import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import type * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: import("../date").GraphqlDate; output: import("../date").GraphqlDate; }
  DateTime: { input: import("../date").GraphqlDateTime; output: import("../date").GraphqlDateTime; }
  Duration: { input: import("../date").GraphqlDuration; output: import("../date").GraphqlDuration; }
  Email: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Time: { input: import("../date").GraphqlTime; output: import("../date").GraphqlTime; }
  UUID: { input: string; output: string; }
  ZonedDateTime: { input: any; output: any; }
};

export type Activity = {
  actor: RevisionAuthor;
  createdDate: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
};

export type ActivityIndicator = {
  __typename?: 'ActivityIndicator';
  pendingModerationCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export const ActivityModerationFilter = {
  DELETED: 'DELETED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED'
} as const;

export type ActivityModerationFilter = typeof ActivityModerationFilter[keyof typeof ActivityModerationFilter];
export type ActivityPage = {
  __typename?: 'ActivityPage';
  content: Array<Activity>;
  oldestCursor?: Maybe<Scalars['String']['output']>;
};

export type ActivityReadState = {
  __typename?: 'ActivityReadState';
  lastReadAt: Scalars['ZonedDateTime']['output'];
  scope: ActivityScope | '%future added value';
};

export const ActivityScope = {
  COMMUNITY: 'COMMUNITY'
} as const;

export type ActivityScope = typeof ActivityScope[keyof typeof ActivityScope];
export type ActivityStreamFilter = {
  moderationStatuses?: InputMaybe<Array<ActivityModerationFilter | '%future added value'>>;
  types?: InputMaybe<Array<ActivityTypeFilter | '%future added value'>>;
};

export const ActivityTypeFilter = {
  COMMENT: 'COMMENT',
  REACTION: 'REACTION',
  REVIEW_COMMENTS: 'REVIEW_COMMENTS'
} as const;

export type ActivityTypeFilter = typeof ActivityTypeFilter[keyof typeof ActivityTypeFilter];
export type AdminSearchGroupInput = {
  key: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  types: Array<SearchType | '%future added value'>;
};

export type AdminSearchGroupResult = {
  __typename?: 'AdminSearchGroupResult';
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  results: Array<AdminSearchResult>;
  size: Scalars['Int']['output'];
  totalHits: Scalars['Int']['output'];
};

export type AdminSearchResponse = {
  __typename?: 'AdminSearchResponse';
  groups: Array<AdminSearchGroupResult>;
  query: Scalars['String']['output'];
};

export type AdminSearchResult = {
  __typename?: 'AdminSearchResult';
  details?: Maybe<AdminSearchResultDetails>;
  headline: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Media>;
  slug: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type: SearchType | '%future added value';
};

export type AdminSearchResultDetails = ArticleSearchDetails | ArticleSeriesSearchDetails | AuthorSearchDetails | CompanySearchDetails | EventSearchDetails | GameConsoleSearchDetails | GameSearchDetails | GameSeriesSearchDetails | MediaSearchDetails | TagSearchDetails | { __typename?: "%other" };

export type AiProvider = {
  __typename?: 'AiProvider';
  available: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  model: Scalars['String']['output'];
};

export const AiUsageLevel = {
  NONE: 'NONE',
  PRIMARILY_AI: 'PRIMARILY_AI',
  SUPPORT_REVIEW: 'SUPPORT_REVIEW'
} as const;

export type AiUsageLevel = typeof AiUsageLevel[keyof typeof AiUsageLevel];
export type AnalysisProviderInfo = {
  __typename?: 'AnalysisProviderInfo';
  model: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export const AnalysisSentiment = {
  DISAPPOINTED: 'DISAPPOINTED',
  EUPHORIC: 'EUPHORIC',
  NEUTRAL: 'NEUTRAL',
  OPTIMISTIC: 'OPTIMISTIC',
  PESSIMISTIC: 'PESSIMISTIC'
} as const;

export type AnalysisSentiment = typeof AnalysisSentiment[keyof typeof AnalysisSentiment];
export const AnalysisStatus = {
  CLOSED: 'CLOSED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  RUNNING: 'RUNNING'
} as const;

export type AnalysisStatus = typeof AnalysisStatus[keyof typeof AnalysisStatus];
export type ArrayChange = BaseChange & {
  __typename?: 'ArrayChange';
  affectedGlobalId?: Maybe<Scalars['String']['output']>;
  author?: Maybe<RevisionAuthor>;
  changeType: PropertyChangeType | '%future added value';
  commitDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  left?: Maybe<Scalars['JSON']['output']>;
  propertyName: Scalars['String']['output'];
  right?: Maybe<Scalars['JSON']['output']>;
};

export type Article = {
  __typename?: 'Article';
  accessibilityNote: Scalars['JSON']['output'];
  aiUsageLevel: AiUsageLevel | '%future added value';
  articleSeries?: Maybe<ArticleSeries>;
  authors: Array<Author>;
  carouselPlacement: CarouselPlacement | '%future added value';
  commentCount: Scalars['Int']['output'];
  companies: Array<Company>;
  conclusion: Scalars['JSON']['output'];
  cons: Array<Scalars['String']['output']>;
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  editorsTake: Scalars['JSON']['output'];
  entityVersion: Scalars['Int']['output'];
  event?: Maybe<Event>;
  gameConsoles: Array<GameConsole>;
  gameSeries: Array<GameSeries>;
  games: Array<Game>;
  highlyAccessible: Scalars['Boolean']['output'];
  kind: ArticleKind | '%future added value';
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  manualTotalScore?: Maybe<Scalars['Boolean']['output']>;
  medias: Array<ArticleMedia>;
  openReviewCommentCount: Scalars['Int']['output'];
  pageViews?: Maybe<ArticlePageViews>;
  previewLinks: Array<ArticlePreviewLink>;
  pros: Array<Scalars['String']['output']>;
  publicationDateTime?: Maybe<Scalars['ZonedDateTime']['output']>;
  publishedState: PublishedState | '%future added value';
  rating: Array<ArticleRating>;
  reactionCounts: Array<ReactionCount>;
  reviewComments: Array<ReviewComment>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  specialThanks: Scalars['JSON']['output'];
  subReviewScoreMax?: Maybe<Scalars['Float']['output']>;
  subReviewScoreMin?: Maybe<Scalars['Float']['output']>;
  subReviews: Array<SubReview>;
  subject: Scalars['String']['output'];
  tags: Array<Tag>;
  teaserMedia?: Maybe<Media>;
  teaserText: Scalars['JSON']['output'];
  text: Scalars['JSON']['output'];
  totalReactions: Scalars['Int']['output'];
  totalScore?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
  viewerCanDelete: Scalars['Boolean']['output'];
  viewerCanEdit: Scalars['Boolean']['output'];
  viewerCanPublish: Scalars['Boolean']['output'];
  viewerEditLockedByPublication: Scalars['Boolean']['output'];
  webPushStatus: ArticleWebPushStatus;
};

export type ArticleAnalysis = {
  __typename?: 'ArticleAnalysis';
  articleId: Scalars['UUID']['output'];
  articleKindSuggestion?: Maybe<ClassificationSuggestion>;
  articleSubject: Scalars['String']['output'];
  closedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  companySuggestions: Array<EntitySuggestion>;
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  gameConsoleSuggestions: Array<EntitySuggestion>;
  gameDetailsSuggestion?: Maybe<GameDetailsSuggestion>;
  gameSeriesSuggestions: Array<EntitySuggestion>;
  gameSuggestions: Array<EntitySuggestion>;
  id: Scalars['UUID']['output'];
  providerInfo?: Maybe<AnalysisProviderInfo>;
  sentiment: AnalysisSentiment | '%future added value';
  startedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  status: AnalysisStatus | '%future added value';
  tagSuggestions: Array<TagSuggestion>;
  textSuggestions: Array<TextSuggestion>;
};

export type ArticleComment = {
  __typename?: 'ArticleComment';
  aiAssessment?: Maybe<CommentAiAssessment>;
  approvedBy?: Maybe<RevisionAuthor>;
  articleId: Scalars['UUID']['output'];
  author: RevisionAuthor;
  content: Scalars['JSON']['output'];
  createdDate: Scalars['ZonedDateTime']['output'];
  editedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  hasPendingEdit: Scalars['Boolean']['output'];
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  moderationStatus: CommentModerationStatus | '%future added value';
  parentCommentId?: Maybe<Scalars['UUID']['output']>;
  reactionCounts: Array<ReactionCount>;
  rejectedBy?: Maybe<RevisionAuthor>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  totalReactions: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
};

export type ArticleCommentPageResults = {
  __typename?: 'ArticleCommentPageResults';
  content: Array<ArticleComment>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ArticleCreateInput = {
  accessibilityNote?: InputMaybe<Scalars['JSON']['input']>;
  aiUsageLevel: AiUsageLevel | '%future added value';
  articleSeries?: InputMaybe<Scalars['UUID']['input']>;
  authors: Array<Scalars['UUID']['input']>;
  carouselPlacement: CarouselPlacement | '%future added value';
  companies?: InputMaybe<Array<Scalars['UUID']['input']>>;
  conclusion: Scalars['JSON']['input'];
  cons: Array<Scalars['String']['input']>;
  editorsTake?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['UUID']['input']>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameSeries?: InputMaybe<Array<Scalars['UUID']['input']>>;
  games?: InputMaybe<Array<Scalars['UUID']['input']>>;
  highlyAccessible: Scalars['Boolean']['input'];
  kind: ArticleKind | '%future added value';
  manualTotalScore?: InputMaybe<Scalars['Boolean']['input']>;
  medias?: InputMaybe<Array<ArticleMediaRefInput>>;
  pros: Array<Scalars['String']['input']>;
  publicationDateTime?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  publishedState: PublishedState | '%future added value';
  rating: Array<ArticleRatingInput>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  specialThanks: Scalars['JSON']['input'];
  subReviews?: InputMaybe<Array<SubReviewInput>>;
  subject: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teaserMedia?: InputMaybe<Scalars['UUID']['input']>;
  teaserText: Scalars['JSON']['input'];
  text: Scalars['JSON']['input'];
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type ArticleExampleInput = {
  articleSeries?: InputMaybe<Array<Scalars['UUID']['input']>>;
  authors?: InputMaybe<Array<Scalars['UUID']['input']>>;
  carouselPlacement?: InputMaybe<Array<CarouselPlacement | '%future added value'>>;
  companies?: InputMaybe<Array<Scalars['UUID']['input']>>;
  event?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameSeries?: InputMaybe<Array<Scalars['UUID']['input']>>;
  games?: InputMaybe<Array<Scalars['UUID']['input']>>;
  kind?: InputMaybe<ArticleKind | '%future added value'>;
  /**
   * Relationen, die am Artikel nicht zugewiesen sein dürfen. Additiv: ist für dieselbe Relation
   * zusätzlich eine Auswahl gesetzt (z.B. `games`), wird verodert — "Spiel X ODER gar kein Spiel".
   * Mehrere Relationen werden untereinander verundet.
   */
  missing?: InputMaybe<Array<ArticleRelation | '%future added value'>>;
  /**
   * Relationen, die am Artikel gesetzt sein müssen — das Gegenstück zu `missing`. Additiv wie
   * dieses: mit einer Auswahl derselben Relation wird verodert, mehrere Relationen werden
   * verundet. `missing` und `present` für dieselbe Relation ergeben zusammen eine Tautologie
   * ("beide Sorten") und schränken damit nicht ein.
   */
  present?: InputMaybe<Array<ArticleRelation | '%future added value'>>;
  publicationDateTime?: InputMaybe<DateTimeQuery>;
  publishedState?: InputMaybe<Array<PublishedState | '%future added value'>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type ArticleFilterPreset = {
  __typename?: 'ArticleFilterPreset';
  after?: Maybe<Scalars['ZonedDateTime']['output']>;
  articleSeries: Array<ArticleSeries>;
  author: Array<Author>;
  before?: Maybe<Scalars['ZonedDateTime']['output']>;
  company: Array<Company>;
  event: Array<Event>;
  excludeKind: Array<ArticleKind | '%future added value'>;
  game: Array<Game>;
  gameConsole: Array<GameConsole>;
  gameSeries: Array<GameSeries>;
  genre: Array<Genre>;
  kind: Array<ArticleKind | '%future added value'>;
  order?: Maybe<Array<Scalars['String']['output']>>;
  tag: Array<Tag>;
};

export type ArticleFilterPresetInput = {
  after?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  articleSeries?: Array<Scalars['String']['input']>;
  author?: Array<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  company?: Array<Scalars['String']['input']>;
  event?: Array<Scalars['String']['input']>;
  excludeKind?: Array<ArticleKind | '%future added value'>;
  game?: Array<Scalars['String']['input']>;
  gameConsole?: Array<Scalars['String']['input']>;
  gameSeries?: Array<Scalars['String']['input']>;
  genre?: Array<Scalars['String']['input']>;
  kind?: Array<ArticleKind | '%future added value'>;
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  tag?: Array<Scalars['UUID']['input']>;
};

export const ArticleKind = {
  COMMUNITY: 'COMMUNITY',
  EVENT: 'EVENT',
  KOLUMNE: 'KOLUMNE',
  NEWS: 'NEWS',
  PODCAST: 'PODCAST',
  TEST: 'TEST'
} as const;

export type ArticleKind = typeof ArticleKind[keyof typeof ArticleKind];
export type ArticleLegacyExport = {
  __typename?: 'ArticleLegacyExport';
  conclusionHtml: Scalars['String']['output'];
  cons: Array<Scalars['String']['output']>;
  gameTitle: Scalars['String']['output'];
  images: Array<LegacyExportImage>;
  pros: Array<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  teaserHtml: Scalars['String']['output'];
  textHtml: Scalars['String']['output'];
};

export const ArticleListPage = {
  AKTUELLES: 'AKTUELLES',
  ARCHIV: 'ARCHIV',
  EVENTS: 'EVENTS',
  NEWS: 'NEWS',
  PODCASTS: 'PODCASTS',
  TESTS: 'TESTS'
} as const;

export type ArticleListPage = typeof ArticleListPage[keyof typeof ArticleListPage];
export type ArticleMedia = ExternalMedia | Media | { __typename?: "%other" };

export type ArticleMediaRefInput = {
  url?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type ArticlePageResults = {
  __typename?: 'ArticlePageResults';
  content: Array<Article>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ArticlePageViews = {
  __typename?: 'ArticlePageViews';
  last30Days: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['ZonedDateTime']['output'];
};

/** Geheimer Vorschau-Link eines unveröffentlichten Artikels. */
export type ArticlePreviewLink = {
  __typename?: 'ArticlePreviewLink';
  createdAt: Scalars['ZonedDateTime']['output'];
  createdBy?: Maybe<RevisionAuthor>;
  /** Optionaler Zweck-Bezeichner, z.B. „Review durch Maik”. */
  label?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  /** Fertige Frontend-URL inklusive Token. */
  url: Scalars['String']['output'];
  validUntil: Scalars['ZonedDateTime']['output'];
};

export type ArticleRating = {
  __typename?: 'ArticleRating';
  category: RatingCategory;
  /** null = attached but not yet scored (N.A.) */
  score?: Maybe<Scalars['Float']['output']>;
};

export type ArticleRatingCategoryInput = {
  articleSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  step: Scalars['Float']['input'];
  uuid: Scalars['UUID']['input'];
};

export type ArticleRatingInput = {
  category: ArticleRatingCategoryInput;
  /** null = attached but not yet scored (N.A.) */
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type ArticleReceipt = {
  __typename?: 'ArticleReceipt';
  body: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

/**
 * Relationen eines Artikels, die per `ArticleExampleInput.missing` auf "nicht zugewiesen" bzw.
 * per `ArticleExampleInput.present` auf "zugewiesen" geprüft werden können. Geprüft wird stets
 * das direkte Feld, nie eine transitive Ableitung — anders als bei einem Filter auf eine
 * konkrete Entität (z.B. `games`), der für `GAME_SERIES`, `GAME_CONSOLES` und `COMPANIES` sowohl
 * das direkte als auch das transitive Feld matcht. Bewusst so: Konsolen-Wertungen
 * (`GameElasticsearchDocumentAssembler.consoleScoresFor`) und Web-Push-Abos
 * (`WebPushService.isEligible`) hängen an der direkten Zuordnung.
 */
export const ArticleRelation = {
  ARTICLE_SERIES: 'ARTICLE_SERIES',
  AUTHORS: 'AUTHORS',
  COMPANIES: 'COMPANIES',
  EVENT: 'EVENT',
  GAMES: 'GAMES',
  GAME_CONSOLES: 'GAME_CONSOLES',
  GAME_SERIES: 'GAME_SERIES',
  TAGS: 'TAGS'
} as const;

export type ArticleRelation = typeof ArticleRelation[keyof typeof ArticleRelation];
export const ArticleScope = {
  ALL: 'ALL',
  OWN: 'OWN'
} as const;

export type ArticleScope = typeof ArticleScope[keyof typeof ArticleScope];
export type ArticleSearchDetails = {
  __typename?: 'ArticleSearchDetails';
  kind: ArticleKind | '%future added value';
  publicationDateTime?: Maybe<Scalars['ZonedDateTime']['output']>;
  publishedState?: Maybe<Scalars['String']['output']>;
};

export type ArticleSeries = {
  __typename?: 'ArticleSeries';
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  description: Scalars['JSON']['output'];
  entityVersion: Scalars['Int']['output'];
  event?: Maybe<Event>;
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  name: Scalars['String']['output'];
  showInSlider: Scalars['Boolean']['output'];
  showUntil?: Maybe<Scalars['Date']['output']>;
  slug: Scalars['String']['output'];
  teaserImage?: Maybe<Media>;
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
};

export type ArticleSeriesCreateInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  showInSlider?: InputMaybe<Scalars['Boolean']['input']>;
  showUntil?: InputMaybe<Scalars['Date']['input']>;
  teaserImage?: InputMaybe<Scalars['UUID']['input']>;
};

export type ArticleSeriesPageResults = {
  __typename?: 'ArticleSeriesPageResults';
  content: Array<ArticleSeries>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ArticleSeriesSearchDetails = {
  __typename?: 'ArticleSeriesSearchDetails';
  showInSlider: Scalars['Boolean']['output'];
};

export type ArticleSeriesUpdateInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  showInSlider?: InputMaybe<Scalars['Boolean']['input']>;
  showUntil?: InputMaybe<Scalars['Date']['input']>;
  teaserImage?: InputMaybe<Scalars['UUID']['input']>;
};

export type ArticleStatistics = {
  __typename?: 'ArticleStatistics';
  avgLeadTimeHours?: Maybe<Scalars['Float']['output']>;
  byEditor: Array<StatisticsEditorCount>;
  byKind: Array<StatisticsKindCount>;
  comparison: StatisticsComparison;
  pipeline: StatisticsPipeline;
  timeSeries: Array<StatisticsTimeBucket>;
  topGames: Array<StatisticsTopic>;
  topGenres: Array<StatisticsTopic>;
  topTags: Array<StatisticsTopic>;
};

export type ArticleStatisticsFilter = {
  dateBasis: StatisticsDateBasis | '%future added value';
  editorGrouping: StatisticsEditorGrouping | '%future added value';
  from: Scalars['ZonedDateTime']['input'];
  granularity: StatisticsGranularity | '%future added value';
  publishedStates?: InputMaybe<Array<PublishedState | '%future added value'>>;
  until: Scalars['ZonedDateTime']['input'];
};

export type ArticleStats = {
  __typename?: 'ArticleStats';
  communityCount?: Maybe<Scalars['Int']['output']>;
  eventCount?: Maybe<Scalars['Int']['output']>;
  kolumneCount?: Maybe<Scalars['Int']['output']>;
  newsCount?: Maybe<Scalars['Int']['output']>;
  podcastCount?: Maybe<Scalars['Int']['output']>;
  testCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ArticleUpdateInput = {
  accessibilityNote?: InputMaybe<Scalars['JSON']['input']>;
  aiUsageLevel?: InputMaybe<AiUsageLevel | '%future added value'>;
  articleSeries?: InputMaybe<Scalars['UUID']['input']>;
  authors?: InputMaybe<Array<Scalars['UUID']['input']>>;
  carouselPlacement?: InputMaybe<CarouselPlacement | '%future added value'>;
  companies?: InputMaybe<Array<Scalars['UUID']['input']>>;
  conclusion?: InputMaybe<Scalars['JSON']['input']>;
  cons?: InputMaybe<Array<Scalars['String']['input']>>;
  editorsTake?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['UUID']['input']>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameSeries?: InputMaybe<Array<Scalars['UUID']['input']>>;
  games?: InputMaybe<Array<Scalars['UUID']['input']>>;
  highlyAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<ArticleKind | '%future added value'>;
  manualTotalScore?: InputMaybe<Scalars['Boolean']['input']>;
  medias?: InputMaybe<Array<ArticleMediaRefInput>>;
  pros?: InputMaybe<Array<Scalars['String']['input']>>;
  publicationDateTime?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  publishedState?: InputMaybe<PublishedState | '%future added value'>;
  rating?: InputMaybe<Array<ArticleRatingInput>>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  specialThanks?: InputMaybe<Scalars['JSON']['input']>;
  subReviews?: InputMaybe<Array<SubReviewInput>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teaserMedia?: InputMaybe<Scalars['UUID']['input']>;
  teaserText?: InputMaybe<Scalars['JSON']['input']>;
  text?: InputMaybe<Scalars['JSON']['input']>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type ArticleWebPushStatus = {
  __typename?: 'ArticleWebPushStatus';
  attempts?: Maybe<Scalars['Int']['output']>;
  errorCount?: Maybe<Scalars['Int']['output']>;
  finishedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  sendAfter?: Maybe<Scalars['ZonedDateTime']['output']>;
  sentAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  sentCount?: Maybe<Scalars['Int']['output']>;
  state: WebPushSendState | '%future added value';
  subscriptionsTotal?: Maybe<Scalars['Int']['output']>;
};

export type Author = {
  __typename?: 'Author';
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  email?: Maybe<Scalars['Email']['output']>;
  entityVersion: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isProfilePublic: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  linkedUsers: Array<LinkedUser>;
  name: Scalars['String']['output'];
  profile?: Maybe<Scalars['String']['output']>;
  slogan?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
};

export type AuthorCreateInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isProfilePublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  slogan?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorExampleInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  hasLinkedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isProfilePublic?: InputMaybe<Scalars['Boolean']['input']>;
  linkedUserSubs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorMergeInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isProfilePublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  slogan?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorPageResults = {
  __typename?: 'AuthorPageResults';
  content: Array<Author>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AuthorSearchDetails = {
  __typename?: 'AuthorSearchDetails';
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isProfilePublic?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AuthorUpdateInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isProfilePublic?: InputMaybe<Scalars['Boolean']['input']>;
  linkedUsers?: InputMaybe<Array<AuthorUserLinkInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  slogan?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorUserLinkInput = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  sub: Scalars['ID']['input'];
};

export type BaseChange = {
  affectedGlobalId?: Maybe<Scalars['String']['output']>;
  author?: Maybe<RevisionAuthor>;
  commitDate?: Maybe<Scalars['ZonedDateTime']['output']>;
};

/** Kontrolliert die Darstellung eines Artikels im Startseiten-Carousel. */
export const CarouselPlacement = {
  EXCLUDED: 'EXCLUDED',
  PRIORITIZED: 'PRIORITIZED',
  STANDARD: 'STANDARD'
} as const;

export type CarouselPlacement = typeof CarouselPlacement[keyof typeof CarouselPlacement];
export type Change = ArrayChange | ListChange | MapChange | NewObjectChange | ObjectRemovedChange | SetChange | ValueChange | { __typename?: "%other" };

export type ChangesByCommit = {
  __typename?: 'ChangesByCommit';
  changes: Array<Change>;
  commit: CommitMetadata;
  summary: Scalars['String']['output'];
};

export type ChangesByCommitPage = {
  __typename?: 'ChangesByCommitPage';
  content: Array<ChangesByCommit>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ClassificationSuggestion = {
  __typename?: 'ClassificationSuggestion';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  confidence: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  value: ArticleKind | '%future added value';
};

export type ClassificationSuggestionInt = {
  __typename?: 'ClassificationSuggestionInt';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  confidence: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  value: Scalars['Int']['output'];
};

export type ClassificationSuggestionString = {
  __typename?: 'ClassificationSuggestionString';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  confidence: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  value: Scalars['String']['output'];
};

export type CommentActivity = Activity & {
  __typename?: 'CommentActivity';
  actor: RevisionAuthor;
  articleId: Scalars['UUID']['output'];
  articleSlug: Scalars['String']['output'];
  articleSubject: Scalars['String']['output'];
  comment: ArticleComment;
  createdDate: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
};

export type CommentAiAssessment = {
  __typename?: 'CommentAiAssessment';
  approved: Scalars['Boolean']['output'];
  assessedAt: Scalars['ZonedDateTime']['output'];
  attemptCount: Scalars['Int']['output'];
  confidence: Scalars['Float']['output'];
  model?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  reasoning: Scalars['String']['output'];
};

export const CommentModerationStatus = {
  AUTO_APPROVED: 'AUTO_APPROVED',
  DELETED: 'DELETED',
  MANUALLY_APPROVED: 'MANUALLY_APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED'
} as const;

export type CommentModerationStatus = typeof CommentModerationStatus[keyof typeof CommentModerationStatus];
export type Commit = {
  __typename?: 'Commit';
  author?: Maybe<RevisionAuthor>;
  changes: Array<Change>;
  commitDate: Scalars['ZonedDateTime']['output'];
  id: Scalars['String']['output'];
};

export type CommitMetadata = {
  __typename?: 'CommitMetadata';
  author?: Maybe<RevisionAuthor>;
  commitDate: Scalars['ZonedDateTime']['output'];
  id: Scalars['String']['output'];
  properties: Scalars['JSON']['output'];
  source?: Maybe<Scalars['String']['output']>;
};

export type Company = {
  __typename?: 'Company';
  acronym?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entityVersion: Scalars['Int']['output'];
  foundingYear?: Maybe<Scalars['Int']['output']>;
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  logo?: Maybe<Media>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
  wikipediaUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyCreateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foundingYear?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  wikipediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyExampleInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyMergeInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foundingYear?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  wikipediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyPageResults = {
  __typename?: 'CompanyPageResults';
  content: Array<Company>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CompanySearchDetails = {
  __typename?: 'CompanySearchDetails';
  acronym?: Maybe<Scalars['String']['output']>;
};

export type CompanyUpdateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foundingYear?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  wikipediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ConsoleEdition = {
  __typename?: 'ConsoleEdition';
  amazonUrl?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Media>;
  developer?: Maybe<Company>;
  esrb?: Maybe<EsrbRating | '%future added value'>;
  gameConsole: GameConsole;
  images: Array<Media>;
  overrideDeveloper: Scalars['Boolean']['output'];
  overridePublisher: Scalars['Boolean']['output'];
  overrideRatings: Scalars['Boolean']['output'];
  packaging: Array<Packaging | '%future added value'>;
  packagingEurope: Array<Packaging | '%future added value'>;
  packagingGermany: Array<Packaging | '%future added value'>;
  packagingJapan: Array<Packaging | '%future added value'>;
  packagingUnitedStates: Array<Packaging | '%future added value'>;
  pegi?: Maybe<Scalars['Int']['output']>;
  publisher?: Maybe<Company>;
  releaseDate?: Maybe<Scalars['Date']['output']>;
  releaseDateEurope?: Maybe<Scalars['Date']['output']>;
  releaseDateGermany?: Maybe<Scalars['Date']['output']>;
  releaseDateJapan?: Maybe<Scalars['Date']['output']>;
  releaseDateUnitedStates?: Maybe<Scalars['Date']['output']>;
  usk?: Maybe<Scalars['Int']['output']>;
};

export type ConsoleEditionInput = {
  amazonUrl?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['UUID']['input']>;
  developer?: InputMaybe<Scalars['UUID']['input']>;
  esrb?: InputMaybe<EsrbRating | '%future added value'>;
  gameConsole: Scalars['UUID']['input'];
  images?: InputMaybe<Array<Scalars['UUID']['input']>>;
  overrideDeveloper?: InputMaybe<Scalars['Boolean']['input']>;
  overridePublisher?: InputMaybe<Scalars['Boolean']['input']>;
  overrideRatings?: InputMaybe<Scalars['Boolean']['input']>;
  packaging?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingEurope?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingGermany?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingJapan?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingUnitedStates?: InputMaybe<Array<Packaging | '%future added value'>>;
  pegi?: InputMaybe<Scalars['Int']['input']>;
  publisher?: InputMaybe<Scalars['UUID']['input']>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  releaseDateEurope?: InputMaybe<Scalars['Date']['input']>;
  releaseDateGermany?: InputMaybe<Scalars['Date']['input']>;
  releaseDateJapan?: InputMaybe<Scalars['Date']['input']>;
  releaseDateUnitedStates?: InputMaybe<Scalars['Date']['input']>;
  usk?: InputMaybe<Scalars['Int']['input']>;
};

export type DateTimeQuery = {
  after?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  before?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  includeNull?: InputMaybe<Scalars['Boolean']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type DuplicateCandidate = {
  __typename?: 'DuplicateCandidate';
  entityId: Scalars['UUID']['output'];
  reason: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

/** Eine offene Bearbeitung einer Entität in einem CMS-Tab („wird gerade bearbeitet von“). */
export type EditSession = {
  __typename?: 'EditSession';
  /** Tab meldet ungespeicherte Änderungen. */
  dirty: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  /** True, wenn die Sitzung dem aufrufenden Nutzer gehört (anderer Tab). */
  own: Scalars['Boolean']['output'];
  sessionId: Scalars['ID']['output'];
  startedAt: Scalars['ZonedDateTime']['output'];
  userSub: Scalars['String']['output'];
};

/** Entitätsarten mit Bearbeitungshinweis im CMS. */
export const EditSessionEntityType = {
  ARTICLE: 'ARTICLE',
  ARTICLE_SERIES: 'ARTICLE_SERIES',
  AUTHOR: 'AUTHOR',
  COMPANY: 'COMPANY',
  EVENT: 'EVENT',
  GAME: 'GAME',
  GAME_CONSOLE: 'GAME_CONSOLE',
  GAME_SERIES: 'GAME_SERIES',
  GENRE: 'GENRE',
  MEDIA: 'MEDIA',
  QUICK_FILTER: 'QUICK_FILTER',
  RATING_CATEGORY: 'RATING_CATEGORY',
  TAG: 'TAG'
} as const;

export type EditSessionEntityType = typeof EditSessionEntityType[keyof typeof EditSessionEntityType];
export type EntitySuggestion = {
  __typename?: 'EntitySuggestion';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  confidence: Scalars['Float']['output'];
  entityId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  isNew: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export const EsrbRating = {
  ADULTS_ONLY: 'ADULTS_ONLY',
  EVERYONE: 'EVERYONE',
  EVERYONE_TEN_PLUS: 'EVERYONE_TEN_PLUS',
  MATURE_PLUS: 'MATURE_PLUS',
  RATING_PENDING: 'RATING_PENDING',
  RATING_PENDING_LIKELY_MATURE_PLUS: 'RATING_PENDING_LIKELY_MATURE_PLUS',
  TEEN: 'TEEN'
} as const;

export type EsrbRating = typeof EsrbRating[keyof typeof EsrbRating];
export type Event = {
  __typename?: 'Event';
  allDay: Scalars['Boolean']['output'];
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  description?: Maybe<Scalars['JSON']['output']>;
  endsAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  entityVersion: Scalars['Int']['output'];
  kind: EventKind | '%future added value';
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  name: Scalars['String']['output'];
  onlineUrl?: Maybe<Scalars['String']['output']>;
  openingHours: Array<EventOpeningHours>;
  showOnHomepage: Scalars['Boolean']['output'];
  showUntil?: Maybe<Scalars['Date']['output']>;
  slug: Scalars['String']['output'];
  startsAt: Scalars['ZonedDateTime']['output'];
  teaserImage?: Maybe<Media>;
  timeZone: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
  venue?: Maybe<EventVenue>;
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type EventCreateInput = {
  allDay: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['JSON']['input']>;
  endsAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  kind: EventKind | '%future added value';
  name: Scalars['String']['input'];
  onlineUrl?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<Array<EventOpeningHoursInput>>;
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  showUntil?: InputMaybe<Scalars['Date']['input']>;
  startsAt: Scalars['ZonedDateTime']['input'];
  teaserImage?: InputMaybe<Scalars['UUID']['input']>;
  timeZone: Scalars['String']['input'];
  venue?: InputMaybe<EventVenueInput>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export const EventKind = {
  COMMUNITY: 'COMMUNITY',
  EXPO: 'EXPO',
  FAIR: 'FAIR',
  ONLINE: 'ONLINE',
  OTHER: 'OTHER'
} as const;

export type EventKind = typeof EventKind[keyof typeof EventKind];
export type EventOpeningHours = {
  __typename?: 'EventOpeningHours';
  closes: Scalars['Time']['output'];
  date: Scalars['Date']['output'];
  note?: Maybe<Scalars['String']['output']>;
  opens: Scalars['Time']['output'];
};

export type EventOpeningHoursInput = {
  closes: Scalars['Time']['input'];
  date: Scalars['Date']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  opens: Scalars['Time']['input'];
};

export type EventPageResults = {
  __typename?: 'EventPageResults';
  content: Array<Event>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type EventSearchDetails = {
  __typename?: 'EventSearchDetails';
  endsAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  kind: EventKind | '%future added value';
  startsAt?: Maybe<Scalars['ZonedDateTime']['output']>;
};

export type EventUpdateInput = {
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  endsAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  kind?: InputMaybe<EventKind | '%future added value'>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlineUrl?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<Array<EventOpeningHoursInput>>;
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  showUntil?: InputMaybe<Scalars['Date']['input']>;
  startsAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  teaserImage?: InputMaybe<Scalars['UUID']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  venue?: InputMaybe<EventVenueInput>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EventVenue = {
  __typename?: 'EventVenue';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type EventVenueInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalMedia = {
  __typename?: 'ExternalMedia';
  url: Scalars['String']['output'];
};

export type Game = {
  __typename?: 'Game';
  acronym?: Maybe<Scalars['String']['output']>;
  additionalInformations?: Maybe<Scalars['String']['output']>;
  alternativeName?: Maybe<Scalars['String']['output']>;
  amazonUrl?: Maybe<Scalars['String']['output']>;
  consoleEditions: Array<ConsoleEdition>;
  cover?: Maybe<Media>;
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  developer?: Maybe<Company>;
  entityVersion: Scalars['Int']['output'];
  esrb?: Maybe<EsrbRating | '%future added value'>;
  gameConsoles: Array<GameConsole>;
  gameModes: Array<GameMode | '%future added value'>;
  gameSeries?: Maybe<GameSeries>;
  genres: Array<Genre>;
  images: Array<Media>;
  /** Berechnete Gegenrichtung: Spiele, die dieses Spiel referenzieren. */
  inverseRelatedGames: Array<GameRelation>;
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  localPlayerCount?: Maybe<PlayerCount>;
  name: Scalars['String']['output'];
  onlinePlayerCount?: Maybe<PlayerCount>;
  packaging: Array<Packaging | '%future added value'>;
  packagingEurope: Array<Packaging | '%future added value'>;
  packagingGermany: Array<Packaging | '%future added value'>;
  packagingJapan: Array<Packaging | '%future added value'>;
  packagingUnitedStates: Array<Packaging | '%future added value'>;
  pegi?: Maybe<Scalars['Int']['output']>;
  publisher?: Maybe<Company>;
  /** Gepflegte (ausgehende) Verknüpfungen: dieses Spiel ist <Art> von <game>. */
  relatedGames: Array<GameRelation>;
  releaseDate?: Maybe<Scalars['Date']['output']>;
  releaseDateEurope?: Maybe<Scalars['Date']['output']>;
  releaseDateGermany?: Maybe<Scalars['Date']['output']>;
  releaseDateJapan?: Maybe<Scalars['Date']['output']>;
  releaseDateUnitedStates?: Maybe<Scalars['Date']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  usk?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
};

export type GameConsole = {
  __typename?: 'GameConsole';
  acronym?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  entityVersion: Scalars['Int']['output'];
  eolDate?: Maybe<Scalars['Date']['output']>;
  eolDateEurope?: Maybe<Scalars['Date']['output']>;
  eolDateGermany?: Maybe<Scalars['Date']['output']>;
  eolDateJapan?: Maybe<Scalars['Date']['output']>;
  eolDateUnitedStates?: Maybe<Scalars['Date']['output']>;
  isEOL: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  logo?: Maybe<Media>;
  name: Scalars['String']['output'];
  releaseDate?: Maybe<Scalars['Date']['output']>;
  releaseDateEurope?: Maybe<Scalars['Date']['output']>;
  releaseDateGermany?: Maybe<Scalars['Date']['output']>;
  releaseDateJapan?: Maybe<Scalars['Date']['output']>;
  releaseDateUnitedStates?: Maybe<Scalars['Date']['output']>;
  showInDatabaseView: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  type: GameConsoleType | '%future added value';
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
  wikipediaUrl?: Maybe<Scalars['String']['output']>;
};

export type GameConsoleCreateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  eolDate?: InputMaybe<Scalars['Date']['input']>;
  eolDateEurope?: InputMaybe<Scalars['Date']['input']>;
  eolDateGermany?: InputMaybe<Scalars['Date']['input']>;
  eolDateJapan?: InputMaybe<Scalars['Date']['input']>;
  eolDateUnitedStates?: InputMaybe<Scalars['Date']['input']>;
  isEOL?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  releaseDateEurope?: InputMaybe<Scalars['Date']['input']>;
  releaseDateGermany?: InputMaybe<Scalars['Date']['input']>;
  releaseDateJapan?: InputMaybe<Scalars['Date']['input']>;
  releaseDateUnitedStates?: InputMaybe<Scalars['Date']['input']>;
  showInDatabaseView?: InputMaybe<Scalars['Boolean']['input']>;
  type: GameConsoleType | '%future added value';
  wikipediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GameConsoleExampleInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  eolDateAfter?: InputMaybe<Scalars['Date']['input']>;
  eolDateBefore?: InputMaybe<Scalars['Date']['input']>;
  eolDateEuropeAfter?: InputMaybe<Scalars['Date']['input']>;
  eolDateEuropeBefore?: InputMaybe<Scalars['Date']['input']>;
  eolDateGermanyAfter?: InputMaybe<Scalars['Date']['input']>;
  eolDateGermanyBefore?: InputMaybe<Scalars['Date']['input']>;
  eolDateJapanAfter?: InputMaybe<Scalars['Date']['input']>;
  eolDateJapanBefore?: InputMaybe<Scalars['Date']['input']>;
  eolDateUnitedStatesAfter?: InputMaybe<Scalars['Date']['input']>;
  eolDateUnitedStatesBefore?: InputMaybe<Scalars['Date']['input']>;
  eolYear?: InputMaybe<Scalars['Int']['input']>;
  eolYearEurope?: InputMaybe<Scalars['Int']['input']>;
  eolYearGermany?: InputMaybe<Scalars['Int']['input']>;
  eolYearJapan?: InputMaybe<Scalars['Int']['input']>;
  eolYearUnitedStates?: InputMaybe<Scalars['Int']['input']>;
  isEOL?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  releaseDateAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseDateEuropeAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateEuropeBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseDateGermanyAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateGermanyBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseDateJapanAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateJapanBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseDateUnitedStatesAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateUnitedStatesBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  releaseYearEurope?: InputMaybe<Scalars['Int']['input']>;
  releaseYearGermany?: InputMaybe<Scalars['Int']['input']>;
  releaseYearJapan?: InputMaybe<Scalars['Int']['input']>;
  releaseYearUnitedStates?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<GameConsoleType | '%future added value'>;
};

export type GameConsolePageResults = {
  __typename?: 'GameConsolePageResults';
  content: Array<GameConsole>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type GameConsoleSearchDetails = {
  __typename?: 'GameConsoleSearchDetails';
  acronym?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['Date']['output']>;
};

export const GameConsoleType = {
  HYBRID: 'HYBRID',
  MOBILE: 'MOBILE',
  STATIONARY: 'STATIONARY',
  UNDEFINED: 'UNDEFINED',
  VIRTUAL: 'VIRTUAL'
} as const;

export type GameConsoleType = typeof GameConsoleType[keyof typeof GameConsoleType];
export type GameConsoleUpdateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  eolDate?: InputMaybe<Scalars['Date']['input']>;
  eolDateEurope?: InputMaybe<Scalars['Date']['input']>;
  eolDateGermany?: InputMaybe<Scalars['Date']['input']>;
  eolDateJapan?: InputMaybe<Scalars['Date']['input']>;
  eolDateUnitedStates?: InputMaybe<Scalars['Date']['input']>;
  isEOL?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  releaseDateEurope?: InputMaybe<Scalars['Date']['input']>;
  releaseDateGermany?: InputMaybe<Scalars['Date']['input']>;
  releaseDateJapan?: InputMaybe<Scalars['Date']['input']>;
  releaseDateUnitedStates?: InputMaybe<Scalars['Date']['input']>;
  showInDatabaseView?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<GameConsoleType | '%future added value'>;
  wikipediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GameCreateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  additionalInformations?: InputMaybe<Scalars['String']['input']>;
  alternativeName?: InputMaybe<Scalars['String']['input']>;
  amazonUrl?: InputMaybe<Scalars['String']['input']>;
  consoleEditions?: InputMaybe<Array<ConsoleEditionInput>>;
  cover?: InputMaybe<Scalars['UUID']['input']>;
  developer?: InputMaybe<Scalars['UUID']['input']>;
  esrb?: InputMaybe<EsrbRating | '%future added value'>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameModes?: InputMaybe<Array<GameMode | '%future added value'>>;
  gameSeries?: InputMaybe<Scalars['UUID']['input']>;
  genres?: InputMaybe<Array<Scalars['UUID']['input']>>;
  images?: InputMaybe<Array<Scalars['UUID']['input']>>;
  localPlayerCount?: InputMaybe<PlayerCountInput>;
  name: Scalars['String']['input'];
  onlinePlayerCount?: InputMaybe<PlayerCountInput>;
  packaging?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingEurope?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingGermany?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingJapan?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingUnitedStates?: InputMaybe<Array<Packaging | '%future added value'>>;
  pegi?: InputMaybe<Scalars['Int']['input']>;
  publisher?: InputMaybe<Scalars['UUID']['input']>;
  relatedGames?: InputMaybe<Array<GameRelationInput>>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  releaseDateEurope?: InputMaybe<Scalars['Date']['input']>;
  releaseDateGermany?: InputMaybe<Scalars['Date']['input']>;
  releaseDateJapan?: InputMaybe<Scalars['Date']['input']>;
  releaseDateUnitedStates?: InputMaybe<Scalars['Date']['input']>;
  usk?: InputMaybe<Scalars['Int']['input']>;
};

export type GameDetailsSuggestion = {
  __typename?: 'GameDetailsSuggestion';
  developer?: Maybe<EntitySuggestion>;
  gameModes: Array<ClassificationSuggestionString>;
  genres: Array<EntitySuggestion>;
  localPlayerCount?: Maybe<PlayerCountSuggestion>;
  onlinePlayerCount?: Maybe<PlayerCountSuggestion>;
  pegi?: Maybe<ClassificationSuggestionInt>;
  publisher?: Maybe<EntitySuggestion>;
  releaseDate?: Maybe<ClassificationSuggestionString>;
  usk?: Maybe<ClassificationSuggestionInt>;
};

export type GameExampleInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  alternativeName?: InputMaybe<Scalars['String']['input']>;
  amazonUrl?: InputMaybe<Scalars['String']['input']>;
  developer?: InputMaybe<Scalars['UUID']['input']>;
  esrb?: InputMaybe<EsrbRating | '%future added value'>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameModes?: InputMaybe<Array<GameMode | '%future added value'>>;
  gameSeries?: InputMaybe<Scalars['UUID']['input']>;
  genre?: InputMaybe<Scalars['UUID']['input']>;
  localPlayerCount?: InputMaybe<PlayerCountInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlinePlayerCount?: InputMaybe<PlayerCountInput>;
  onlyUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  pegi?: InputMaybe<Scalars['Int']['input']>;
  publisher?: InputMaybe<Scalars['UUID']['input']>;
  releaseDateAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseDateEuropeAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateEuropeBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseDateGermanyAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateGermanyBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseDateJapanAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateJapanBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseDateUnitedStatesAfter?: InputMaybe<Scalars['Date']['input']>;
  releaseDateUnitedStatesBefore?: InputMaybe<Scalars['Date']['input']>;
  releaseYear?: InputMaybe<Scalars['Int']['input']>;
  releaseYearEurope?: InputMaybe<Scalars['Int']['input']>;
  releaseYearGermany?: InputMaybe<Scalars['Int']['input']>;
  releaseYearJapan?: InputMaybe<Scalars['Int']['input']>;
  releaseYearUnitedStates?: InputMaybe<Scalars['Int']['input']>;
  usk?: InputMaybe<Scalars['Int']['input']>;
};

export const GameMode = {
  LOCAL_CO_OP: 'LOCAL_CO_OP',
  LOCAL_MULTIPLAYER: 'LOCAL_MULTIPLAYER',
  ONLINE_CO_OP: 'ONLINE_CO_OP',
  ONLINE_MULTIPLAYER: 'ONLINE_MULTIPLAYER',
  SINGLEPLAYER: 'SINGLEPLAYER'
} as const;

export type GameMode = typeof GameMode[keyof typeof GameMode];
export type GamePageResults = {
  __typename?: 'GamePageResults';
  content: Array<Game>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type GameRelation = {
  __typename?: 'GameRelation';
  game: Game;
  type: GameRelationType | '%future added value';
};

export type GameRelationInput = {
  game: Scalars['UUID']['input'];
  type: GameRelationType | '%future added value';
};

export const GameRelationType = {
  EXPANSION: 'EXPANSION',
  EXPANSION_PASS: 'EXPANSION_PASS',
  FREE_DLC: 'FREE_DLC',
  FREE_UPGRADE: 'FREE_UPGRADE',
  PAID_DLC: 'PAID_DLC',
  PAID_UPGRADE: 'PAID_UPGRADE',
  PORT: 'PORT',
  REBOOT: 'REBOOT',
  REMAKE: 'REMAKE',
  REMASTER: 'REMASTER',
  RETAKE: 'RETAKE',
  SEQUEL: 'SEQUEL',
  SPIN_OFF: 'SPIN_OFF',
  SUCCESSOR: 'SUCCESSOR',
  UPGRADE_PACK: 'UPGRADE_PACK'
} as const;

export type GameRelationType = typeof GameRelationType[keyof typeof GameRelationType];
export type GameSearchDetails = {
  __typename?: 'GameSearchDetails';
  acronym?: Maybe<Scalars['String']['output']>;
  esrb?: Maybe<EsrbRating | '%future added value'>;
  pegi?: Maybe<Scalars['Int']['output']>;
  releaseDate?: Maybe<Scalars['Date']['output']>;
  usk?: Maybe<Scalars['Int']['output']>;
};

export type GameSeries = {
  __typename?: 'GameSeries';
  acronym?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  entityVersion: Scalars['Int']['output'];
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  logo?: Maybe<Media>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
};

export type GameSeriesCreateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type GameSeriesPageResults = {
  __typename?: 'GameSeriesPageResults';
  content: Array<GameSeries>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type GameSeriesSearchDetails = {
  __typename?: 'GameSeriesSearchDetails';
  acronym?: Maybe<Scalars['String']['output']>;
};

export type GameSeriesUpdateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GameUpdateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  additionalInformations?: InputMaybe<Scalars['String']['input']>;
  alternativeName?: InputMaybe<Scalars['String']['input']>;
  amazonUrl?: InputMaybe<Scalars['String']['input']>;
  consoleEditions?: InputMaybe<Array<ConsoleEditionInput>>;
  cover?: InputMaybe<Scalars['UUID']['input']>;
  developer?: InputMaybe<Scalars['UUID']['input']>;
  esrb?: InputMaybe<EsrbRating | '%future added value'>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameModes?: InputMaybe<Array<GameMode | '%future added value'>>;
  gameSeries?: InputMaybe<Scalars['UUID']['input']>;
  genres?: InputMaybe<Array<Scalars['UUID']['input']>>;
  images?: InputMaybe<Array<Scalars['UUID']['input']>>;
  localPlayerCount?: InputMaybe<PlayerCountInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlinePlayerCount?: InputMaybe<PlayerCountInput>;
  packaging?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingEurope?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingGermany?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingJapan?: InputMaybe<Array<Packaging | '%future added value'>>;
  packagingUnitedStates?: InputMaybe<Array<Packaging | '%future added value'>>;
  pegi?: InputMaybe<Scalars['Int']['input']>;
  publisher?: InputMaybe<Scalars['UUID']['input']>;
  relatedGames?: InputMaybe<Array<GameRelationInput>>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  releaseDateEurope?: InputMaybe<Scalars['Date']['input']>;
  releaseDateGermany?: InputMaybe<Scalars['Date']['input']>;
  releaseDateJapan?: InputMaybe<Scalars['Date']['input']>;
  releaseDateUnitedStates?: InputMaybe<Scalars['Date']['input']>;
  usk?: InputMaybe<Scalars['Int']['input']>;
};

export type Genre = {
  __typename?: 'Genre';
  acronym?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  entityVersion: Scalars['Int']['output'];
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
};

export type GenreCreateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type GenrePageResults = {
  __typename?: 'GenrePageResults';
  content: Array<Genre>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type GenreUpdateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IndexerStatus = {
  __typename?: 'IndexerStatus';
  indexed?: Maybe<Scalars['Int']['output']>;
  queued?: Maybe<Scalars['Int']['output']>;
  running?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LegacyExportImage = {
  __typename?: 'LegacyExportImage';
  downloadUrl: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  isTeaser: Scalars['Boolean']['output'];
};

export type LinkedAuthor = {
  __typename?: 'LinkedAuthor';
  displayName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isPrimary: Scalars['Boolean']['output'];
};

export type LinkedUser = {
  __typename?: 'LinkedUser';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  sub: Scalars['ID']['output'];
};

export type ListChange = BaseChange & {
  __typename?: 'ListChange';
  affectedGlobalId?: Maybe<Scalars['String']['output']>;
  author?: Maybe<RevisionAuthor>;
  changeType: PropertyChangeType | '%future added value';
  commitDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  left?: Maybe<Scalars['JSON']['output']>;
  propertyName: Scalars['String']['output'];
  right?: Maybe<Scalars['JSON']['output']>;
};

export type MapChange = BaseChange & {
  __typename?: 'MapChange';
  affectedGlobalId?: Maybe<Scalars['String']['output']>;
  author?: Maybe<RevisionAuthor>;
  changeType: PropertyChangeType | '%future added value';
  commitDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  left?: Maybe<Scalars['JSON']['output']>;
  propertyName: Scalars['String']['output'];
  right?: Maybe<Scalars['JSON']['output']>;
};

export type Media = {
  __typename?: 'Media';
  companies: Array<Company>;
  copyright?: Maybe<Scalars['String']['output']>;
  copyrightUrl?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  entityVersion: Scalars['Int']['output'];
  etag: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  gameConsoles: Array<GameConsole>;
  gameSeries: Array<GameSeries>;
  games: Array<Game>;
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  length: Scalars['Int']['output'];
  license?: Maybe<Scalars['String']['output']>;
  licenseUrl?: Maybe<Scalars['String']['output']>;
  mediaType: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  sha512sum: Scalars['String']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
  watermark: Scalars['Boolean']['output'];
};


export type MediaPreviewUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  resizing?: InputMaybe<Resizing>;
  watermark?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MediaExampleInput = {
  companies?: InputMaybe<Array<Scalars['UUID']['input']>>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  copyrightUrl?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameSeries?: InputMaybe<Array<Scalars['UUID']['input']>>;
  games?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lengthMax?: InputMaybe<Scalars['Int']['input']>;
  lengthMin?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseUrl?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  watermark?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaPageResults = {
  __typename?: 'MediaPageResults';
  content: Array<Media>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type MediaSearchDetails = {
  __typename?: 'MediaSearchDetails';
  filename: Scalars['String']['output'];
  mediaType: Scalars['String']['output'];
};

export type MediaUpdateInput = {
  companies?: InputMaybe<Array<Scalars['UUID']['input']>>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  copyrightUrl?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameSeries?: InputMaybe<Array<Scalars['UUID']['input']>>;
  games?: InputMaybe<Array<Scalars['UUID']['input']>>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseUrl?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  watermark?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type Mutation = {
  __typename?: 'Mutation';
  applyArticleAnalysis: ArticleAnalysis;
  approveComment: ArticleComment;
  claimPreparationTask: PreparationTask;
  closeArticleAnalysis: ArticleAnalysis;
  completePreparationTask: Scalars['Boolean']['output'];
  createArticle: Article;
  createArticlePreviewLink: Article;
  createArticleReviewCommentReply: ReviewComment;
  createArticleSeries: ArticleSeries;
  createAuthor: Author;
  createCompany: Company;
  createEvent: Event;
  createGame: Game;
  createGameConsole: GameConsole;
  createGameSeries: GameSeries;
  createGenre: Genre;
  createQuickFilter: QuickFilter;
  createRatingCategory: RatingCategory;
  createTag: Tag;
  deleteArticle: Article;
  deleteArticlePreviewLink: Article;
  /** Loescht den eigenen Kommentar; eine Wurzel mit Antworten wird zu deleted=true statt entfernt. */
  deleteArticleReviewComment?: Maybe<ReviewComment>;
  deleteArticleSeries: ArticleSeries;
  deleteAuthor: Author;
  deleteComment: ArticleComment;
  deleteCompany: Company;
  deleteEvent: Event;
  deleteGame: Game;
  deleteGameConsole: GameConsole;
  deleteGameSeries: GameSeries;
  deleteGenre: Genre;
  deleteMedia: Media;
  deleteQuickFilter: QuickFilter;
  deleteRatingCategory: RatingCategory;
  deleteTag: Tag;
  /** Legt die eigene Sitzung an bzw. frischt sie auf; liefert die übrigen aktiven Sitzungen. */
  editSessionHeartbeat: Array<EditSession>;
  /** Beendet die eigene Sitzung; fremde bleiben unberührt. Liefert, ob gelöscht wurde. */
  endEditSession: Scalars['Boolean']['output'];
  importMedia?: Maybe<Media>;
  /**
   * Imports a YouTube video's thumbnail into the media store and returns
   * both the media document and the canonical video URL. Idempotent —
   * re-importing the same video returns the existing Media (deduplicated
   * by sourceUrl).
   *
   * Errors (returned as ValidationError with extensions.classification):
   * - INVALID_YOUTUBE_URL: URL is not a recognised YouTube URL or video ID
   *   cannot be extracted.
   * - YOUTUBE_THUMBNAIL_UNAVAILABLE: All thumbnail candidates returned
   *   non-200 (private/deleted video, or no thumbnail available).
   * - MEDIA_IMPORT_FAILED: Network or storage error while downloading or
   *   persisting the thumbnail.
   */
  importYouTubeMedia: YouTubeMediaImportResult;
  markActivitiesReadUpTo: ActivityIndicator;
  mergeAuthors: Author;
  mergeCompanies: Company;
  prepareUpload: Upload;
  publishArticle: Article;
  rejectComment: ArticleComment;
  releasePreparationTask: PreparationTask;
  reopenArticleReviewComment: ReviewComment;
  reorderQuickFilters: Array<QuickFilter>;
  resolveArticleReviewComment: ReviewComment;
  retryArticleAnalysis: ArticleAnalysis;
  reviewArticleAnalysisSuggestion: ArticleAnalysis;
  scheduleArticleIndexing: ScheduleResult;
  scheduleArticleReindexing: Scalars['Int']['output'];
  scheduleArticleSeriesIndexing: ScheduleResult;
  scheduleArticleSeriesReindexing: Scalars['Int']['output'];
  scheduleAuthorIndexing: ScheduleResult;
  scheduleAuthorReindexing: Scalars['Int']['output'];
  scheduleCommentReindexing: Scalars['Int']['output'];
  scheduleCompanyIndexing: ScheduleResult;
  scheduleCompanyReindexing: Scalars['Int']['output'];
  scheduleEventIndexing: ScheduleResult;
  scheduleEventReindexing: Scalars['Int']['output'];
  scheduleGameConsoleIndexing: ScheduleResult;
  scheduleGameConsoleReindexing: Scalars['Int']['output'];
  scheduleGameIndexing: ScheduleResult;
  scheduleGameReindexing: Scalars['Int']['output'];
  scheduleGameSeriesIndexing: ScheduleResult;
  scheduleGameSeriesReindexing: Scalars['Int']['output'];
  scheduleGenreIndexing: ScheduleResult;
  scheduleGenreReindexing: Scalars['Int']['output'];
  scheduleMediaIndexing: ScheduleResult;
  scheduleMediaReindexing: Scalars['Int']['output'];
  scheduleRatingCategoryIndexing: ScheduleResult;
  scheduleRatingCategoryReindexing: Scalars['Int']['output'];
  scheduleTagIndexing: ScheduleResult;
  scheduleTagReindexing: Scalars['Int']['output'];
  setUserRoles: User;
  startArticleAnalysis: ArticleAnalysis;
  unpublishArticle: Article;
  updateArticle: Article;
  updateArticleSeries: ArticleSeries;
  updateAuthor: Author;
  updateCompany: Company;
  updateEvent: Event;
  updateGame: Game;
  updateGameConsole: GameConsole;
  updateGameSeries: GameSeries;
  updateGenre: Genre;
  updateMedia: Media;
  updateQuickFilter: QuickFilter;
  updateRatingCategory: RatingCategory;
  updateTag: Tag;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationApplyArticleAnalysisArgs = {
  analysisId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationApproveCommentArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationClaimPreparationTaskArgs = {
  entityId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCloseArticleAnalysisArgs = {
  analysisId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCompletePreparationTaskArgs = {
  entityId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateArticleArgs = {
  create: ArticleCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateArticlePreviewLinkArgs = {
  articleId: Scalars['UUID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  validUntil: Scalars['ZonedDateTime']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateArticleReviewCommentReplyArgs = {
  commentId: Scalars['UUID']['input'];
  text: Scalars['String']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateArticleSeriesArgs = {
  create: ArticleSeriesCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateAuthorArgs = {
  create: AuthorCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateCompanyArgs = {
  create: CompanyCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateEventArgs = {
  create: EventCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateGameArgs = {
  create: GameCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateGameConsoleArgs = {
  create: GameConsoleCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateGameSeriesArgs = {
  create: GameSeriesCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateGenreArgs = {
  create: GenreCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateQuickFilterArgs = {
  create: QuickFilterCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateRatingCategoryArgs = {
  create: RatingCategoryCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationCreateTagArgs = {
  create: TagCreateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteArticleArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteArticlePreviewLinkArgs = {
  articleId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteArticleReviewCommentArgs = {
  commentId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteArticleSeriesArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteAuthorArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteCommentArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteCompanyArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteEventArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteGameArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteGameConsoleArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteGameSeriesArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteGenreArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteMediaArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteQuickFilterArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteRatingCategoryArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationDeleteTagArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationEditSessionHeartbeatArgs = {
  dirty: Scalars['Boolean']['input'];
  entityId: Scalars['ID']['input'];
  entityType: EditSessionEntityType;
  sessionId: Scalars['ID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationEndEditSessionArgs = {
  entityId: Scalars['ID']['input'];
  entityType: EditSessionEntityType;
  sessionId: Scalars['ID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationImportMediaArgs = {
  companies?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameSeries?: InputMaybe<Array<Scalars['UUID']['input']>>;
  games?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uri: Scalars['String']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationImportYouTubeMediaArgs = {
  youtubeUrl: Scalars['String']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationMarkActivitiesReadUpToArgs = {
  scope: ActivityScope;
  timestamp: Scalars['ZonedDateTime']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationMergeAuthorsArgs = {
  resolved: AuthorMergeInput;
  sourceId: Scalars['UUID']['input'];
  targetId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationMergeCompaniesArgs = {
  resolved: CompanyMergeInput;
  sourceId: Scalars['UUID']['input'];
  targetId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationPrepareUploadArgs = {
  upload: PrepareUploadInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationPublishArticleArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationRejectCommentArgs = {
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationReleasePreparationTaskArgs = {
  entityId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationReopenArticleReviewCommentArgs = {
  commentId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationReorderQuickFiltersArgs = {
  orderedIds: Array<Scalars['UUID']['input']>;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationResolveArticleReviewCommentArgs = {
  commentId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationRetryArticleAnalysisArgs = {
  analysisId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationReviewArticleAnalysisSuggestionArgs = {
  accepted: Scalars['Boolean']['input'];
  analysisId: Scalars['UUID']['input'];
  suggestionId: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationSetUserRolesArgs = {
  roles: Array<Role>;
  sub: Scalars['ID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationStartArticleAnalysisArgs = {
  articleId: Scalars['UUID']['input'];
  preferredProvider?: InputMaybe<Scalars['String']['input']>;
  sentiment: AnalysisSentiment;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUnpublishArticleArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateArticleArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: ArticleUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateArticleSeriesArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: ArticleSeriesUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateAuthorArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: AuthorUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateCompanyArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: CompanyUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateEventArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: EventUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateGameArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: GameUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateGameConsoleArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: GameConsoleUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateGameSeriesArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: GameSeriesUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateGenreArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: GenreUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateMediaArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: MediaUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateQuickFilterArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: QuickFilterUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateRatingCategoryArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: RatingCategoryUpdateInput;
};


/**
 * Admin write API. Per-entity CRUD (`create…`/`update…`/`delete…`, plus article publish/unpublish and
 * entity merges) alongside `schedule<Entity>Indexing` / `schedule<Entity>Reindexing` maintenance
 * operations. Every field is authorization-gated by a [Role].
 */
export type MutationUpdateTagArgs = {
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  update: TagUpdateInput;
};

export type NewObjectChange = BaseChange & {
  __typename?: 'NewObjectChange';
  affectedGlobalId?: Maybe<Scalars['String']['output']>;
  author?: Maybe<RevisionAuthor>;
  commitDate?: Maybe<Scalars['ZonedDateTime']['output']>;
};

export type ObjectRemovedChange = BaseChange & {
  __typename?: 'ObjectRemovedChange';
  affectedGlobalId?: Maybe<Scalars['String']['output']>;
  author?: Maybe<RevisionAuthor>;
  commitDate?: Maybe<Scalars['ZonedDateTime']['output']>;
};

export const Packaging = {
  BOX: 'BOX',
  BOX_WITH_DOWNLOAD_CODE: 'BOX_WITH_DOWNLOAD_CODE',
  DOWNLOAD: 'DOWNLOAD',
  LIMITED_BOX: 'LIMITED_BOX',
  LIMITED_DOWNLOAD: 'LIMITED_DOWNLOAD'
} as const;

export type Packaging = typeof Packaging[keyof typeof Packaging];
export type PlayerCount = {
  __typename?: 'PlayerCount';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type PlayerCountInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type PlayerCountSuggestion = {
  __typename?: 'PlayerCountSuggestion';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  confidence: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export const PreparationEntityType = {
  ARTICLE: 'ARTICLE',
  AUTHOR: 'AUTHOR',
  COMPANY: 'COMPANY',
  GAME: 'GAME',
  GAME_CONSOLE: 'GAME_CONSOLE',
  GAME_SERIES: 'GAME_SERIES',
  GENRE: 'GENRE',
  MEDIA: 'MEDIA'
} as const;

export type PreparationEntityType = typeof PreparationEntityType[keyof typeof PreparationEntityType];
export const PreparationStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  OPEN: 'OPEN'
} as const;

export type PreparationStatus = typeof PreparationStatus[keyof typeof PreparationStatus];
export type PreparationTask = {
  __typename?: 'PreparationTask';
  claimedBy?: Maybe<RevisionAuthor>;
  claimedDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  createdDate: Scalars['ZonedDateTime']['output'];
  duplicateCandidates: Array<DuplicateCandidate>;
  entityId: Scalars['UUID']['output'];
  entityType: PreparationEntityType | '%future added value';
  possibleDuplicate: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type PreparationTaskPageResults = {
  __typename?: 'PreparationTaskPageResults';
  content: Array<PreparationTask>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PrepareUploadInput = {
  companies?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filename: Scalars['String']['input'];
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gameSeries?: InputMaybe<Array<Scalars['UUID']['input']>>;
  games?: InputMaybe<Array<Scalars['UUID']['input']>>;
  mediaType: Scalars['String']['input'];
  parts: Array<PrepareUploadPartInput>;
  /**
   * Ersetzt nach Abschluss des Uploads die Datei des angegebenen Mediums, statt ein neues
   * Medium anzulegen. UUID, Verknuepfungen und Verwendungsstellen bleiben erhalten; die
   * Entitaeten-Verknuepfungen dieses Inputs werden dabei ignoriert.
   */
  replaceMedia?: InputMaybe<Scalars['UUID']['input']>;
  sha512sum: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type PrepareUploadPartInput = {
  length: Scalars['Int']['input'];
  number: Scalars['Int']['input'];
  sha512sum: Scalars['String']['input'];
};

export const PropertyChangeType = {
  PROPERTY_ADDED: 'PROPERTY_ADDED',
  PROPERTY_REMOVED: 'PROPERTY_REMOVED',
  PROPERTY_VALUE_CHANGED: 'PROPERTY_VALUE_CHANGED'
} as const;

export type PropertyChangeType = typeof PropertyChangeType[keyof typeof PropertyChangeType];
export const PublishedState = {
  DRAFT: 'DRAFT',
  IN_REVIEW: 'IN_REVIEW',
  PUBLISHED: 'PUBLISHED'
} as const;

export type PublishedState = typeof PublishedState[keyof typeof PublishedState];
/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type Query = {
  __typename?: 'Query';
  activityIndicator: ActivityIndicator;
  activityReadState: ActivityReadState;
  activityStream: ActivityPage;
  adminSearch: AdminSearchResponse;
  aiProviders: Array<AiProvider>;
  allArticleSeries: ArticleSeriesPageResults;
  allArticles: ArticlePageResults;
  allAuthors: AuthorPageResults;
  allCompanies: CompanyPageResults;
  allEvents: EventPageResults;
  allGameConsoles: GameConsolePageResults;
  allGameSeries: GameSeriesPageResults;
  allGames: GamePageResults;
  allGenres: GenrePageResults;
  allMedia: MediaPageResults;
  allQuickFilters: QuickFilterPageResults;
  allRatingCategories: RatingCategoryPageResults;
  allTags: TagPageResults;
  article?: Maybe<Article>;
  articleAnalyses: Array<ArticleAnalysis>;
  articleAnalysis?: Maybe<ArticleAnalysis>;
  articleComments: ArticleCommentPageResults;
  articleLegacyExport: ArticleLegacyExport;
  articleReceipt: ArticleReceipt;
  articleRevisionAuthors: Array<RevisionAuthor>;
  articleRevisions: ChangesByCommitPage;
  articleSeries?: Maybe<ArticleSeries>;
  articleStatistics: ArticleStatistics;
  articleStats?: Maybe<ArticleStats>;
  author?: Maybe<Author>;
  company?: Maybe<Company>;
  currentUserPrimaryAuthor?: Maybe<Author>;
  /** Aktive Bearbeitungen der Entität, älteste zuerst. */
  editSessions: Array<EditSession>;
  event?: Maybe<Event>;
  findArticleSeries: ArticleSeriesPageResults;
  findArticles: ArticlePageResults;
  findAuthors: AuthorPageResults;
  findCompanies: CompanyPageResults;
  findEvents: EventPageResults;
  findGameConsoles: GameConsolePageResults;
  findGameSeries: GameSeriesPageResults;
  findGames: GamePageResults;
  findGenres: GenrePageResults;
  findMedia: MediaPageResults;
  findQuickFilters: QuickFilterPageResults;
  findRatingCategories: RatingCategoryPageResults;
  findTags: TagPageResults;
  findUsers: UserPageResults;
  findYouTubeVideos: YouTubeVideoPageResults;
  game?: Maybe<Game>;
  gameConsole?: Maybe<GameConsole>;
  gameSeries?: Maybe<GameSeries>;
  genre?: Maybe<Genre>;
  media?: Maybe<Media>;
  myOpenArticleAnalyses: Array<ArticleAnalysis>;
  myPreparationTasks: Array<PreparationTask>;
  openArticleAnalyses: Array<ArticleAnalysis>;
  openPreparationTasks: PreparationTaskPageResults;
  pendingComments: ArticleCommentPageResults;
  pendingCommentsCount: Scalars['Int']['output'];
  preparationTask?: Maybe<PreparationTask>;
  quickFilter?: Maybe<QuickFilter>;
  ratingCategory?: Maybe<RatingCategory>;
  searchUsers: Array<LinkedUser>;
  tag?: Maybe<Tag>;
  user?: Maybe<User>;
  usersBySubs: Array<LinkedUser>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryActivityIndicatorArgs = {
  scope: ActivityScope;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryActivityReadStateArgs = {
  scope: ActivityScope;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryActivityStreamArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ActivityStreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scope: ActivityScope;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAdminSearchArgs = {
  groups: Array<AdminSearchGroupInput>;
  query: Scalars['String']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllArticleSeriesArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllArticlesArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  scope?: InputMaybe<ArticleScope>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllAuthorsArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllCompaniesArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllEventsArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllGameConsolesArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllGameSeriesArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllGamesArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllGenresArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllMediaArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllQuickFiltersArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllRatingCategoriesArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAllTagsArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleAnalysesArgs = {
  articleId: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleAnalysisArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleCommentsArgs = {
  articleId: Scalars['UUID']['input'];
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  status?: InputMaybe<Array<CommentModerationStatus>>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleLegacyExportArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleReceiptArgs = {
  id: Scalars['UUID']['input'];
  language: ReceiptLanguage;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleRevisionAuthorsArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleRevisionsArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleSeriesArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleStatisticsArgs = {
  filter: ArticleStatisticsFilter;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryArticleStatsArgs = {
  from: Scalars['ZonedDateTime']['input'];
  until: Scalars['ZonedDateTime']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryAuthorArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryCompanyArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryEditSessionsArgs = {
  entityId: Scalars['ID']['input'];
  entityType: EditSessionEntityType;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryEventArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindArticleSeriesArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindArticlesArgs = {
  examples?: InputMaybe<Array<ArticleExampleInput>>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<ArticleScope>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindAuthorsArgs = {
  examples?: InputMaybe<Array<AuthorExampleInput>>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindCompaniesArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindEventsArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  kinds?: InputMaybe<Array<EventKind>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindGameConsolesArgs = {
  examples?: InputMaybe<Array<GameConsoleExampleInput>>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindGameSeriesArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindGamesArgs = {
  examples?: InputMaybe<Array<GameExampleInput>>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindGenresArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindMediaArgs = {
  examples?: InputMaybe<Array<MediaExampleInput>>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindQuickFiltersArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  visibleOn?: InputMaybe<ArticleListPage>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindRatingCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindTagsArgs = {
  examples?: InputMaybe<Array<TagExampleInput>>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindUsersArgs = {
  examples?: InputMaybe<Array<UserExampleInput>>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryFindYouTubeVideosArgs = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryGameArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryGameConsoleArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryGameSeriesArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryGenreArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryMediaArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryOpenPreparationTasksArgs = {
  limit?: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  possibleDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PreparationStatus>;
  type?: InputMaybe<PreparationEntityType>;
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryPendingCommentsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryPreparationTaskArgs = {
  entityId: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryQuickFilterArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryRatingCategoryArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QuerySearchUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryTagArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryUserArgs = {
  sub: Scalars['ID']['input'];
};


/**
 * Admin read API served at `/admin/graphql`. Every field is authorization-gated by a [Role]. Entity
 * reads follow a consistent convention: `entity(id)` for one, `allEntities(page, limit, order)` for an
 * unfiltered page, and `findEntities(…, query, ids, examples)` for a filtered/query-by-example page.
 */
export type QueryUsersBySubsArgs = {
  subs: Array<Scalars['ID']['input']>;
};

export type QuickFilter = {
  __typename?: 'QuickFilter';
  createdDate: Scalars['ZonedDateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  entityVersion: Scalars['Int']['output'];
  filters: ArticleFilterPreset;
  icon: QuickFilterIcon | '%future added value';
  label: Scalars['String']['output'];
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  slug: Scalars['String']['output'];
  sortIndex: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
  visibleFrom?: Maybe<Scalars['ZonedDateTime']['output']>;
  visibleOn: Array<ArticleListPage | '%future added value'>;
  visibleUntil?: Maybe<Scalars['ZonedDateTime']['output']>;
};

export type QuickFilterCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filters: ArticleFilterPresetInput;
  icon: QuickFilterIcon | '%future added value';
  label: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  visibleFrom?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  visibleOn: Array<ArticleListPage | '%future added value'>;
  visibleUntil?: InputMaybe<Scalars['ZonedDateTime']['input']>;
};

export const QuickFilterIcon = {
  AWARD: 'AWARD',
  BOOKMARK: 'BOOKMARK',
  CALENDAR: 'CALENDAR',
  CLOCK: 'CLOCK',
  COMPASS: 'COMPASS',
  CROWN: 'CROWN',
  FILM: 'FILM',
  FLAME: 'FLAME',
  GAMEPAD_2: 'GAMEPAD_2',
  GHOST: 'GHOST',
  GIFT: 'GIFT',
  HASH: 'HASH',
  HEADPHONES: 'HEADPHONES',
  HEART: 'HEART',
  JOYSTICK: 'JOYSTICK',
  LAPTOP: 'LAPTOP',
  LAYERS: 'LAYERS',
  MAP: 'MAP',
  MEDAL: 'MEDAL',
  MIC: 'MIC',
  MONITOR: 'MONITOR',
  MUSIC: 'MUSIC',
  PARTY_POPPER: 'PARTY_POPPER',
  PODCAST: 'PODCAST',
  ROCKET: 'ROCKET',
  SHIELD: 'SHIELD',
  SPARKLES: 'SPARKLES',
  STAR: 'STAR',
  SWORD: 'SWORD',
  TAG: 'TAG',
  TAGS: 'TAGS',
  TROPHY: 'TROPHY',
  USER: 'USER',
  USERS: 'USERS',
  ZAP: 'ZAP'
} as const;

export type QuickFilterIcon = typeof QuickFilterIcon[keyof typeof QuickFilterIcon];
export type QuickFilterPageResults = {
  __typename?: 'QuickFilterPageResults';
  content: Array<QuickFilter>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type QuickFilterUpdateInput = {
  enabled: Scalars['Boolean']['input'];
  filters: ArticleFilterPresetInput;
  icon: QuickFilterIcon | '%future added value';
  label: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  visibleFrom?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  visibleOn: Array<ArticleListPage | '%future added value'>;
  visibleUntil?: InputMaybe<Scalars['ZonedDateTime']['input']>;
};

export type RatingCategory = {
  __typename?: 'RatingCategory';
  articleSpecific: Scalars['Boolean']['output'];
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  entityVersion: Scalars['Int']['output'];
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  step: Scalars['Float']['output'];
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
};

export type RatingCategoryCreateInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  step: Scalars['Float']['input'];
};

export type RatingCategoryPageResults = {
  __typename?: 'RatingCategoryPageResults';
  content: Array<RatingCategory>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type RatingCategoryUpdateInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  step?: InputMaybe<Scalars['Float']['input']>;
};

export type ReactionActivity = Activity & {
  __typename?: 'ReactionActivity';
  actor: RevisionAuthor;
  createdDate: Scalars['ZonedDateTime']['output'];
  emoji: ReactionEmoji | '%future added value';
  id: Scalars['ID']['output'];
  target: ReactionTarget;
};

export type ReactionCount = {
  __typename?: 'ReactionCount';
  count: Scalars['Int']['output'];
  emoji: ReactionEmoji | '%future added value';
};

export const ReactionEmoji = {
  EYES: 'EYES',
  FIRE: 'FIRE',
  GAMING: 'GAMING',
  HEART: 'HEART',
  LAUGH: 'LAUGH',
  PARTY: 'PARTY',
  STAR: 'STAR',
  SURPRISED: 'SURPRISED',
  THINKING: 'THINKING',
  THUMBS_UP: 'THUMBS_UP'
} as const;

export type ReactionEmoji = typeof ReactionEmoji[keyof typeof ReactionEmoji];
export type ReactionTarget = Article | ArticleComment | { __typename?: "%other" };

export const ReceiptLanguage = {
  DE: 'DE',
  EN: 'EN'
} as const;

export type ReceiptLanguage = typeof ReceiptLanguage[keyof typeof ReceiptLanguage];
export const Resizing = {
  AUTO: 'AUTO',
  FILL: 'FILL',
  FIT: 'FIT'
} as const;

export type Resizing = typeof Resizing[keyof typeof Resizing];
export type ReviewComment = {
  __typename?: 'ReviewComment';
  anchor?: Maybe<ReviewCommentAnchor>;
  author?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  parentCommentId?: Maybe<Scalars['UUID']['output']>;
  resolvedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  resolvedBy?: Maybe<RevisionAuthor>;
  status: ReviewCommentStatus | '%future added value';
  suggestedText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
  viewerCanDelete: Scalars['Boolean']['output'];
};

export type ReviewCommentActivity = Activity & {
  __typename?: 'ReviewCommentActivity';
  actor: RevisionAuthor;
  articleId: Scalars['UUID']['output'];
  articleSubject: Scalars['String']['output'];
  createdDate: Scalars['ZonedDateTime']['output'];
  excerpt: Scalars['String']['output'];
  hasSuggestion: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isReply: Scalars['Boolean']['output'];
};

export type ReviewCommentAnchor = {
  __typename?: 'ReviewCommentAnchor';
  blockId: Scalars['String']['output'];
  endOffset: Scalars['Int']['output'];
  field: ReviewCommentField | '%future added value';
  quotedText: Scalars['String']['output'];
  startOffset: Scalars['Int']['output'];
  subReviewIndex?: Maybe<Scalars['Int']['output']>;
};

export const ReviewCommentField = {
  ACCESSIBILITY_NOTE: 'ACCESSIBILITY_NOTE',
  CONCLUSION: 'CONCLUSION',
  EDITORS_TAKE: 'EDITORS_TAKE',
  SPECIAL_THANKS: 'SPECIAL_THANKS',
  SUB_REVIEW_BODY: 'SUB_REVIEW_BODY',
  SUB_REVIEW_CONCLUSION: 'SUB_REVIEW_CONCLUSION',
  TEASER_TEXT: 'TEASER_TEXT',
  TEXT: 'TEXT'
} as const;

export type ReviewCommentField = typeof ReviewCommentField[keyof typeof ReviewCommentField];
export const ReviewCommentStatus = {
  OPEN: 'OPEN',
  RESOLVED: 'RESOLVED'
} as const;

export type ReviewCommentStatus = typeof ReviewCommentStatus[keyof typeof ReviewCommentStatus];
export type RevisionAuthor = {
  __typename?: 'RevisionAuthor';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

/**
 * Authorization roles, mapped from Keycloak realm/client roles to Spring Security authorities. Every
 * admin `Query`/`Mutation` field is gated on one of these via `@PreAuthorize` in its resolver. There is
 * no role hierarchy — a role grants exactly its own capability.
 */
export const Role = {
  /** Access to the Spring Boot Actuator endpoints. */
  ACTUATOR: 'ACTUATOR',
  DELETE_ARTICLES: 'DELETE_ARTICLES',
  DELETE_ARTICLE_SERIES: 'DELETE_ARTICLE_SERIES',
  DELETE_AUTHORS: 'DELETE_AUTHORS',
  DELETE_COMPANIES: 'DELETE_COMPANIES',
  DELETE_EVENTS: 'DELETE_EVENTS',
  DELETE_GAMES: 'DELETE_GAMES',
  DELETE_GAME_CONSOLES: 'DELETE_GAME_CONSOLES',
  DELETE_GAME_SERIES: 'DELETE_GAME_SERIES',
  DELETE_GENRES: 'DELETE_GENRES',
  DELETE_MEDIA: 'DELETE_MEDIA',
  DELETE_OWN_ARTICLES: 'DELETE_OWN_ARTICLES',
  DELETE_OWN_ARTICLE_SERIES: 'DELETE_OWN_ARTICLE_SERIES',
  DELETE_OWN_AUTHORS: 'DELETE_OWN_AUTHORS',
  DELETE_OWN_COMPANIES: 'DELETE_OWN_COMPANIES',
  DELETE_OWN_EVENTS: 'DELETE_OWN_EVENTS',
  DELETE_OWN_GAMES: 'DELETE_OWN_GAMES',
  DELETE_OWN_GAME_CONSOLES: 'DELETE_OWN_GAME_CONSOLES',
  DELETE_OWN_GAME_SERIES: 'DELETE_OWN_GAME_SERIES',
  DELETE_OWN_GENRES: 'DELETE_OWN_GENRES',
  DELETE_OWN_MEDIA: 'DELETE_OWN_MEDIA',
  DELETE_OWN_QUICK_FILTER: 'DELETE_OWN_QUICK_FILTER',
  DELETE_OWN_RATING_CATEGORIES: 'DELETE_OWN_RATING_CATEGORIES',
  DELETE_OWN_TAG: 'DELETE_OWN_TAG',
  DELETE_QUICK_FILTER: 'DELETE_QUICK_FILTER',
  DELETE_RATING_CATEGORIES: 'DELETE_RATING_CATEGORIES',
  DELETE_TAG: 'DELETE_TAG',
  /** Full create/update/delete over every article (does not by itself grant publish). */
  MANAGE_ARTICLES: 'MANAGE_ARTICLES',
  /** Create/update over every article series. */
  MANAGE_ARTICLE_SERIES: 'MANAGE_ARTICLE_SERIES',
  MANAGE_AUTHORS: 'MANAGE_AUTHORS',
  MANAGE_COMMENTS: 'MANAGE_COMMENTS',
  MANAGE_COMPANIES: 'MANAGE_COMPANIES',
  MANAGE_EVENTS: 'MANAGE_EVENTS',
  MANAGE_GAMES: 'MANAGE_GAMES',
  MANAGE_GAME_CONSOLES: 'MANAGE_GAME_CONSOLES',
  MANAGE_GAME_SERIES: 'MANAGE_GAME_SERIES',
  MANAGE_GENRES: 'MANAGE_GENRES',
  MANAGE_MEDIA: 'MANAGE_MEDIA',
  /** Create/update over the caller's OWN articles only (no foreign articles, no publish). */
  MANAGE_OWN_ARTICLES: 'MANAGE_OWN_ARTICLES',
  /** Create/update over the caller's OWN article series only. */
  MANAGE_OWN_ARTICLE_SERIES: 'MANAGE_OWN_ARTICLE_SERIES',
  MANAGE_OWN_AUTHORS: 'MANAGE_OWN_AUTHORS',
  MANAGE_OWN_COMPANIES: 'MANAGE_OWN_COMPANIES',
  MANAGE_OWN_EVENTS: 'MANAGE_OWN_EVENTS',
  MANAGE_OWN_GAMES: 'MANAGE_OWN_GAMES',
  MANAGE_OWN_GAME_CONSOLES: 'MANAGE_OWN_GAME_CONSOLES',
  MANAGE_OWN_GAME_SERIES: 'MANAGE_OWN_GAME_SERIES',
  MANAGE_OWN_GENRES: 'MANAGE_OWN_GENRES',
  MANAGE_OWN_MEDIA: 'MANAGE_OWN_MEDIA',
  MANAGE_OWN_QUICK_FILTER: 'MANAGE_OWN_QUICK_FILTER',
  MANAGE_OWN_RATING_CATEGORIES: 'MANAGE_OWN_RATING_CATEGORIES',
  MANAGE_OWN_TAG: 'MANAGE_OWN_TAG',
  MANAGE_QUICK_FILTER: 'MANAGE_QUICK_FILTER',
  MANAGE_RATING_CATEGORIES: 'MANAGE_RATING_CATEGORIES',
  MANAGE_TAG: 'MANAGE_TAG',
  MANAGE_USERS: 'MANAGE_USERS',
  MANAGE_USER_ROLES: 'MANAGE_USER_ROLES',
  /** Publish/unpublish articles. */
  PUBLISH_ARTICLES: 'PUBLISH_ARTICLES',
  /** Superuser: reindex/schedule maintenance ops and other system-level operations; the built-in Api-Token maps to this. */
  SYSTEM_ADMINISTRATION: 'SYSTEM_ADMINISTRATION'
} as const;

export type Role = typeof Role[keyof typeof Role];
export type ScheduleResult = {
  __typename?: 'ScheduleResult';
  creates?: Maybe<Scalars['Int']['output']>;
  deletes?: Maybe<Scalars['Int']['output']>;
  updates?: Maybe<Scalars['Int']['output']>;
};

export const SearchType = {
  ARTICLE: 'ARTICLE',
  ARTICLE_SERIES: 'ARTICLE_SERIES',
  AUTHOR: 'AUTHOR',
  COMPANY: 'COMPANY',
  EVENT: 'EVENT',
  GAME: 'GAME',
  GAME_CONSOLE: 'GAME_CONSOLE',
  GAME_SERIES: 'GAME_SERIES',
  MEDIA: 'MEDIA',
  TAG: 'TAG'
} as const;

export type SearchType = typeof SearchType[keyof typeof SearchType];
export type SetChange = BaseChange & {
  __typename?: 'SetChange';
  affectedGlobalId?: Maybe<Scalars['String']['output']>;
  author?: Maybe<RevisionAuthor>;
  changeType: PropertyChangeType | '%future added value';
  commitDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  left?: Maybe<Scalars['JSON']['output']>;
  propertyName: Scalars['String']['output'];
  right?: Maybe<Scalars['JSON']['output']>;
};

export type StatisticsComparison = {
  __typename?: 'StatisticsComparison';
  byKind: Array<StatisticsKindCount>;
  total: Scalars['Int']['output'];
};

export const StatisticsDateBasis = {
  CREATED: 'CREATED',
  PUBLICATION: 'PUBLICATION'
} as const;

export type StatisticsDateBasis = typeof StatisticsDateBasis[keyof typeof StatisticsDateBasis];
export type StatisticsEditorCount = {
  __typename?: 'StatisticsEditorCount';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export const StatisticsEditorGrouping = {
  AUTHOR: 'AUTHOR',
  CREATED_BY: 'CREATED_BY'
} as const;

export type StatisticsEditorGrouping = typeof StatisticsEditorGrouping[keyof typeof StatisticsEditorGrouping];
export const StatisticsGranularity = {
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  WEEK: 'WEEK',
  YEAR: 'YEAR'
} as const;

export type StatisticsGranularity = typeof StatisticsGranularity[keyof typeof StatisticsGranularity];
export type StatisticsKindCount = {
  __typename?: 'StatisticsKindCount';
  count: Scalars['Int']['output'];
  kind: ArticleKind | '%future added value';
};

export type StatisticsPipeline = {
  __typename?: 'StatisticsPipeline';
  draftCount: Scalars['Int']['output'];
  inReviewCount: Scalars['Int']['output'];
};

export type StatisticsTimeBucket = {
  __typename?: 'StatisticsTimeBucket';
  bucketStart: Scalars['ZonedDateTime']['output'];
  byKind: Array<StatisticsKindCount>;
  total: Scalars['Int']['output'];
};

export type StatisticsTopic = {
  __typename?: 'StatisticsTopic';
  count: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  label: Scalars['String']['output'];
};

export type SubReview = {
  __typename?: 'SubReview';
  body: Scalars['JSON']['output'];
  conclusion?: Maybe<Scalars['JSON']['output']>;
  cons: Array<Scalars['String']['output']>;
  pros: Array<Scalars['String']['output']>;
  rating: Array<ArticleRating>;
  score?: Maybe<Scalars['Float']['output']>;
  teaserMedia?: Maybe<Media>;
  title: Scalars['String']['output'];
};

export type SubReviewInput = {
  body: Scalars['JSON']['input'];
  conclusion?: InputMaybe<Scalars['JSON']['input']>;
  cons: Array<Scalars['String']['input']>;
  pros: Array<Scalars['String']['input']>;
  rating: Array<ArticleRatingInput>;
  score?: InputMaybe<Scalars['Float']['input']>;
  teaserMedia?: InputMaybe<Scalars['UUID']['input']>;
  title: Scalars['String']['input'];
};

/** Live per-entity indexer-status streams, served over the WebSocket endpoint `/admin/subscriptions`. */
export type Subscription = {
  __typename?: 'Subscription';
  activityAdded: Activity;
  activityChanged: Activity;
  activityIndicatorChanged: ActivityIndicator;
  activityRemoved: Scalars['ID']['output'];
  articleIndexerStatus: IndexerStatus;
  articleSeriesIndexerStatus: IndexerStatus;
  authorIndexerStatus: IndexerStatus;
  companyIndexerStatus: IndexerStatus;
  eventIndexerStatus: IndexerStatus;
  gameConsoleIndexerStatus: IndexerStatus;
  gameIndexerStatus: IndexerStatus;
  gameSeriesIndexerStatus: IndexerStatus;
  genreIndexerStatus: IndexerStatus;
  mediaIndexerStatus: IndexerStatus;
  ratingCategoryIndexerStatus: IndexerStatus;
  tagIndexerStatus: IndexerStatus;
};


/** Live per-entity indexer-status streams, served over the WebSocket endpoint `/admin/subscriptions`. */
export type SubscriptionActivityAddedArgs = {
  filter?: InputMaybe<ActivityStreamFilter>;
  scope: ActivityScope;
};


/** Live per-entity indexer-status streams, served over the WebSocket endpoint `/admin/subscriptions`. */
export type SubscriptionActivityChangedArgs = {
  scope: ActivityScope;
};


/** Live per-entity indexer-status streams, served over the WebSocket endpoint `/admin/subscriptions`. */
export type SubscriptionActivityIndicatorChangedArgs = {
  scope: ActivityScope;
};


/** Live per-entity indexer-status streams, served over the WebSocket endpoint `/admin/subscriptions`. */
export type SubscriptionActivityRemovedArgs = {
  scope: ActivityScope;
};

export type Tag = {
  __typename?: 'Tag';
  color?: Maybe<Scalars['String']['output']>;
  contrastColor?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  entityVersion: Scalars['Int']['output'];
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  normalizedText: Scalars['String']['output'];
  text: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt löschen darf (DELETE_<X> oder DELETE_OWN_<X> auf eigenem Objekt). */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** True, wenn der aufrufende Nutzer dieses Objekt bearbeiten darf (MANAGE_<X> oder MANAGE_OWN_<X> auf eigenem Objekt). */
  viewerCanEdit: Scalars['Boolean']['output'];
};

export type TagCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  contrastColor?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type TagExampleInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type TagPageResults = {
  __typename?: 'TagPageResults';
  content: Array<Tag>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type TagSearchDetails = {
  __typename?: 'TagSearchDetails';
  text: Scalars['String']['output'];
};

export type TagSuggestion = {
  __typename?: 'TagSuggestion';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  confidence: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  isNew: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tagId?: Maybe<Scalars['UUID']['output']>;
};

export type TagUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  contrastColor?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TextSuggestion = {
  __typename?: 'TextSuggestion';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  category: TextSuggestionCategory | '%future added value';
  field: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  originalText: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
  suggestedText: Scalars['String']['output'];
};

export const TextSuggestionCategory = {
  COMPLEXITY: 'COMPLEXITY',
  SPELLING: 'SPELLING',
  STYLE: 'STYLE'
} as const;

export type TextSuggestionCategory = typeof TextSuggestionCategory[keyof typeof TextSuggestionCategory];
export type Upload = {
  __typename?: 'Upload';
  createdBy?: Maybe<RevisionAuthor>;
  createdDate: Scalars['ZonedDateTime']['output'];
  entityVersion: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  lastModifiedBy?: Maybe<RevisionAuthor>;
  lastModifiedDate: Scalars['ZonedDateTime']['output'];
  length: Scalars['Int']['output'];
  mediaType: Scalars['String']['output'];
  parts: Array<UploadPart>;
  sha512sum: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type UploadPart = {
  __typename?: 'UploadPart';
  complete: Scalars['Boolean']['output'];
  length: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  sha512sum: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  classification: UserClassification | '%future added value';
  createdDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  lastModifiedDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  linkedAuthors: Array<LinkedAuthor>;
  loginName?: Maybe<Scalars['String']['output']>;
  roles: Array<Role | '%future added value'>;
  state: UserState | '%future added value';
  sub: Scalars['ID']['output'];
  unknownRoleKeys: Array<Scalars['String']['output']>;
};

export const UserClassification = {
  COMMUNITY: 'COMMUNITY',
  EDITOR: 'EDITOR'
} as const;

export type UserClassification = typeof UserClassification[keyof typeof UserClassification];
export type UserExampleInput = {
  classifications?: InputMaybe<Array<UserClassification | '%future added value'>>;
  hasLinkedAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<Role | '%future added value'>>;
  states?: InputMaybe<Array<UserState | '%future added value'>>;
};

export type UserPageResults = {
  __typename?: 'UserPageResults';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  results: Array<User>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export const UserState = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  PENDING: 'PENDING'
} as const;

export type UserState = typeof UserState[keyof typeof UserState];
export type ValueChange = BaseChange & {
  __typename?: 'ValueChange';
  affectedGlobalId?: Maybe<Scalars['String']['output']>;
  author?: Maybe<RevisionAuthor>;
  changeType: PropertyChangeType | '%future added value';
  commitDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  left?: Maybe<Scalars['JSON']['output']>;
  propertyName: Scalars['String']['output'];
  right?: Maybe<Scalars['JSON']['output']>;
};

export const WebPushSendState = {
  NONE: 'NONE',
  SCHEDULED: 'SCHEDULED',
  SENDING: 'SENDING',
  SENT: 'SENT'
} as const;

export type WebPushSendState = typeof WebPushSendState[keyof typeof WebPushSendState];
export type YouTubeMediaImportResult = {
  __typename?: 'YouTubeMediaImportResult';
  /** The media document for the imported (or already-existing) thumbnail. */
  media: Media;
  /** The canonical YouTube watch URL — to be used as ExternalMedia.url. */
  videoUrl: Scalars['String']['output'];
};

/**
 * Ein YouTube-Video mit dauerhaft abgelegten Metadaten. Nur lesbar — die Daten stammen von
 * YouTube und werden periodisch aufgefrischt; redigiert wird hier nichts.
 */
export type YouTubeVideo = {
  __typename?: 'YouTubeVideo';
  /** Beitraege, die dieses Video verwenden — auch bei abweichender URL-Schreibweise im Beitrag. */
  articles: Array<Article>;
  authorName: Scalars['String']['output'];
  /** Ob das Video beim letzten Pruefen noch existierte. */
  available: Scalars['Boolean']['output'];
  lastRefreshedAt: Scalars['ZonedDateTime']['output'];
  /** Das importierte Vorschaubild aus dem eigenen Medienspeicher. */
  thumbnail?: Maybe<Media>;
  title: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
  videoId: Scalars['String']['output'];
  /** Kanonische Watch-URL des Videos. */
  videoUrl: Scalars['String']['output'];
};

export type YouTubeVideoPageResults = {
  __typename?: 'YouTubeVideoPageResults';
  content: Array<YouTubeVideo>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type GetArticleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetArticleQuery = { __typename?: 'Query', article?: { __typename?: 'Article', uuid: string, kind: ArticleKind, slug: string, subject: string, viewerCanEdit: boolean, viewerCanDelete: boolean, viewerCanPublish: boolean, viewerEditLockedByPublication: boolean, teaserText: any, text: any, conclusion: any, editorsTake: any, highlyAccessible: boolean, accessibilityNote: any, specialThanks: any, pros: Array<string>, cons: Array<string>, totalScore?: number | null | undefined, manualTotalScore?: boolean | null | undefined, subReviewScoreMin?: number | null | undefined, subReviewScoreMax?: number | null | undefined, publishedState: PublishedState, aiUsageLevel: AiUsageLevel, carouselPlacement: CarouselPlacement, publicationDateTime?: any | null | undefined, seoDescription?: string | null | undefined, entityVersion: number, authors: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }>, subReviews: Array<{ __typename?: 'SubReview', title: string, body: any, conclusion?: any | null | undefined, pros: Array<string>, cons: Array<string>, score?: number | null | undefined, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }> }>, medias: Array<
      | { __typename?: 'ExternalMedia', url: string }
      | { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }
    >, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined, previewLinks: Array<{ __typename?: 'ArticlePreviewLink', token: string, url: string, label?: string | null | undefined, validUntil: any, createdAt: any, createdBy?: { __typename?: 'RevisionAuthor', displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetArticlesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetArticlesQuery = { __typename?: 'Query', allArticles: { __typename?: 'ArticlePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Article', uuid: string, kind: ArticleKind, slug: string, subject: string, viewerCanEdit: boolean, viewerCanDelete: boolean, viewerCanPublish: boolean, viewerEditLockedByPublication: boolean, teaserText: any, totalReactions: number, commentCount: number, publishedState: PublishedState, carouselPlacement: CarouselPlacement, publicationDateTime?: any | null | undefined, createdDate: any, lastModifiedDate: any, authors: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, medias: Array<
        | { __typename?: 'ExternalMedia' }
        | { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }
      >, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean } }>, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }>, webPushStatus: { __typename?: 'ArticleWebPushStatus', state: WebPushSendState, sendAfter?: any | null | undefined, sentAt?: any | null | undefined, finishedAt?: any | null | undefined, subscriptionsTotal?: number | null | undefined, sentCount?: number | null | undefined, errorCount?: number | null | undefined, attempts?: number | null | undefined }, pageViews?: { __typename?: 'ArticlePageViews', total: number, last30Days: number, updatedAt: any } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined }> } };

export type FindArticlesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  examples?: InputMaybe<Array<ArticleExampleInput> | ArticleExampleInput>;
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  scope?: InputMaybe<ArticleScope>;
}>;


export type FindArticlesQuery = { __typename?: 'Query', findArticles: { __typename?: 'ArticlePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Article', uuid: string, kind: ArticleKind, slug: string, subject: string, viewerCanEdit: boolean, viewerCanDelete: boolean, viewerCanPublish: boolean, viewerEditLockedByPublication: boolean, teaserText: any, totalReactions: number, commentCount: number, publishedState: PublishedState, carouselPlacement: CarouselPlacement, publicationDateTime?: any | null | undefined, createdDate: any, lastModifiedDate: any, authors: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, medias: Array<
        | { __typename?: 'ExternalMedia' }
        | { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }
      >, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean } }>, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }>, webPushStatus: { __typename?: 'ArticleWebPushStatus', state: WebPushSendState, sendAfter?: any | null | undefined, sentAt?: any | null | undefined, finishedAt?: any | null | undefined, subscriptionsTotal?: number | null | undefined, sentCount?: number | null | undefined, errorCount?: number | null | undefined, attempts?: number | null | undefined }, pageViews?: { __typename?: 'ArticlePageViews', total: number, last30Days: number, updatedAt: any } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined }> } };

export type CreateArticleMutationVariables = Exact<{
  create: ArticleCreateInput;
}>;


export type CreateArticleMutation = { __typename?: 'Mutation', createArticle: { __typename?: 'Article', uuid: string, kind: ArticleKind, slug: string, subject: string, viewerCanEdit: boolean, viewerCanDelete: boolean, viewerCanPublish: boolean, viewerEditLockedByPublication: boolean, teaserText: any, text: any, conclusion: any, editorsTake: any, highlyAccessible: boolean, accessibilityNote: any, specialThanks: any, pros: Array<string>, cons: Array<string>, totalScore?: number | null | undefined, manualTotalScore?: boolean | null | undefined, subReviewScoreMin?: number | null | undefined, subReviewScoreMax?: number | null | undefined, publishedState: PublishedState, aiUsageLevel: AiUsageLevel, carouselPlacement: CarouselPlacement, publicationDateTime?: any | null | undefined, seoDescription?: string | null | undefined, entityVersion: number, authors: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }>, subReviews: Array<{ __typename?: 'SubReview', title: string, body: any, conclusion?: any | null | undefined, pros: Array<string>, cons: Array<string>, score?: number | null | undefined, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }> }>, medias: Array<
      | { __typename?: 'ExternalMedia', url: string }
      | { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }
    >, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined, previewLinks: Array<{ __typename?: 'ArticlePreviewLink', token: string, url: string, label?: string | null | undefined, validUntil: any, createdAt: any, createdBy?: { __typename?: 'RevisionAuthor', displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined }> } };

export type UpdateArticleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: ArticleUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateArticleMutation = { __typename?: 'Mutation', updateArticle: { __typename?: 'Article', uuid: string, kind: ArticleKind, slug: string, subject: string, viewerCanEdit: boolean, viewerCanDelete: boolean, viewerCanPublish: boolean, viewerEditLockedByPublication: boolean, teaserText: any, text: any, conclusion: any, editorsTake: any, highlyAccessible: boolean, accessibilityNote: any, specialThanks: any, pros: Array<string>, cons: Array<string>, totalScore?: number | null | undefined, manualTotalScore?: boolean | null | undefined, subReviewScoreMin?: number | null | undefined, subReviewScoreMax?: number | null | undefined, publishedState: PublishedState, aiUsageLevel: AiUsageLevel, carouselPlacement: CarouselPlacement, publicationDateTime?: any | null | undefined, seoDescription?: string | null | undefined, entityVersion: number, authors: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }>, subReviews: Array<{ __typename?: 'SubReview', title: string, body: any, conclusion?: any | null | undefined, pros: Array<string>, cons: Array<string>, score?: number | null | undefined, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }> }>, medias: Array<
      | { __typename?: 'ExternalMedia', url: string }
      | { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }
    >, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined, previewLinks: Array<{ __typename?: 'ArticlePreviewLink', token: string, url: string, label?: string | null | undefined, validUntil: any, createdAt: any, createdBy?: { __typename?: 'RevisionAuthor', displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined }> } };

export type DeleteArticleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteArticleMutation = { __typename?: 'Mutation', deleteArticle: { __typename?: 'Article', uuid: string, subject: string } };

export type PublishArticleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PublishArticleMutation = { __typename?: 'Mutation', publishArticle: { __typename?: 'Article', uuid: string, publishedState: PublishedState, publicationDateTime?: any | null | undefined } };

export type UnpublishArticleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type UnpublishArticleMutation = { __typename?: 'Mutation', unpublishArticle: { __typename?: 'Article', uuid: string, publishedState: PublishedState } };

export type ArticlePageResultsFragment = { __typename?: 'ArticlePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Article', uuid: string, kind: ArticleKind, slug: string, subject: string, viewerCanEdit: boolean, viewerCanDelete: boolean, viewerCanPublish: boolean, viewerEditLockedByPublication: boolean, teaserText: any, totalReactions: number, commentCount: number, publishedState: PublishedState, carouselPlacement: CarouselPlacement, publicationDateTime?: any | null | undefined, createdDate: any, lastModifiedDate: any, authors: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, medias: Array<
      | { __typename?: 'ExternalMedia' }
      | { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }
    >, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean } }>, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }>, webPushStatus: { __typename?: 'ArticleWebPushStatus', state: WebPushSendState, sendAfter?: any | null | undefined, sentAt?: any | null | undefined, finishedAt?: any | null | undefined, subscriptionsTotal?: number | null | undefined, sentCount?: number | null | undefined, errorCount?: number | null | undefined, attempts?: number | null | undefined }, pageViews?: { __typename?: 'ArticlePageViews', total: number, last30Days: number, updatedAt: any } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined }> };

export type ArticleRatingListItemFragment = { __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean } };

export type ArticleListItemFragment = { __typename?: 'Article', uuid: string, kind: ArticleKind, slug: string, subject: string, viewerCanEdit: boolean, viewerCanDelete: boolean, viewerCanPublish: boolean, viewerEditLockedByPublication: boolean, teaserText: any, totalReactions: number, commentCount: number, publishedState: PublishedState, carouselPlacement: CarouselPlacement, publicationDateTime?: any | null | undefined, createdDate: any, lastModifiedDate: any, authors: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, medias: Array<
    | { __typename?: 'ExternalMedia' }
    | { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }
  >, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean } }>, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }>, webPushStatus: { __typename?: 'ArticleWebPushStatus', state: WebPushSendState, sendAfter?: any | null | undefined, sentAt?: any | null | undefined, finishedAt?: any | null | undefined, subscriptionsTotal?: number | null | undefined, sentCount?: number | null | undefined, errorCount?: number | null | undefined, attempts?: number | null | undefined }, pageViews?: { __typename?: 'ArticlePageViews', total: number, last30Days: number, updatedAt: any } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined };

export type ArticleRatingDetailsFragment = { __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } };

export type ArticleDetailsFragment = { __typename?: 'Article', uuid: string, kind: ArticleKind, slug: string, subject: string, viewerCanEdit: boolean, viewerCanDelete: boolean, viewerCanPublish: boolean, viewerEditLockedByPublication: boolean, teaserText: any, text: any, conclusion: any, editorsTake: any, highlyAccessible: boolean, accessibilityNote: any, specialThanks: any, pros: Array<string>, cons: Array<string>, totalScore?: number | null | undefined, manualTotalScore?: boolean | null | undefined, subReviewScoreMin?: number | null | undefined, subReviewScoreMax?: number | null | undefined, publishedState: PublishedState, aiUsageLevel: AiUsageLevel, carouselPlacement: CarouselPlacement, publicationDateTime?: any | null | undefined, seoDescription?: string | null | undefined, entityVersion: number, authors: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }>, subReviews: Array<{ __typename?: 'SubReview', title: string, body: any, conclusion?: any | null | undefined, pros: Array<string>, cons: Array<string>, score?: number | null | undefined, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }> }>, medias: Array<
    | { __typename?: 'ExternalMedia', url: string }
    | { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }
  >, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined, previewLinks: Array<{ __typename?: 'ArticlePreviewLink', token: string, url: string, label?: string | null | undefined, validUntil: any, createdAt: any, createdBy?: { __typename?: 'RevisionAuthor', displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined }> };

export type GetArticleRevisionsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  author?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArticleRevisionsQuery = { __typename?: 'Query', article?: { __typename?: 'Article', uuid: string, kind: ArticleKind, slug: string, subject: string, viewerCanEdit: boolean, viewerCanDelete: boolean, viewerCanPublish: boolean, viewerEditLockedByPublication: boolean, teaserText: any, text: any, conclusion: any, editorsTake: any, highlyAccessible: boolean, accessibilityNote: any, specialThanks: any, pros: Array<string>, cons: Array<string>, totalScore?: number | null | undefined, manualTotalScore?: boolean | null | undefined, subReviewScoreMin?: number | null | undefined, subReviewScoreMax?: number | null | undefined, publishedState: PublishedState, aiUsageLevel: AiUsageLevel, carouselPlacement: CarouselPlacement, publicationDateTime?: any | null | undefined, seoDescription?: string | null | undefined, entityVersion: number, authors: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }>, subReviews: Array<{ __typename?: 'SubReview', title: string, body: any, conclusion?: any | null | undefined, pros: Array<string>, cons: Array<string>, score?: number | null | undefined, teaserMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, rating: Array<{ __typename?: 'ArticleRating', score?: number | null | undefined, category: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } }> }>, medias: Array<
      | { __typename?: 'ExternalMedia', url: string }
      | { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }
    >, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined } | null | undefined, previewLinks: Array<{ __typename?: 'ArticlePreviewLink', token: string, url: string, label?: string | null | undefined, validUntil: any, createdAt: any, createdBy?: { __typename?: 'RevisionAuthor', displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined }> } | null | undefined, articleRevisions: { __typename?: 'ChangesByCommitPage', page: number, limit: number, totalElements: number, totalPages: number, content: Array<{ __typename?: 'ChangesByCommit', summary: string, commit: { __typename?: 'CommitMetadata', id: string, commitDate: any, author?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined }, changes: Array<
        | { __typename?: 'ArrayChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
        | { __typename?: 'ListChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
        | { __typename?: 'MapChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
        | { __typename?: 'NewObjectChange' }
        | { __typename?: 'ObjectRemovedChange' }
        | { __typename?: 'SetChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
        | { __typename?: 'ValueChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
      > }> } };

export type GetArticleRevisionAuthorsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetArticleRevisionAuthorsQuery = { __typename?: 'Query', articleRevisionAuthors: Array<{ __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined }> };

export type CreateArticlePreviewLinkMutationVariables = Exact<{
  articleId: Scalars['UUID']['input'];
  validUntil: Scalars['ZonedDateTime']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateArticlePreviewLinkMutation = { __typename?: 'Mutation', createArticlePreviewLink: { __typename?: 'Article', uuid: string, previewLinks: Array<{ __typename?: 'ArticlePreviewLink', token: string, url: string, label?: string | null | undefined, validUntil: any, createdAt: any, createdBy?: { __typename?: 'RevisionAuthor', displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined }> } };

export type DeleteArticlePreviewLinkMutationVariables = Exact<{
  articleId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
}>;


export type DeleteArticlePreviewLinkMutation = { __typename?: 'Mutation', deleteArticlePreviewLink: { __typename?: 'Article', uuid: string, previewLinks: Array<{ __typename?: 'ArticlePreviewLink', token: string }> } };

export type ReviewCommentFieldsFragment = { __typename?: 'ReviewComment', uuid: string, parentCommentId?: string | null | undefined, text: string, suggestedText?: string | null | undefined, status: ReviewCommentStatus, deleted: boolean, createdDate: any, resolvedAt?: any | null | undefined, viewerCanDelete: boolean, anchor?: { __typename?: 'ReviewCommentAnchor', field: ReviewCommentField, subReviewIndex?: number | null | undefined, blockId: string, quotedText: string, startOffset: number, endOffset: number } | null | undefined, author?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, resolvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined };

export type GetArticleReviewCommentsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetArticleReviewCommentsQuery = { __typename?: 'Query', article?: { __typename?: 'Article', uuid: string, reviewComments: Array<{ __typename?: 'ReviewComment', uuid: string, parentCommentId?: string | null | undefined, text: string, suggestedText?: string | null | undefined, status: ReviewCommentStatus, deleted: boolean, createdDate: any, resolvedAt?: any | null | undefined, viewerCanDelete: boolean, anchor?: { __typename?: 'ReviewCommentAnchor', field: ReviewCommentField, subReviewIndex?: number | null | undefined, blockId: string, quotedText: string, startOffset: number, endOffset: number } | null | undefined, author?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, resolvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined }> } | null | undefined };

export type CreateArticleReviewCommentReplyMutationVariables = Exact<{
  commentId: Scalars['UUID']['input'];
  text: Scalars['String']['input'];
}>;


export type CreateArticleReviewCommentReplyMutation = { __typename?: 'Mutation', createArticleReviewCommentReply: { __typename?: 'ReviewComment', uuid: string, parentCommentId?: string | null | undefined, text: string, suggestedText?: string | null | undefined, status: ReviewCommentStatus, deleted: boolean, createdDate: any, resolvedAt?: any | null | undefined, viewerCanDelete: boolean, anchor?: { __typename?: 'ReviewCommentAnchor', field: ReviewCommentField, subReviewIndex?: number | null | undefined, blockId: string, quotedText: string, startOffset: number, endOffset: number } | null | undefined, author?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, resolvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined } };

export type ResolveArticleReviewCommentMutationVariables = Exact<{
  commentId: Scalars['UUID']['input'];
}>;


export type ResolveArticleReviewCommentMutation = { __typename?: 'Mutation', resolveArticleReviewComment: { __typename?: 'ReviewComment', uuid: string, parentCommentId?: string | null | undefined, text: string, suggestedText?: string | null | undefined, status: ReviewCommentStatus, deleted: boolean, createdDate: any, resolvedAt?: any | null | undefined, viewerCanDelete: boolean, anchor?: { __typename?: 'ReviewCommentAnchor', field: ReviewCommentField, subReviewIndex?: number | null | undefined, blockId: string, quotedText: string, startOffset: number, endOffset: number } | null | undefined, author?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, resolvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined } };

export type ReopenArticleReviewCommentMutationVariables = Exact<{
  commentId: Scalars['UUID']['input'];
}>;


export type ReopenArticleReviewCommentMutation = { __typename?: 'Mutation', reopenArticleReviewComment: { __typename?: 'ReviewComment', uuid: string, parentCommentId?: string | null | undefined, text: string, suggestedText?: string | null | undefined, status: ReviewCommentStatus, deleted: boolean, createdDate: any, resolvedAt?: any | null | undefined, viewerCanDelete: boolean, anchor?: { __typename?: 'ReviewCommentAnchor', field: ReviewCommentField, subReviewIndex?: number | null | undefined, blockId: string, quotedText: string, startOffset: number, endOffset: number } | null | undefined, author?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, resolvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined } };

export type DeleteArticleReviewCommentMutationVariables = Exact<{
  commentId: Scalars['UUID']['input'];
}>;


export type DeleteArticleReviewCommentMutation = { __typename?: 'Mutation', deleteArticleReviewComment?: { __typename?: 'ReviewComment', uuid: string, parentCommentId?: string | null | undefined, text: string, suggestedText?: string | null | undefined, status: ReviewCommentStatus, deleted: boolean, createdDate: any, resolvedAt?: any | null | undefined, viewerCanDelete: boolean, anchor?: { __typename?: 'ReviewCommentAnchor', field: ReviewCommentField, subReviewIndex?: number | null | undefined, blockId: string, quotedText: string, startOffset: number, endOffset: number } | null | undefined, author?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, resolvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined } | null | undefined };

export type ArticleLegacyExportQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ArticleLegacyExportQuery = { __typename?: 'Query', articleLegacyExport: { __typename?: 'ArticleLegacyExport', subject: string, gameTitle: string, teaserHtml: string, textHtml: string, conclusionHtml: string, pros: Array<string>, cons: Array<string>, images: Array<{ __typename?: 'LegacyExportImage', filename: string, downloadUrl: string, isTeaser: boolean }> } };

export type ArticleReceiptQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  language: ReceiptLanguage;
}>;


export type ArticleReceiptQuery = { __typename?: 'Query', articleReceipt: { __typename?: 'ArticleReceipt', subject: string, body: string } };

export type ArticleAnalysisDetailsFragment = { __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> };

export type GetArticleAnalysisQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetArticleAnalysisQuery = { __typename?: 'Query', articleAnalysis?: { __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> } | null | undefined };

export type GetArticleAnalysesQueryVariables = Exact<{
  articleId: Scalars['UUID']['input'];
}>;


export type GetArticleAnalysesQuery = { __typename?: 'Query', articleAnalyses: Array<{ __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> }> };

export type GetOpenArticleAnalysesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpenArticleAnalysesQuery = { __typename?: 'Query', openArticleAnalyses: Array<{ __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> }> };

export type GetMyOpenArticleAnalysesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOpenArticleAnalysesQuery = { __typename?: 'Query', myOpenArticleAnalyses: Array<{ __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> }> };

export type StartArticleAnalysisMutationVariables = Exact<{
  articleId: Scalars['UUID']['input'];
  sentiment: AnalysisSentiment;
  preferredProvider?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartArticleAnalysisMutation = { __typename?: 'Mutation', startArticleAnalysis: { __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> } };

export type GetAiProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiProvidersQuery = { __typename?: 'Query', aiProviders: Array<{ __typename?: 'AiProvider', id: string, model: string, available: boolean }> };

export type ReviewArticleAnalysisSuggestionMutationVariables = Exact<{
  analysisId: Scalars['UUID']['input'];
  suggestionId: Scalars['UUID']['input'];
  accepted: Scalars['Boolean']['input'];
}>;


export type ReviewArticleAnalysisSuggestionMutation = { __typename?: 'Mutation', reviewArticleAnalysisSuggestion: { __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> } };

export type ApplyArticleAnalysisMutationVariables = Exact<{
  analysisId: Scalars['UUID']['input'];
}>;


export type ApplyArticleAnalysisMutation = { __typename?: 'Mutation', applyArticleAnalysis: { __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> } };

export type CloseArticleAnalysisMutationVariables = Exact<{
  analysisId: Scalars['UUID']['input'];
}>;


export type CloseArticleAnalysisMutation = { __typename?: 'Mutation', closeArticleAnalysis: { __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> } };

export type RetryArticleAnalysisMutationVariables = Exact<{
  analysisId: Scalars['UUID']['input'];
}>;


export type RetryArticleAnalysisMutation = { __typename?: 'Mutation', retryArticleAnalysis: { __typename?: 'ArticleAnalysis', id: string, articleId: string, articleSubject: string, status: AnalysisStatus, sentiment: AnalysisSentiment, createdDate: any, startedAt?: any | null | undefined, completedAt?: any | null | undefined, closedAt?: any | null | undefined, error?: string | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, providerInfo?: { __typename?: 'AnalysisProviderInfo', provider: string, model: string } | null | undefined, articleKindSuggestion?: { __typename?: 'ClassificationSuggestion', id: string, value: ArticleKind, confidence: number, accepted?: boolean | null | undefined } | null | undefined, tagSuggestions: Array<{ __typename?: 'TagSuggestion', id: string, tagId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, companySuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameConsoleSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSeriesSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameSuggestions: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }>, gameDetailsSuggestion?: { __typename?: 'GameDetailsSuggestion', developer?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, publisher?: { __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined } | null | undefined, genres: Array<{ __typename?: 'EntitySuggestion', id: string, entityId?: string | null | undefined, name: string, isNew: boolean, confidence: number, accepted?: boolean | null | undefined }> } | null | undefined, textSuggestions: Array<{ __typename?: 'TextSuggestion', id: string, category: TextSuggestionCategory, field: string, originalText: string, suggestedText: string, reasoning: string, accepted?: boolean | null | undefined }> } };

export type ImportYouTubeMediaMutationVariables = Exact<{
  youtubeUrl: Scalars['String']['input'];
}>;


export type ImportYouTubeMediaMutation = { __typename?: 'Mutation', importYouTubeMedia: { __typename?: 'YouTubeMediaImportResult', videoUrl: string, media: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } } };

export type ArticleSeriesListItemFragment = { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean };

export type ArticleSeriesDetailsFragment = { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, description: any, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, teaserImage?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, kind: EventKind, startsAt: any, endsAt?: any | null | undefined } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined } | null | undefined };

export type FindArticleSeriesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type FindArticleSeriesQuery = { __typename?: 'Query', findArticleSeries: { __typename?: 'ArticleSeriesPageResults', number: number, size: number, numberOfElements: number, totalPages: number, totalElements: number, isFirst: boolean, isLast: boolean, hasNext: boolean, hasPrevious: boolean, content: Array<{ __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean }> } };

export type GetArticleSeriesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetArticleSeriesQuery = { __typename?: 'Query', articleSeries?: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, description: any, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, teaserImage?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, kind: EventKind, startsAt: any, endsAt?: any | null | undefined } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined } | null | undefined } | null | undefined };

export type CreateArticleSeriesMutationVariables = Exact<{
  create: ArticleSeriesCreateInput;
}>;


export type CreateArticleSeriesMutation = { __typename?: 'Mutation', createArticleSeries: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, description: any, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, teaserImage?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, kind: EventKind, startsAt: any, endsAt?: any | null | undefined } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined } | null | undefined } };

export type UpdateArticleSeriesMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: ArticleSeriesUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateArticleSeriesMutation = { __typename?: 'Mutation', updateArticleSeries: { __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, description: any, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, teaserImage?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, event?: { __typename?: 'Event', uuid: string, name: string, slug: string, kind: EventKind, startsAt: any, endsAt?: any | null | undefined } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined } | null | undefined } };

export type DeleteArticleSeriesMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteArticleSeriesMutation = { __typename?: 'Mutation', deleteArticleSeries: { __typename?: 'ArticleSeries', uuid: string } };

export type MyPreparationTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPreparationTasksQuery = { __typename?: 'Query', myPreparationTasks: Array<{ __typename?: 'PreparationTask', entityType: PreparationEntityType, entityId: string, title: string, createdDate: any, claimedDate?: any | null | undefined, possibleDuplicate: boolean, claimedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined, duplicateCandidates: Array<{ __typename?: 'DuplicateCandidate', entityId: string, title: string, reason: string, score: number }> }> };

export type OpenPreparationTasksQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PreparationEntityType>;
  status?: InputMaybe<PreparationStatus>;
  possibleDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OpenPreparationTasksQuery = { __typename?: 'Query', openPreparationTasks: { __typename?: 'PreparationTaskPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'PreparationTask', entityType: PreparationEntityType, entityId: string, title: string, createdDate: any, claimedDate?: any | null | undefined, possibleDuplicate: boolean, claimedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined, duplicateCandidates: Array<{ __typename?: 'DuplicateCandidate', entityId: string, title: string, reason: string, score: number }> }> } };

export type PreparationTaskQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
}>;


export type PreparationTaskQuery = { __typename?: 'Query', preparationTask?: { __typename?: 'PreparationTask', entityType: PreparationEntityType, entityId: string, title: string, createdDate: any, claimedDate?: any | null | undefined, possibleDuplicate: boolean, claimedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined, duplicateCandidates: Array<{ __typename?: 'DuplicateCandidate', entityId: string, title: string, reason: string, score: number }> } | null | undefined };

export type ClaimPreparationTaskMutationVariables = Exact<{
  entityId: Scalars['UUID']['input'];
}>;


export type ClaimPreparationTaskMutation = { __typename?: 'Mutation', claimPreparationTask: { __typename?: 'PreparationTask', entityType: PreparationEntityType, entityId: string, title: string, createdDate: any, claimedDate?: any | null | undefined, possibleDuplicate: boolean, claimedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined, duplicateCandidates: Array<{ __typename?: 'DuplicateCandidate', entityId: string, title: string, reason: string, score: number }> } };

export type ReleasePreparationTaskMutationVariables = Exact<{
  entityId: Scalars['UUID']['input'];
}>;


export type ReleasePreparationTaskMutation = { __typename?: 'Mutation', releasePreparationTask: { __typename?: 'PreparationTask', entityType: PreparationEntityType, entityId: string, title: string, createdDate: any, claimedDate?: any | null | undefined, possibleDuplicate: boolean, claimedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined, duplicateCandidates: Array<{ __typename?: 'DuplicateCandidate', entityId: string, title: string, reason: string, score: number }> } };

export type CompletePreparationTaskMutationVariables = Exact<{
  entityId: Scalars['UUID']['input'];
}>;


export type CompletePreparationTaskMutation = { __typename?: 'Mutation', completePreparationTask: boolean };

export type PreparationTaskItemFragment = { __typename?: 'PreparationTask', entityType: PreparationEntityType, entityId: string, title: string, createdDate: any, claimedDate?: any | null | undefined, possibleDuplicate: boolean, claimedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined, username?: string | null | undefined } | null | undefined, duplicateCandidates: Array<{ __typename?: 'DuplicateCandidate', entityId: string, title: string, reason: string, score: number }> };

export type GetAuthorQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetAuthorQuery = { __typename?: 'Query', author?: { __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, slogan?: string | null | undefined, profile?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> } | null | undefined };

export type CurrentUserPrimaryAuthorQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPrimaryAuthorQuery = { __typename?: 'Query', currentUserPrimaryAuthor?: { __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> } | null | undefined };

export type GetAuthorsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetAuthorsQuery = { __typename?: 'Query', allAuthors: { __typename?: 'AuthorPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }> } };

export type FindAuthorsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  examples?: InputMaybe<Array<AuthorExampleInput> | AuthorExampleInput>;
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindAuthorsQuery = { __typename?: 'Query', findAuthors: { __typename?: 'AuthorPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }> } };

export type AuthorPageResultsFragment = { __typename?: 'AuthorPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }> };

export type LinkedUserFragment = { __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean };

export type AuthorListItemFragment = { __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> };

export type AuthorDetailsFragment = { __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, slogan?: string | null | undefined, profile?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> };

export type SearchUsersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> };

export type CreateAuthorMutationVariables = Exact<{
  create: AuthorCreateInput;
}>;


export type CreateAuthorMutation = { __typename?: 'Mutation', createAuthor: { __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, slogan?: string | null | undefined, profile?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> } };

export type UpdateAuthorMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: AuthorUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateAuthorMutation = { __typename?: 'Mutation', updateAuthor: { __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, slogan?: string | null | undefined, profile?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> } };

export type MergeAuthorsMutationVariables = Exact<{
  targetId: Scalars['UUID']['input'];
  sourceId: Scalars['UUID']['input'];
  resolved: AuthorMergeInput;
}>;


export type MergeAuthorsMutation = { __typename?: 'Mutation', mergeAuthors: { __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, slogan?: string | null | undefined, profile?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> } };

export type UsersBySubsQueryVariables = Exact<{
  subs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UsersBySubsQuery = { __typename?: 'Query', usersBySubs: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> };

export type DeleteAuthorMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteAuthorMutation = { __typename?: 'Mutation', deleteAuthor: { __typename?: 'Author', uuid: string, name: string } };

export type GetArticleCommentsQueryVariables = Exact<{
  articleId: Scalars['UUID']['input'];
  status?: InputMaybe<Array<CommentModerationStatus> | CommentModerationStatus>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetArticleCommentsQuery = { __typename?: 'Query', articleComments: { __typename?: 'ArticleCommentPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'ArticleComment', uuid: string, articleId: string, parentCommentId?: string | null | undefined, content: any, moderationStatus: CommentModerationStatus, rejectionReason?: string | null | undefined, totalReactions: number, editedAt?: any | null | undefined, hasPendingEdit: boolean, createdDate: any, lastModifiedDate: any, author: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string, provider?: string | null | undefined, model?: string | null | undefined, assessedAt: any, attemptCount: number } | null | undefined, rejectedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, approvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }> }> } };

export type GetPendingCommentsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetPendingCommentsQuery = { __typename?: 'Query', pendingComments: { __typename?: 'ArticleCommentPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'ArticleComment', uuid: string, articleId: string, parentCommentId?: string | null | undefined, content: any, moderationStatus: CommentModerationStatus, createdDate: any, lastModifiedDate: any, author: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string, provider?: string | null | undefined, model?: string | null | undefined, assessedAt: any, attemptCount: number } | null | undefined }> } };

export type GetPendingCommentsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingCommentsCountQuery = { __typename?: 'Query', pendingCommentsCount: number };

export type ApproveCommentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ApproveCommentMutation = { __typename?: 'Mutation', approveComment: { __typename?: 'ArticleComment', uuid: string, articleId: string, parentCommentId?: string | null | undefined, content: any, moderationStatus: CommentModerationStatus, rejectionReason?: string | null | undefined, totalReactions: number, editedAt?: any | null | undefined, hasPendingEdit: boolean, createdDate: any, lastModifiedDate: any, author: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string, provider?: string | null | undefined, model?: string | null | undefined, assessedAt: any, attemptCount: number } | null | undefined, rejectedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, approvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }> } };

export type RejectCommentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}>;


export type RejectCommentMutation = { __typename?: 'Mutation', rejectComment: { __typename?: 'ArticleComment', uuid: string, articleId: string, parentCommentId?: string | null | undefined, content: any, moderationStatus: CommentModerationStatus, rejectionReason?: string | null | undefined, totalReactions: number, editedAt?: any | null | undefined, hasPendingEdit: boolean, createdDate: any, lastModifiedDate: any, author: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string, provider?: string | null | undefined, model?: string | null | undefined, assessedAt: any, attemptCount: number } | null | undefined, rejectedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, approvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }> } };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'ArticleComment', uuid: string, articleId: string, parentCommentId?: string | null | undefined, content: any, moderationStatus: CommentModerationStatus, rejectionReason?: string | null | undefined, totalReactions: number, editedAt?: any | null | undefined, hasPendingEdit: boolean, createdDate: any, lastModifiedDate: any, author: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string, provider?: string | null | undefined, model?: string | null | undefined, assessedAt: any, attemptCount: number } | null | undefined, rejectedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, approvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }> } };

export type CommentListItemFragment = { __typename?: 'ArticleComment', uuid: string, articleId: string, parentCommentId?: string | null | undefined, content: any, moderationStatus: CommentModerationStatus, createdDate: any, lastModifiedDate: any, author: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string, provider?: string | null | undefined, model?: string | null | undefined, assessedAt: any, attemptCount: number } | null | undefined };

export type CommentDetailsFragment = { __typename?: 'ArticleComment', uuid: string, articleId: string, parentCommentId?: string | null | undefined, content: any, moderationStatus: CommentModerationStatus, rejectionReason?: string | null | undefined, totalReactions: number, editedAt?: any | null | undefined, hasPendingEdit: boolean, createdDate: any, lastModifiedDate: any, author: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string, provider?: string | null | undefined, model?: string | null | undefined, assessedAt: any, attemptCount: number } | null | undefined, rejectedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, approvedBy?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }> };

export type CommentActivityFieldsFragment = { __typename: 'CommentActivity', id: string, createdDate: any, articleId: string, articleSlug: string, articleSubject: string, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, comment: { __typename?: 'ArticleComment', uuid: string, content: any, moderationStatus: CommentModerationStatus, totalReactions: number, rejectionReason?: string | null | undefined, createdDate: any, editedAt?: any | null | undefined, author: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }> } };

export type ReactionActivityFieldsFragment = { __typename: 'ReactionActivity', id: string, createdDate: any, emoji: ReactionEmoji, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, target:
    | { __typename: 'Article', uuid: string, slug: string, subject: string }
    | { __typename: 'ArticleComment', uuid: string, articleId: string, content: any }
   };

export type ReviewCommentActivityFieldsFragment = { __typename: 'ReviewCommentActivity', id: string, createdDate: any, articleId: string, articleSubject: string, excerpt: string, hasSuggestion: boolean, isReply: boolean, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined } };

export type CommunityActivityStreamQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ActivityStreamFilter>;
}>;


export type CommunityActivityStreamQuery = { __typename?: 'Query', activityStream: { __typename?: 'ActivityPage', oldestCursor?: string | null | undefined, content: Array<
      | { __typename: 'CommentActivity', id: string, createdDate: any, articleId: string, articleSlug: string, articleSubject: string, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, comment: { __typename?: 'ArticleComment', uuid: string, content: any, moderationStatus: CommentModerationStatus, totalReactions: number, rejectionReason?: string | null | undefined, createdDate: any, editedAt?: any | null | undefined, author: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }> } }
      | { __typename: 'ReactionActivity', id: string, createdDate: any, emoji: ReactionEmoji, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, target:
          | { __typename: 'Article', uuid: string, slug: string, subject: string }
          | { __typename: 'ArticleComment', uuid: string, articleId: string, content: any }
         }
      | { __typename: 'ReviewCommentActivity', id: string, createdDate: any, articleId: string, articleSubject: string, excerpt: string, hasSuggestion: boolean, isReply: boolean, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined } }
    > } };

export type CommunityActivityIndicatorQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityActivityIndicatorQuery = { __typename?: 'Query', activityIndicator: { __typename?: 'ActivityIndicator', unreadCount: number, pendingModerationCount: number }, activityReadState: { __typename?: 'ActivityReadState', lastReadAt: any } };

export type MarkCommunityActivitiesReadUpToMutationVariables = Exact<{
  timestamp: Scalars['ZonedDateTime']['input'];
}>;


export type MarkCommunityActivitiesReadUpToMutation = { __typename?: 'Mutation', markActivitiesReadUpTo: { __typename?: 'ActivityIndicator', unreadCount: number, pendingModerationCount: number } };

export type CommunityActivityAddedSubscriptionVariables = Exact<{
  filter?: InputMaybe<ActivityStreamFilter>;
}>;


export type CommunityActivityAddedSubscription = { __typename?: 'Subscription', activityAdded:
    | { __typename: 'CommentActivity', id: string, createdDate: any, articleId: string, articleSlug: string, articleSubject: string, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, comment: { __typename?: 'ArticleComment', uuid: string, content: any, moderationStatus: CommentModerationStatus, totalReactions: number, rejectionReason?: string | null | undefined, createdDate: any, editedAt?: any | null | undefined, author: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }> } }
    | { __typename: 'ReactionActivity', id: string, createdDate: any, emoji: ReactionEmoji, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, target:
        | { __typename: 'Article', uuid: string, slug: string, subject: string }
        | { __typename: 'ArticleComment', uuid: string, articleId: string, content: any }
       }
    | { __typename: 'ReviewCommentActivity', id: string, createdDate: any, articleId: string, articleSubject: string, excerpt: string, hasSuggestion: boolean, isReply: boolean, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined } }
   };

export type CommunityActivityChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CommunityActivityChangedSubscription = { __typename?: 'Subscription', activityChanged:
    | { __typename: 'CommentActivity', id: string, createdDate: any, articleId: string, articleSlug: string, articleSubject: string, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, comment: { __typename?: 'ArticleComment', uuid: string, content: any, moderationStatus: CommentModerationStatus, totalReactions: number, rejectionReason?: string | null | undefined, createdDate: any, editedAt?: any | null | undefined, author: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, aiAssessment?: { __typename?: 'CommentAiAssessment', approved: boolean, confidence: number, reasoning: string } | null | undefined, reactionCounts: Array<{ __typename?: 'ReactionCount', emoji: ReactionEmoji, count: number }> } }
    | { __typename: 'ReactionActivity', id: string, createdDate: any, emoji: ReactionEmoji, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined }, target:
        | { __typename: 'Article', uuid: string, slug: string, subject: string }
        | { __typename: 'ArticleComment', uuid: string, articleId: string, content: any }
       }
    | { __typename: 'ReviewCommentActivity', id: string, createdDate: any, articleId: string, articleSubject: string, excerpt: string, hasSuggestion: boolean, isReply: boolean, actor: { __typename?: 'RevisionAuthor', userId: string, username?: string | null | undefined, displayName?: string | null | undefined } }
   };

export type CommunityActivityRemovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CommunityActivityRemovedSubscription = { __typename?: 'Subscription', activityRemoved: string };

export type CommunityActivityIndicatorChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CommunityActivityIndicatorChangedSubscription = { __typename?: 'Subscription', activityIndicatorChanged: { __typename?: 'ActivityIndicator', unreadCount: number, pendingModerationCount: number } };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, description?: string | null | undefined, websiteUrl?: string | null | undefined, wikipediaUrl?: string | null | undefined, foundingYear?: number | null | undefined, country?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, logo?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined } | null | undefined };

export type GetCompaniesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetCompaniesQuery = { __typename?: 'Query', allCompanies: { __typename?: 'CompanyPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> } };

export type FindCompaniesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindCompaniesQuery = { __typename?: 'Query', findCompanies: { __typename?: 'CompanyPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> } };

export type CreateCompanyMutationVariables = Exact<{
  create: CompanyCreateInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, description?: string | null | undefined, websiteUrl?: string | null | undefined, wikipediaUrl?: string | null | undefined, foundingYear?: number | null | undefined, country?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, logo?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined } };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: CompanyUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, description?: string | null | undefined, websiteUrl?: string | null | undefined, wikipediaUrl?: string | null | undefined, foundingYear?: number | null | undefined, country?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, logo?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined } };

export type MergeCompaniesMutationVariables = Exact<{
  targetId: Scalars['UUID']['input'];
  sourceId: Scalars['UUID']['input'];
  resolved: CompanyMergeInput;
}>;


export type MergeCompaniesMutation = { __typename?: 'Mutation', mergeCompanies: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, description?: string | null | undefined, websiteUrl?: string | null | undefined, wikipediaUrl?: string | null | undefined, foundingYear?: number | null | undefined, country?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, logo?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined } };

export type CompanyPageResultsFragment = { __typename?: 'CompanyPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> };

export type CompanyListItemFragment = { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined };

export type CompanyDetailsFragment = { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, description?: string | null | undefined, websiteUrl?: string | null | undefined, wikipediaUrl?: string | null | undefined, foundingYear?: number | null | undefined, country?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, logo?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined };

export type DeleteCompanyMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteCompany: { __typename?: 'Company', uuid: string, name: string } };

export type CreateCompanyInlineMutationVariables = Exact<{
  create: CompanyCreateInput;
}>;


export type CreateCompanyInlineMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } };

export type GetArticleStatsQueryVariables = Exact<{
  from: Scalars['ZonedDateTime']['input'];
  until: Scalars['ZonedDateTime']['input'];
}>;


export type GetArticleStatsQuery = { __typename?: 'Query', articleStats?: { __typename?: 'ArticleStats', totalCount?: number | null | undefined, newsCount?: number | null | undefined, testCount?: number | null | undefined, eventCount?: number | null | undefined, podcastCount?: number | null | undefined, communityCount?: number | null | undefined, kolumneCount?: number | null | undefined } | null | undefined };

export type EventListItemFragment = { __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined };

export type EventDetailsFragment = { __typename?: 'Event', uuid: string, name: string, slug: string, description?: any | null | undefined, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, websiteUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, teaserImage?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, openingHours: Array<{ __typename?: 'EventOpeningHours', date: import("../date").GraphqlDate, opens: import("../date").GraphqlTime, closes: import("../date").GraphqlTime, note?: string | null | undefined }>, venue?: { __typename?: 'EventVenue', name: string, street?: string | null | undefined, city: string, postalCode?: string | null | undefined, country: string, latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined } | null | undefined };

export type GetEventQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetEventQuery = { __typename?: 'Query', event?: { __typename?: 'Event', uuid: string, name: string, slug: string, description?: any | null | undefined, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, websiteUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, teaserImage?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, openingHours: Array<{ __typename?: 'EventOpeningHours', date: import("../date").GraphqlDate, opens: import("../date").GraphqlTime, closes: import("../date").GraphqlTime, note?: string | null | undefined }>, venue?: { __typename?: 'EventVenue', name: string, street?: string | null | undefined, city: string, postalCode?: string | null | undefined, country: string, latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined } | null | undefined } | null | undefined };

export type FindEventsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  kinds?: InputMaybe<Array<EventKind> | EventKind>;
  upcoming?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FindEventsQuery = { __typename?: 'Query', findEvents: { __typename?: 'EventPageResults', number: number, size: number, totalElements: number, totalPages: number, isFirst: boolean, isLast: boolean, hasNext: boolean, hasPrevious: boolean, content: Array<{ __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined }> } };

export type AllEventsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AllEventsQuery = { __typename?: 'Query', allEvents: { __typename?: 'EventPageResults', totalElements: number, content: Array<{ __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined }> } };

export type CreateEventMutationVariables = Exact<{
  create: EventCreateInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'Event', uuid: string, name: string, slug: string, description?: any | null | undefined, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, websiteUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, teaserImage?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, openingHours: Array<{ __typename?: 'EventOpeningHours', date: import("../date").GraphqlDate, opens: import("../date").GraphqlTime, closes: import("../date").GraphqlTime, note?: string | null | undefined }>, venue?: { __typename?: 'EventVenue', name: string, street?: string | null | undefined, city: string, postalCode?: string | null | undefined, country: string, latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined } | null | undefined } };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: EventUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'Event', uuid: string, name: string, slug: string, description?: any | null | undefined, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, websiteUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, teaserImage?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, openingHours: Array<{ __typename?: 'EventOpeningHours', date: import("../date").GraphqlDate, opens: import("../date").GraphqlTime, closes: import("../date").GraphqlTime, note?: string | null | undefined }>, venue?: { __typename?: 'EventVenue', name: string, street?: string | null | undefined, city: string, postalCode?: string | null | undefined, country: string, latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined, createdBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined } | null | undefined, lastModifiedBy?: { __typename?: 'RevisionAuthor', userId: string, displayName?: string | null | undefined } | null | undefined } };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: { __typename?: 'Event', uuid: string, name: string } };

export type EditSessionFragment = { __typename?: 'EditSession', sessionId: string, userSub: string, displayName: string, startedAt: any, dirty: boolean, own: boolean };

export type EditSessionsQueryVariables = Exact<{
  entityType: EditSessionEntityType;
  entityId: Scalars['ID']['input'];
}>;


export type EditSessionsQuery = { __typename?: 'Query', editSessions: Array<{ __typename?: 'EditSession', sessionId: string, userSub: string, displayName: string, startedAt: any, dirty: boolean, own: boolean }> };

export type EditSessionHeartbeatMutationVariables = Exact<{
  entityType: EditSessionEntityType;
  entityId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  dirty: Scalars['Boolean']['input'];
}>;


export type EditSessionHeartbeatMutation = { __typename?: 'Mutation', editSessionHeartbeat: Array<{ __typename?: 'EditSession', sessionId: string, userSub: string, displayName: string, startedAt: any, dirty: boolean, own: boolean }> };

export type EndEditSessionMutationVariables = Exact<{
  entityType: EditSessionEntityType;
  entityId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;


export type EndEditSessionMutation = { __typename?: 'Mutation', endEditSession: boolean };

export type GetGameConsoleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetGameConsoleQuery = { __typename?: 'Query', gameConsole?: { __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, logo?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined } | null | undefined };

export type GetGameConsolesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetGameConsolesQuery = { __typename?: 'Query', allGameConsoles: { __typename?: 'GameConsolePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> } };

export type FindGameConsolesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  examples?: InputMaybe<Array<GameConsoleExampleInput> | GameConsoleExampleInput>;
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindGameConsolesQuery = { __typename?: 'Query', findGameConsoles: { __typename?: 'GameConsolePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> } };

export type CreateGameConsoleMutationVariables = Exact<{
  create: GameConsoleCreateInput;
}>;


export type CreateGameConsoleMutation = { __typename?: 'Mutation', createGameConsole: { __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, logo?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined } };

export type UpdateGameConsoleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: GameConsoleUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateGameConsoleMutation = { __typename?: 'Mutation', updateGameConsole: { __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, logo?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined } };

export type GameConsolePageResultsFragment = { __typename?: 'GameConsolePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> };

export type GameConsoleListItemFragment = { __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined };

export type GameConsoleDetailsFragment = { __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number, logo?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined };

export type DeleteGameConsoleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteGameConsoleMutation = { __typename?: 'Mutation', deleteGameConsole: { __typename?: 'GameConsole', uuid: string, name: string } };

export type GetGameQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetGameQuery = { __typename?: 'Query', game?: { __typename?: 'Game', uuid: string, name: string, viewerCanDelete: boolean, viewerCanEdit: boolean, alternativeName?: string | null | undefined, acronym?: string | null | undefined, gameModes: Array<GameMode>, additionalInformations?: string | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, entityVersion: number, localPlayerCount?: { __typename?: 'PlayerCount', min?: number | null | undefined, max?: number | null | undefined } | null | undefined, onlinePlayerCount?: { __typename?: 'PlayerCount', min?: number | null | undefined, max?: number | null | undefined } | null | undefined, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, relatedGames: Array<{ __typename?: 'GameRelation', type: GameRelationType, game: { __typename?: 'Game', uuid: string, name: string } }>, inverseRelatedGames: Array<{ __typename?: 'GameRelation', type: GameRelationType, game: { __typename?: 'Game', uuid: string, name: string } }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, consoleEditions: Array<{ __typename?: 'ConsoleEdition', releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, packaging: Array<Packaging>, packagingJapan: Array<Packaging>, packagingUnitedStates: Array<Packaging>, packagingEurope: Array<Packaging>, packagingGermany: Array<Packaging>, amazonUrl?: string | null | undefined, overridePublisher: boolean, overrideDeveloper: boolean, overrideRatings: boolean, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, gameConsole: { __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }> } | null | undefined };

export type GetGamesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetGamesQuery = { __typename?: 'Query', allGames: { __typename?: 'GamePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }> } };

export type FindGamesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  examples?: InputMaybe<Array<GameExampleInput> | GameExampleInput>;
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindGamesQuery = { __typename?: 'Query', findGames: { __typename?: 'GamePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }> } };

export type CreateGameMutationVariables = Exact<{
  create: GameCreateInput;
}>;


export type CreateGameMutation = { __typename?: 'Mutation', createGame: { __typename?: 'Game', uuid: string, name: string, viewerCanDelete: boolean, viewerCanEdit: boolean, alternativeName?: string | null | undefined, acronym?: string | null | undefined, gameModes: Array<GameMode>, additionalInformations?: string | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, entityVersion: number, localPlayerCount?: { __typename?: 'PlayerCount', min?: number | null | undefined, max?: number | null | undefined } | null | undefined, onlinePlayerCount?: { __typename?: 'PlayerCount', min?: number | null | undefined, max?: number | null | undefined } | null | undefined, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, relatedGames: Array<{ __typename?: 'GameRelation', type: GameRelationType, game: { __typename?: 'Game', uuid: string, name: string } }>, inverseRelatedGames: Array<{ __typename?: 'GameRelation', type: GameRelationType, game: { __typename?: 'Game', uuid: string, name: string } }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, consoleEditions: Array<{ __typename?: 'ConsoleEdition', releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, packaging: Array<Packaging>, packagingJapan: Array<Packaging>, packagingUnitedStates: Array<Packaging>, packagingEurope: Array<Packaging>, packagingGermany: Array<Packaging>, amazonUrl?: string | null | undefined, overridePublisher: boolean, overrideDeveloper: boolean, overrideRatings: boolean, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, gameConsole: { __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }> } };

export type UpdateGameMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: GameUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateGameMutation = { __typename?: 'Mutation', updateGame: { __typename?: 'Game', uuid: string, name: string, viewerCanDelete: boolean, viewerCanEdit: boolean, alternativeName?: string | null | undefined, acronym?: string | null | undefined, gameModes: Array<GameMode>, additionalInformations?: string | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, entityVersion: number, localPlayerCount?: { __typename?: 'PlayerCount', min?: number | null | undefined, max?: number | null | undefined } | null | undefined, onlinePlayerCount?: { __typename?: 'PlayerCount', min?: number | null | undefined, max?: number | null | undefined } | null | undefined, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, relatedGames: Array<{ __typename?: 'GameRelation', type: GameRelationType, game: { __typename?: 'Game', uuid: string, name: string } }>, inverseRelatedGames: Array<{ __typename?: 'GameRelation', type: GameRelationType, game: { __typename?: 'Game', uuid: string, name: string } }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, consoleEditions: Array<{ __typename?: 'ConsoleEdition', releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, packaging: Array<Packaging>, packagingJapan: Array<Packaging>, packagingUnitedStates: Array<Packaging>, packagingEurope: Array<Packaging>, packagingGermany: Array<Packaging>, amazonUrl?: string | null | undefined, overridePublisher: boolean, overrideDeveloper: boolean, overrideRatings: boolean, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, gameConsole: { __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }> } };

export type DeleteGameMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteGameMutation = { __typename?: 'Mutation', deleteGame: { __typename?: 'Game', uuid: string, name: string } };

export type GamePageResultsFragment = { __typename?: 'GamePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }> };

export type GameListItemFragment = { __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined };

export type GameDetailsFragment = { __typename?: 'Game', uuid: string, name: string, viewerCanDelete: boolean, viewerCanEdit: boolean, alternativeName?: string | null | undefined, acronym?: string | null | undefined, gameModes: Array<GameMode>, additionalInformations?: string | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, entityVersion: number, localPlayerCount?: { __typename?: 'PlayerCount', min?: number | null | undefined, max?: number | null | undefined } | null | undefined, onlinePlayerCount?: { __typename?: 'PlayerCount', min?: number | null | undefined, max?: number | null | undefined } | null | undefined, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, relatedGames: Array<{ __typename?: 'GameRelation', type: GameRelationType, game: { __typename?: 'Game', uuid: string, name: string } }>, inverseRelatedGames: Array<{ __typename?: 'GameRelation', type: GameRelationType, game: { __typename?: 'Game', uuid: string, name: string } }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, consoleEditions: Array<{ __typename?: 'ConsoleEdition', releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, packaging: Array<Packaging>, packagingJapan: Array<Packaging>, packagingUnitedStates: Array<Packaging>, packagingEurope: Array<Packaging>, packagingGermany: Array<Packaging>, amazonUrl?: string | null | undefined, overridePublisher: boolean, overrideDeveloper: boolean, overrideRatings: boolean, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, gameConsole: { __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }> };

export type PlayerCountFragment = { __typename?: 'PlayerCount', min?: number | null | undefined, max?: number | null | undefined };

export type GetGameSeriesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetGameSeriesQuery = { __typename?: 'Query', gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } | null | undefined };

export type GetAllGameSeriesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetAllGameSeriesQuery = { __typename?: 'Query', allGameSeries: { __typename?: 'GameSeriesPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }> } };

export type FindGameSeriesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindGameSeriesQuery = { __typename?: 'Query', findGameSeries: { __typename?: 'GameSeriesPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }> } };

export type CreateGameSeriesMutationVariables = Exact<{
  create: GameSeriesCreateInput;
}>;


export type CreateGameSeriesMutation = { __typename?: 'Mutation', createGameSeries: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } };

export type UpdateGameSeriesMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: GameSeriesUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateGameSeriesMutation = { __typename?: 'Mutation', updateGameSeries: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } };

export type GameSeriesPageResultsFragment = { __typename?: 'GameSeriesPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }> };

export type GameSeriesListItemFragment = { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean };

export type GameSeriesDetailsFragment = { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number };

export type DeleteGameSeriesMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteGameSeriesMutation = { __typename?: 'Mutation', deleteGameSeries: { __typename?: 'GameSeries', uuid: string, name: string } };

export type GetGenreQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetGenreQuery = { __typename?: 'Query', genre?: { __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } | null | undefined };

export type GetGenresQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetGenresQuery = { __typename?: 'Query', allGenres: { __typename?: 'GenrePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }> } };

export type FindGenresQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindGenresQuery = { __typename?: 'Query', findGenres: { __typename?: 'GenrePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }> } };

export type CreateGenreMutationVariables = Exact<{
  create: GenreCreateInput;
}>;


export type CreateGenreMutation = { __typename?: 'Mutation', createGenre: { __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } };

export type UpdateGenreMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: GenreUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateGenreMutation = { __typename?: 'Mutation', updateGenre: { __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } };

export type GenrePageResultsFragment = { __typename?: 'GenrePageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }> };

export type GenreListItemFragment = { __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean };

export type GenreDetailsFragment = { __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number };

export type DeleteGenreMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteGenreMutation = { __typename?: 'Mutation', deleteGenre: { __typename?: 'Genre', uuid: string, name: string } };

export type RevisionAuthorFragment = { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string };

export type ChangesByCommitFragment = { __typename?: 'ChangesByCommit', summary: string, commit: { __typename?: 'CommitMetadata', id: string, commitDate: any, author?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined }, changes: Array<
    | { __typename?: 'ArrayChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
    | { __typename?: 'ListChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
    | { __typename?: 'MapChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
    | { __typename?: 'NewObjectChange' }
    | { __typename?: 'ObjectRemovedChange' }
    | { __typename?: 'SetChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
    | { __typename?: 'ValueChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined }
  > };

export type CommitMetadataFragment = { __typename?: 'CommitMetadata', id: string, commitDate: any, author?: { __typename?: 'RevisionAuthor', username?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, userId: string } | null | undefined };

type Change_ArrayChange_Fragment = { __typename?: 'ArrayChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

type Change_ListChange_Fragment = { __typename?: 'ListChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

type Change_MapChange_Fragment = { __typename?: 'MapChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

type Change_NewObjectChange_Fragment = { __typename?: 'NewObjectChange' };

type Change_ObjectRemovedChange_Fragment = { __typename?: 'ObjectRemovedChange' };

type Change_SetChange_Fragment = { __typename?: 'SetChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

type Change_ValueChange_Fragment = { __typename?: 'ValueChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

export type ChangeFragment =
  | Change_ArrayChange_Fragment
  | Change_ListChange_Fragment
  | Change_MapChange_Fragment
  | Change_NewObjectChange_Fragment
  | Change_ObjectRemovedChange_Fragment
  | Change_SetChange_Fragment
  | Change_ValueChange_Fragment
;

export type ValueChangeFragment = { __typename?: 'ValueChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

export type MapChangeFragment = { __typename?: 'MapChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

export type ListChangeFragment = { __typename?: 'ListChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

export type ArrayChangeFragment = { __typename?: 'ArrayChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

export type SetChangeFragment = { __typename?: 'SetChange', propertyName: string, left?: any | null | undefined, right?: any | null | undefined };

export type GetMediaQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMediaQuery = { __typename?: 'Query', media?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, copyright?: string | null | undefined, copyrightUrl?: string | null | undefined, license?: string | null | undefined, licenseUrl?: string | null | undefined, sourceUrl?: string | null | undefined, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, entityVersion: number, previewUrl256?: string | null | undefined, previewUrl374?: string | null | undefined, previewUrl822?: string | null | undefined, nonWatermarkPreviewUrl374?: string | null | undefined, nonWatermarkPreviewUrl822?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> } | null | undefined };

export type GetMediasQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetMediasQuery = { __typename?: 'Query', allMedia: { __typename?: 'MediaPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }> } };

export type FindMediasQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  examples?: InputMaybe<Array<MediaExampleInput> | MediaExampleInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FindMediasQuery = { __typename?: 'Query', findMedia: { __typename?: 'MediaPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }> } };

export type UpdateMediaMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: MediaUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateMediaMutation = { __typename?: 'Mutation', updateMedia: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, copyright?: string | null | undefined, copyrightUrl?: string | null | undefined, license?: string | null | undefined, licenseUrl?: string | null | undefined, sourceUrl?: string | null | undefined, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, entityVersion: number, previewUrl256?: string | null | undefined, previewUrl374?: string | null | undefined, previewUrl822?: string | null | undefined, nonWatermarkPreviewUrl374?: string | null | undefined, nonWatermarkPreviewUrl822?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> } };

export type DeleteMediaMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteMediaMutation = { __typename?: 'Mutation', deleteMedia: { __typename?: 'Media', uuid: string } };

export type MediaPageResultsFragment = { __typename?: 'MediaPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> }> };

export type MediaListItemFragment = { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> };

export type MediaDetailsFragment = { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, copyright?: string | null | undefined, copyrightUrl?: string | null | undefined, license?: string | null | undefined, licenseUrl?: string | null | undefined, sourceUrl?: string | null | undefined, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, entityVersion: number, previewUrl256?: string | null | undefined, previewUrl374?: string | null | undefined, previewUrl822?: string | null | undefined, nonWatermarkPreviewUrl374?: string | null | undefined, nonWatermarkPreviewUrl822?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> };

export type MediaBatchEditItemFragment = { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, copyright?: string | null | undefined, copyrightUrl?: string | null | undefined, license?: string | null | undefined, licenseUrl?: string | null | undefined, sourceUrl?: string | null | undefined, watermark: boolean, viewerCanEdit: boolean, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> };

export type FindMediasForBatchEditQueryVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type FindMediasForBatchEditQuery = { __typename?: 'Query', findMedia: { __typename?: 'MediaPageResults', totalElements: number, content: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, copyright?: string | null | undefined, copyrightUrl?: string | null | undefined, license?: string | null | undefined, licenseUrl?: string | null | undefined, sourceUrl?: string | null | undefined, watermark: boolean, viewerCanEdit: boolean, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }> }> } };

export type GetQuickFilterQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetQuickFilterQuery = { __typename?: 'Query', quickFilter?: { __typename?: 'QuickFilter', entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, filters: { __typename?: 'ArticleFilterPreset', kind: Array<ArticleKind>, excludeKind: Array<ArticleKind>, after?: any | null | undefined, before?: any | null | undefined, order?: Array<string> | null | undefined, game: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsole: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, genre: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, company: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, event: Array<{ __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined }>, author: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, tag: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries: Array<{ __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean }> } } | null | undefined };

export type GetQuickFiltersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetQuickFiltersQuery = { __typename?: 'Query', allQuickFilters: { __typename?: 'QuickFilterPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'QuickFilter', uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, viewerCanEdit: boolean }> } };

export type FindQuickFiltersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  visibleOn?: InputMaybe<ArticleListPage>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindQuickFiltersQuery = { __typename?: 'Query', findQuickFilters: { __typename?: 'QuickFilterPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'QuickFilter', uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, viewerCanEdit: boolean }> } };

export type CreateQuickFilterMutationVariables = Exact<{
  create: QuickFilterCreateInput;
}>;


export type CreateQuickFilterMutation = { __typename?: 'Mutation', createQuickFilter: { __typename?: 'QuickFilter', entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, filters: { __typename?: 'ArticleFilterPreset', kind: Array<ArticleKind>, excludeKind: Array<ArticleKind>, after?: any | null | undefined, before?: any | null | undefined, order?: Array<string> | null | undefined, game: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsole: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, genre: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, company: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, event: Array<{ __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined }>, author: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, tag: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries: Array<{ __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean }> } } };

export type UpdateQuickFilterMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: QuickFilterUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateQuickFilterMutation = { __typename?: 'Mutation', updateQuickFilter: { __typename?: 'QuickFilter', entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, filters: { __typename?: 'ArticleFilterPreset', kind: Array<ArticleKind>, excludeKind: Array<ArticleKind>, after?: any | null | undefined, before?: any | null | undefined, order?: Array<string> | null | undefined, game: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsole: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, genre: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, company: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, event: Array<{ __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined }>, author: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, tag: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries: Array<{ __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean }> } } };

export type ReorderQuickFiltersMutationVariables = Exact<{
  orderedIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ReorderQuickFiltersMutation = { __typename?: 'Mutation', reorderQuickFilters: Array<{ __typename?: 'QuickFilter', uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, viewerCanEdit: boolean }> };

export type DeleteQuickFilterMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteQuickFilterMutation = { __typename?: 'Mutation', deleteQuickFilter: { __typename?: 'QuickFilter', uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, viewerCanEdit: boolean } };

export type QuickFilterListItemFragment = { __typename?: 'QuickFilter', uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, viewerCanEdit: boolean };

export type QuickFilterDetailsFragment = { __typename?: 'QuickFilter', entityVersion: number, createdDate: any, lastModifiedDate: any, viewerCanDelete: boolean, viewerCanEdit: boolean, uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, filters: { __typename?: 'ArticleFilterPreset', kind: Array<ArticleKind>, excludeKind: Array<ArticleKind>, after?: any | null | undefined, before?: any | null | undefined, order?: Array<string> | null | undefined, game: Array<{ __typename?: 'Game', uuid: string, name: string, alternativeName?: string | null | undefined, acronym?: string | null | undefined, viewerCanEdit: boolean, gameModes: Array<GameMode>, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined, cover?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined } | null | undefined, images: Array<{ __typename?: 'Media', uuid: string, filename: string, mediaType: string, previewUrl?: string | null | undefined }>, genres: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameSeries?: { __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean } | null | undefined, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, publisher?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined, developer?: { __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, gameConsole: Array<{ __typename?: 'GameConsole', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean, type: GameConsoleType, releaseDate?: import("../date").GraphqlDate | null | undefined, releaseDateEurope?: import("../date").GraphqlDate | null | undefined, releaseDateGermany?: import("../date").GraphqlDate | null | undefined, releaseDateJapan?: import("../date").GraphqlDate | null | undefined, releaseDateUnitedStates?: import("../date").GraphqlDate | null | undefined, showInDatabaseView: boolean, archived: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, genre: Array<{ __typename?: 'Genre', uuid: string, name: string, acronym?: string | null | undefined, viewerCanEdit: boolean }>, company: Array<{ __typename?: 'Company', uuid: string, name: string, acronym?: string | null | undefined, slug?: string | null | undefined, viewerCanEdit: boolean, logo?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined }>, event: Array<{ __typename?: 'Event', uuid: string, name: string, slug: string, viewerCanEdit: boolean, kind: EventKind, startsAt: any, endsAt?: any | null | undefined, allDay: boolean, timeZone: string, onlineUrl?: string | null | undefined, showOnHomepage: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, lastModifiedDate: any, venue?: { __typename?: 'EventVenue', name: string, city: string, country: string } | null | undefined }>, author: Array<{ __typename?: 'Author', uuid: string, name: string, email?: string | null | undefined, title?: string | null | undefined, isProfilePublic: boolean, isActive: boolean, viewerCanEdit: boolean, linkedUsers: Array<{ __typename?: 'LinkedUser', sub: string, displayName?: string | null | undefined, email?: string | null | undefined, isPrimary: boolean }> }>, tag: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }>, articleSeries: Array<{ __typename?: 'ArticleSeries', uuid: string, name: string, slug: string, showInSlider: boolean, showUntil?: import("../date").GraphqlDate | null | undefined, viewerCanEdit: boolean }> } };

export type QuickFilterPageResultsFragment = { __typename?: 'QuickFilterPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'QuickFilter', uuid: string, slug: string, label: string, icon: QuickFilterIcon, visibleOn: Array<ArticleListPage>, enabled: boolean, visibleFrom?: any | null | undefined, visibleUntil?: any | null | undefined, sortIndex: number, viewerCanEdit: boolean }> };

export type GetRatingCategoryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetRatingCategoryQuery = { __typename?: 'Query', ratingCategory?: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } | null | undefined };

export type GetRatingCategoriesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetRatingCategoriesQuery = { __typename?: 'Query', allRatingCategories: { __typename?: 'RatingCategoryPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean }> } };

export type GetRatingCategoryDetailsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetRatingCategoryDetailsQuery = { __typename?: 'Query', allRatingCategories: { __typename?: 'RatingCategoryPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number }> } };

export type FindRatingCategoriesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindRatingCategoriesQuery = { __typename?: 'Query', findRatingCategories: { __typename?: 'RatingCategoryPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean }> } };

export type CreateRatingCategoryMutationVariables = Exact<{
  create: RatingCategoryCreateInput;
}>;


export type CreateRatingCategoryMutation = { __typename?: 'Mutation', createRatingCategory: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } };

export type UpdateRatingCategoryMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: RatingCategoryUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateRatingCategoryMutation = { __typename?: 'Mutation', updateRatingCategory: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } };

export type DeleteRatingCategoryMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteRatingCategoryMutation = { __typename?: 'Mutation', deleteRatingCategory: { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean } };

export type RatingCategoryPageResultsFragment = { __typename?: 'RatingCategoryPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean }> };

export type RatingCategoryDetailsPageResultsFragment = { __typename?: 'RatingCategoryPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number }> };

export type RatingCategoryListItemFragment = { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, viewerCanEdit: boolean };

export type RatingCategoryDetailsFragment = { __typename?: 'RatingCategory', uuid: string, name: string, min: number, max: number, step: number, required: boolean, order: number, articleSpecific: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number };

export type AdminSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  groups: Array<AdminSearchGroupInput> | AdminSearchGroupInput;
}>;


export type AdminSearchQuery = { __typename?: 'Query', adminSearch: { __typename?: 'AdminSearchResponse', query: string, groups: Array<{ __typename?: 'AdminSearchGroupResult', key: string, totalHits: number, page: number, size: number, results: Array<{ __typename?: 'AdminSearchResult', id: string, slug: string, type: SearchType, headline: string, text?: string | null | undefined, image?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined, details?:
          | { __typename: 'ArticleSearchDetails', publicationDateTime?: any | null | undefined, publishedState?: string | null | undefined, articleKind: ArticleKind }
          | { __typename: 'ArticleSeriesSearchDetails', showInSlider: boolean }
          | { __typename: 'AuthorSearchDetails', title?: string | null | undefined }
          | { __typename: 'CompanySearchDetails', acronym?: string | null | undefined }
          | { __typename: 'EventSearchDetails', startsAt?: any | null | undefined, endsAt?: any | null | undefined, eventKind: EventKind }
          | { __typename: 'GameConsoleSearchDetails', acronym?: string | null | undefined, releaseDate?: import("../date").GraphqlDate | null | undefined }
          | { __typename: 'GameSearchDetails', acronym?: string | null | undefined, releaseDate?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined }
          | { __typename: 'GameSeriesSearchDetails', acronym?: string | null | undefined }
          | { __typename: 'MediaSearchDetails', mediaType: string, filename: string }
          | { __typename: 'TagSearchDetails', text: string }
         | null | undefined }> }> } };

export type AdminSearchResultItemFragment = { __typename?: 'AdminSearchResult', id: string, slug: string, type: SearchType, headline: string, text?: string | null | undefined, image?: { __typename?: 'Media', previewUrl?: string | null | undefined } | null | undefined, details?:
    | { __typename: 'ArticleSearchDetails', publicationDateTime?: any | null | undefined, publishedState?: string | null | undefined, articleKind: ArticleKind }
    | { __typename: 'ArticleSeriesSearchDetails', showInSlider: boolean }
    | { __typename: 'AuthorSearchDetails', title?: string | null | undefined }
    | { __typename: 'CompanySearchDetails', acronym?: string | null | undefined }
    | { __typename: 'EventSearchDetails', startsAt?: any | null | undefined, endsAt?: any | null | undefined, eventKind: EventKind }
    | { __typename: 'GameConsoleSearchDetails', acronym?: string | null | undefined, releaseDate?: import("../date").GraphqlDate | null | undefined }
    | { __typename: 'GameSearchDetails', acronym?: string | null | undefined, releaseDate?: import("../date").GraphqlDate | null | undefined, usk?: number | null | undefined, pegi?: number | null | undefined, esrb?: EsrbRating | null | undefined }
    | { __typename: 'GameSeriesSearchDetails', acronym?: string | null | undefined }
    | { __typename: 'MediaSearchDetails', mediaType: string, filename: string }
    | { __typename: 'TagSearchDetails', text: string }
   | null | undefined };

export type GetArticleStatisticsQueryVariables = Exact<{
  filter: ArticleStatisticsFilter;
}>;


export type GetArticleStatisticsQuery = { __typename?: 'Query', articleStatistics: { __typename?: 'ArticleStatistics', avgLeadTimeHours?: number | null | undefined, timeSeries: Array<{ __typename?: 'StatisticsTimeBucket', bucketStart: any, total: number, byKind: Array<{ __typename?: 'StatisticsKindCount', kind: ArticleKind, count: number }> }>, byKind: Array<{ __typename?: 'StatisticsKindCount', kind: ArticleKind, count: number }>, byEditor: Array<{ __typename?: 'StatisticsEditorCount', id: string, label: string, count: number }>, topGames: Array<{ __typename?: 'StatisticsTopic', id: string, label: string, count: number }>, topTags: Array<{ __typename?: 'StatisticsTopic', id: string, label: string, count: number }>, topGenres: Array<{ __typename?: 'StatisticsTopic', id: string, label: string, count: number }>, pipeline: { __typename?: 'StatisticsPipeline', draftCount: number, inReviewCount: number }, comparison: { __typename?: 'StatisticsComparison', total: number, byKind: Array<{ __typename?: 'StatisticsKindCount', kind: ArticleKind, count: number }> } } };

export type TriggerScheduleArticleIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleArticleIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleArticleIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleArticleReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleArticleReindexingMutation = { __typename?: 'Mutation', scheduleArticleReindexing: number };

export type TriggerScheduleArticleSeriesIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleArticleSeriesIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleArticleSeriesIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleArticleSeriesReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleArticleSeriesReindexingMutation = { __typename?: 'Mutation', scheduleArticleSeriesReindexing: number };

export type TriggerScheduleEventIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleEventIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleEventIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleEventReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleEventReindexingMutation = { __typename?: 'Mutation', scheduleEventReindexing: number };

export type TriggerScheduleCompanyIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleCompanyIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleCompanyIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleCompanyReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleCompanyReindexingMutation = { __typename?: 'Mutation', scheduleCompanyReindexing: number };

export type TriggerScheduleGameConsoleIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleGameConsoleIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleGameConsoleIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleGameConsoleReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleGameConsoleReindexingMutation = { __typename?: 'Mutation', scheduleGameConsoleReindexing: number };

export type TriggerScheduleGameIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleGameIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleGameIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleGameReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleGameReindexingMutation = { __typename?: 'Mutation', scheduleGameReindexing: number };

export type TriggerScheduleGameSeriesIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleGameSeriesIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleGameSeriesIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleGameSeriesReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleGameSeriesReindexingMutation = { __typename?: 'Mutation', scheduleGameSeriesReindexing: number };

export type TriggerScheduleGenreIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleGenreIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleGenreIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleGenreReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleGenreReindexingMutation = { __typename?: 'Mutation', scheduleGenreReindexing: number };

export type TriggerScheduleMediaIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleMediaIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleMediaIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleMediaReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleMediaReindexingMutation = { __typename?: 'Mutation', scheduleMediaReindexing: number };

export type TriggerScheduleRatingCategoryIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleRatingCategoryIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleRatingCategoryIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleRatingCategoryReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleRatingCategoryReindexingMutation = { __typename?: 'Mutation', scheduleRatingCategoryReindexing: number };

export type TriggerScheduleTagIndexerUpdatesMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleTagIndexerUpdatesMutation = { __typename?: 'Mutation', scheduleTagIndexing: { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined } };

export type TriggerScheduleTagReindexingMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerScheduleTagReindexingMutation = { __typename?: 'Mutation', scheduleTagReindexing: number };

export type SubscribeToArticleIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToArticleIndexerStatusSubscription = { __typename?: 'Subscription', articleIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToArticleSeriesIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToArticleSeriesIndexerStatusSubscription = { __typename?: 'Subscription', articleSeriesIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToEventIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToEventIndexerStatusSubscription = { __typename?: 'Subscription', eventIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToCompanyIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToCompanyIndexerStatusSubscription = { __typename?: 'Subscription', companyIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToGameConsoleIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToGameConsoleIndexerStatusSubscription = { __typename?: 'Subscription', gameConsoleIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToGameIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToGameIndexerStatusSubscription = { __typename?: 'Subscription', gameIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToGameSeriesIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToGameSeriesIndexerStatusSubscription = { __typename?: 'Subscription', gameSeriesIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToGenreIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToGenreIndexerStatusSubscription = { __typename?: 'Subscription', genreIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToMediaIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToMediaIndexerStatusSubscription = { __typename?: 'Subscription', mediaIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToRatingCategoryIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToRatingCategoryIndexerStatusSubscription = { __typename?: 'Subscription', ratingCategoryIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type SubscribeToTagIndexerStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToTagIndexerStatusSubscription = { __typename?: 'Subscription', tagIndexerStatus: { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined } };

export type IndexerStatusFragment = { __typename?: 'IndexerStatus', queued?: number | null | undefined, running?: number | null | undefined, indexed?: number | null | undefined, total?: number | null | undefined };

export type ScheduleResultFragment = { __typename?: 'ScheduleResult', creates?: number | null | undefined, updates?: number | null | undefined, deletes?: number | null | undefined };

export type GetTagQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTagQuery = { __typename?: 'Query', tag?: { __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } | null | undefined };

export type GetTagsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetTagsQuery = { __typename?: 'Query', allTags: { __typename?: 'TagPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }> } };

export type FindTagsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  examples?: InputMaybe<Array<TagExampleInput> | TagExampleInput>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindTagsQuery = { __typename?: 'Query', findTags: { __typename?: 'TagPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }> } };

export type CreateTagMutationVariables = Exact<{
  create: TagCreateInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  update: TagUpdateInput;
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number } };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean } };

export type TagPageResultsFragment = { __typename?: 'TagPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean }> };

export type TagListItemFragment = { __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanEdit: boolean };

export type TagDetailsFragment = { __typename?: 'Tag', uuid: string, text: string, normalizedText: string, color?: string | null | undefined, contrastColor?: string | null | undefined, viewerCanDelete: boolean, viewerCanEdit: boolean, entityVersion: number };

export type PrepareUploadMutationVariables = Exact<{
  input: PrepareUploadInput;
}>;


export type PrepareUploadMutation = { __typename?: 'Mutation', prepareUpload: { __typename?: 'Upload', uuid: string, parts: Array<{ __typename?: 'UploadPart', number: number, uploadUrl: string }> } };

export type UploadUuidAndPartNumberWithUploadUrlFragment = { __typename?: 'Upload', uuid: string, parts: Array<{ __typename?: 'UploadPart', number: number, uploadUrl: string }> };

export type UploadPartNumberAndUploadUrlFragment = { __typename?: 'UploadPart', number: number, uploadUrl: string };

export type ImportMediaMutationVariables = Exact<{
  url: Scalars['String']['input'];
  games?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  gameSeries?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  gameConsoles?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  companies?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type ImportMediaMutation = { __typename?: 'Mutation', importMedia?: { __typename?: 'Media', uuid: string, filename: string, mediaType: string, length: number, watermark: boolean, viewerCanDelete: boolean, viewerCanEdit: boolean, createdDate: any, lastModifiedDate: any, previewUrl48?: string | null | undefined, previewUrl64?: string | null | undefined, previewUrl128?: string | null | undefined, previewUrl192?: string | null | undefined, previewUrl256?: string | null | undefined, previewUrl110?: string | null | undefined, previewUrl140?: string | null | undefined, previewUrl190?: string | null | undefined, previewUrl260?: string | null | undefined, previewUrl410?: string | null | undefined, tags: Array<{ __typename?: 'Tag', uuid: string, text: string, color?: string | null | undefined, contrastColor?: string | null | undefined }>, companies: Array<{ __typename?: 'Company', uuid: string, name: string, viewerCanEdit: boolean }>, gameSeries: Array<{ __typename?: 'GameSeries', uuid: string, name: string, viewerCanEdit: boolean }>, games: Array<{ __typename?: 'Game', uuid: string, name: string }>, gameConsoles: Array<{ __typename?: 'GameConsole', uuid: string, name: string }> } | null | undefined };

export type UserListItemFragment = { __typename?: 'User', sub: string, loginName?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, emailVerified: boolean, state: UserState, classification: UserClassification, roles: Array<Role>, createdDate?: any | null | undefined, lastModifiedDate?: any | null | undefined, linkedAuthors: Array<{ __typename?: 'LinkedAuthor', id: string, displayName: string, isPrimary: boolean }> };

export type FindUsersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  examples?: InputMaybe<Array<UserExampleInput> | UserExampleInput>;
}>;


export type FindUsersQuery = { __typename?: 'Query', findUsers: { __typename?: 'UserPageResults', page: number, limit: number, total: number, totalPages: number, results: Array<{ __typename?: 'User', sub: string, loginName?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, emailVerified: boolean, state: UserState, classification: UserClassification, roles: Array<Role>, createdDate?: any | null | undefined, lastModifiedDate?: any | null | undefined, linkedAuthors: Array<{ __typename?: 'LinkedAuthor', id: string, displayName: string, isPrimary: boolean }> }> } };

export type UserDetailFragment = { __typename?: 'User', sub: string, loginName?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, state: UserState, classification: UserClassification, roles: Array<Role>, unknownRoleKeys: Array<string>, linkedAuthors: Array<{ __typename?: 'LinkedAuthor', id: string, displayName: string, isPrimary: boolean }> };

export type UserQueryVariables = Exact<{
  sub: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', sub: string, loginName?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, state: UserState, classification: UserClassification, roles: Array<Role>, unknownRoleKeys: Array<string>, linkedAuthors: Array<{ __typename?: 'LinkedAuthor', id: string, displayName: string, isPrimary: boolean }> } | null | undefined };

export type SetUserRolesMutationVariables = Exact<{
  sub: Scalars['ID']['input'];
  roles: Array<Role> | Role;
}>;


export type SetUserRolesMutation = { __typename?: 'Mutation', setUserRoles: { __typename?: 'User', sub: string, loginName?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, state: UserState, classification: UserClassification, roles: Array<Role>, unknownRoleKeys: Array<string>, linkedAuthors: Array<{ __typename?: 'LinkedAuthor', id: string, displayName: string, isPrimary: boolean }> } };

export type FindYouTubeVideosQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindYouTubeVideosQuery = { __typename?: 'Query', findYouTubeVideos: { __typename?: 'YouTubeVideoPageResults', totalElements: number, totalPages: number, hasPrevious: boolean, hasNext: boolean, content: Array<{ __typename?: 'YouTubeVideo', uuid: string, videoId: string, videoUrl: string, title: string, authorName: string, available: boolean, lastRefreshedAt: any, thumbnail?: { __typename?: 'Media', uuid: string, previewUrl128?: string | null | undefined } | null | undefined, articles: Array<{ __typename?: 'Article', uuid: string, subject: string }> }> } };

export type YouTubeVideoListItemFragment = { __typename?: 'YouTubeVideo', uuid: string, videoId: string, videoUrl: string, title: string, authorName: string, available: boolean, lastRefreshedAt: any, thumbnail?: { __typename?: 'Media', uuid: string, previewUrl128?: string | null | undefined } | null | undefined, articles: Array<{ __typename?: 'Article', uuid: string, subject: string }> };

export const LinkedUserFragmentDoc = gql`
    fragment LinkedUser on LinkedUser {
  sub
  displayName
  email
  isPrimary
}
    `;
export const AuthorListItemFragmentDoc = gql`
    fragment AuthorListItem on Author {
  uuid
  name
  email
  title
  isProfilePublic
  isActive
  viewerCanEdit
  linkedUsers {
    ...LinkedUser
  }
}
    ${LinkedUserFragmentDoc}`;
export const MediaListItemFragmentDoc = gql`
    fragment MediaListItem on Media {
  uuid
  filename
  mediaType
  length
  watermark
  viewerCanDelete
  viewerCanEdit
  tags {
    uuid
    text
    color
    contrastColor
  }
  companies {
    uuid
    name
    viewerCanEdit
  }
  gameSeries {
    uuid
    name
    viewerCanEdit
  }
  games {
    uuid
    name
  }
  gameConsoles {
    uuid
    name
  }
  previewUrl48: previewUrl(width: 48, height: 48, resizing: FIT)
  previewUrl64: previewUrl(width: 64, height: 64, resizing: FIT)
  previewUrl128: previewUrl(width: 128, height: 128, resizing: FIT)
  previewUrl192: previewUrl(width: 192, height: 192, resizing: FIT)
  previewUrl256: previewUrl(width: 256, height: 256, resizing: FIT)
  previewUrl110: previewUrl(width: 110, height: 110, resizing: FIT)
  previewUrl140: previewUrl(width: 140, height: 140, resizing: FIT)
  previewUrl190: previewUrl(width: 190, height: 190, resizing: FIT)
  previewUrl260: previewUrl(width: 260, height: 260, resizing: FIT)
  previewUrl410: previewUrl(width: 410, height: 410, resizing: FIT)
  createdDate
  lastModifiedDate
}
    `;
export const RatingCategoryListItemFragmentDoc = gql`
    fragment RatingCategoryListItem on RatingCategory {
  uuid
  name
  min
  max
  step
  required
  order
  viewerCanEdit
}
    `;
export const ArticleRatingListItemFragmentDoc = gql`
    fragment ArticleRatingListItem on ArticleRating {
  category {
    ...RatingCategoryListItem
  }
  score
}
    ${RatingCategoryListItemFragmentDoc}`;
export const GenreListItemFragmentDoc = gql`
    fragment GenreListItem on Genre {
  uuid
  name
  acronym
  viewerCanEdit
}
    `;
export const GameSeriesListItemFragmentDoc = gql`
    fragment GameSeriesListItem on GameSeries {
  uuid
  name
  acronym
  viewerCanEdit
}
    `;
export const GameConsoleListItemFragmentDoc = gql`
    fragment GameConsoleListItem on GameConsole {
  uuid
  name
  acronym
  viewerCanEdit
  type
  logo {
    previewUrl(width: 40, height: 40, resizing: FIT)
  }
  releaseDate
  releaseDateEurope
  releaseDateGermany
  releaseDateJapan
  releaseDateUnitedStates
  showInDatabaseView
  archived
}
    `;
export const CompanyListItemFragmentDoc = gql`
    fragment CompanyListItem on Company {
  uuid
  name
  acronym
  slug
  viewerCanEdit
  logo {
    previewUrl(width: 40, height: 40, resizing: FIT)
  }
}
    `;
export const GameListItemFragmentDoc = gql`
    fragment GameListItem on Game {
  uuid
  name
  alternativeName
  acronym
  viewerCanEdit
  cover {
    uuid
    filename
    mediaType
    previewUrl(width: 40, height: 40, resizing: FIT)
  }
  images {
    uuid
    filename
    mediaType
    previewUrl(width: 40, height: 40, resizing: FIT)
  }
  genres {
    ...GenreListItem
  }
  gameSeries {
    ...GameSeriesListItem
  }
  gameConsoles {
    ...GameConsoleListItem
  }
  publisher {
    ...CompanyListItem
  }
  developer {
    ...CompanyListItem
  }
  gameModes
  releaseDate
  releaseDateGermany
  usk
  pegi
  esrb
}
    ${GenreListItemFragmentDoc}
${GameSeriesListItemFragmentDoc}
${GameConsoleListItemFragmentDoc}
${CompanyListItemFragmentDoc}`;
export const TagListItemFragmentDoc = gql`
    fragment TagListItem on Tag {
  uuid
  text
  normalizedText
  color
  contrastColor
  viewerCanEdit
}
    `;
export const ArticleSeriesListItemFragmentDoc = gql`
    fragment ArticleSeriesListItem on ArticleSeries {
  uuid
  name
  slug
  showInSlider
  showUntil
  viewerCanEdit
}
    `;
export const EventListItemFragmentDoc = gql`
    fragment EventListItem on Event {
  uuid
  name
  slug
  viewerCanEdit
  kind
  startsAt
  endsAt
  allDay
  timeZone
  venue {
    name
    city
    country
  }
  onlineUrl
  showOnHomepage
  showUntil
  lastModifiedDate
}
    `;
export const RevisionAuthorFragmentDoc = gql`
    fragment RevisionAuthor on RevisionAuthor {
  username
  displayName
  email
  userId
}
    `;
export const ArticleListItemFragmentDoc = gql`
    fragment ArticleListItem on Article {
  uuid
  kind
  slug
  subject
  viewerCanEdit
  viewerCanDelete
  viewerCanPublish
  viewerEditLockedByPublication
  teaserText
  authors {
    ...AuthorListItem
  }
  teaserMedia {
    ...MediaListItem
  }
  medias {
    ... on Media {
      ...MediaListItem
    }
  }
  rating {
    ...ArticleRatingListItem
  }
  games {
    ...GameListItem
  }
  gameSeries {
    ...GameSeriesListItem
  }
  gameConsoles {
    ...GameConsoleListItem
  }
  companies {
    ...CompanyListItem
  }
  tags {
    ...TagListItem
  }
  articleSeries {
    ...ArticleSeriesListItem
    event {
      ...EventListItem
    }
  }
  event {
    ...EventListItem
  }
  reactionCounts {
    emoji
    count
  }
  totalReactions
  commentCount
  publishedState
  carouselPlacement
  webPushStatus {
    state
    sendAfter
    sentAt
    finishedAt
    subscriptionsTotal
    sentCount
    errorCount
    attempts
  }
  pageViews {
    total
    last30Days
    updatedAt
  }
  publicationDateTime
  createdDate
  createdBy {
    ...RevisionAuthor
  }
  lastModifiedDate
  lastModifiedBy {
    ...RevisionAuthor
  }
}
    ${AuthorListItemFragmentDoc}
${MediaListItemFragmentDoc}
${ArticleRatingListItemFragmentDoc}
${GameListItemFragmentDoc}
${GameSeriesListItemFragmentDoc}
${GameConsoleListItemFragmentDoc}
${CompanyListItemFragmentDoc}
${TagListItemFragmentDoc}
${ArticleSeriesListItemFragmentDoc}
${EventListItemFragmentDoc}
${RevisionAuthorFragmentDoc}`;
export const ArticlePageResultsFragmentDoc = gql`
    fragment ArticlePageResults on ArticlePageResults {
  content {
    ...ArticleListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${ArticleListItemFragmentDoc}`;
export const RatingCategoryDetailsFragmentDoc = gql`
    fragment RatingCategoryDetails on RatingCategory {
  uuid
  name
  min
  max
  step
  required
  order
  articleSpecific
  viewerCanDelete
  viewerCanEdit
  entityVersion
}
    `;
export const ArticleRatingDetailsFragmentDoc = gql`
    fragment ArticleRatingDetails on ArticleRating {
  category {
    ...RatingCategoryDetails
  }
  score
}
    ${RatingCategoryDetailsFragmentDoc}`;
export const ArticleDetailsFragmentDoc = gql`
    fragment ArticleDetails on Article {
  uuid
  kind
  slug
  subject
  viewerCanEdit
  viewerCanDelete
  viewerCanPublish
  viewerEditLockedByPublication
  authors {
    ...AuthorListItem
  }
  teaserMedia {
    ...MediaListItem
  }
  teaserText
  text
  conclusion
  editorsTake
  highlyAccessible
  accessibilityNote
  specialThanks
  pros
  cons
  rating {
    ...ArticleRatingDetails
  }
  totalScore
  manualTotalScore
  subReviews {
    title
    body
    conclusion
    teaserMedia {
      ...MediaListItem
    }
    pros
    cons
    rating {
      category {
        ...RatingCategoryDetails
      }
      score
    }
    score
  }
  subReviewScoreMin
  subReviewScoreMax
  medias {
    ... on Media {
      ...MediaListItem
    }
    ... on ExternalMedia {
      url
    }
  }
  games {
    ...GameListItem
  }
  gameSeries {
    ...GameSeriesListItem
  }
  gameConsoles {
    ...GameConsoleListItem
  }
  companies {
    ...CompanyListItem
  }
  tags {
    ...TagListItem
  }
  articleSeries {
    ...ArticleSeriesListItem
    event {
      ...EventListItem
    }
  }
  event {
    ...EventListItem
  }
  publishedState
  aiUsageLevel
  carouselPlacement
  publicationDateTime
  seoDescription
  previewLinks {
    token
    url
    label
    validUntil
    createdAt
    createdBy {
      displayName
      username
    }
  }
  entityVersion
}
    ${AuthorListItemFragmentDoc}
${MediaListItemFragmentDoc}
${ArticleRatingDetailsFragmentDoc}
${RatingCategoryDetailsFragmentDoc}
${GameListItemFragmentDoc}
${GameSeriesListItemFragmentDoc}
${GameConsoleListItemFragmentDoc}
${CompanyListItemFragmentDoc}
${TagListItemFragmentDoc}
${ArticleSeriesListItemFragmentDoc}
${EventListItemFragmentDoc}`;
export const ReviewCommentFieldsFragmentDoc = gql`
    fragment ReviewCommentFields on ReviewComment {
  uuid
  parentCommentId
  anchor {
    field
    subReviewIndex
    blockId
    quotedText
    startOffset
    endOffset
  }
  text
  suggestedText
  status
  deleted
  author {
    ...RevisionAuthor
  }
  createdDate
  resolvedAt
  resolvedBy {
    ...RevisionAuthor
  }
  viewerCanDelete
}
    ${RevisionAuthorFragmentDoc}`;
export const ArticleAnalysisDetailsFragmentDoc = gql`
    fragment ArticleAnalysisDetails on ArticleAnalysis {
  id
  articleId
  articleSubject
  status
  sentiment
  createdBy {
    ...RevisionAuthor
  }
  createdDate
  startedAt
  completedAt
  closedAt
  error
  providerInfo {
    provider
    model
  }
  articleKindSuggestion {
    id
    value
    confidence
    accepted
  }
  tagSuggestions {
    id
    tagId
    name
    isNew
    confidence
    accepted
  }
  companySuggestions {
    id
    entityId
    name
    isNew
    confidence
    accepted
  }
  gameConsoleSuggestions {
    id
    entityId
    name
    isNew
    confidence
    accepted
  }
  gameSeriesSuggestions {
    id
    entityId
    name
    isNew
    confidence
    accepted
  }
  gameSuggestions {
    id
    entityId
    name
    isNew
    confidence
    accepted
  }
  gameDetailsSuggestion {
    developer {
      id
      entityId
      name
      isNew
      confidence
      accepted
    }
    publisher {
      id
      entityId
      name
      isNew
      confidence
      accepted
    }
    genres {
      id
      entityId
      name
      isNew
      confidence
      accepted
    }
  }
  textSuggestions {
    id
    category
    field
    originalText
    suggestedText
    reasoning
    accepted
  }
}
    ${RevisionAuthorFragmentDoc}`;
export const ArticleSeriesDetailsFragmentDoc = gql`
    fragment ArticleSeriesDetails on ArticleSeries {
  uuid
  name
  slug
  teaserImage {
    ...MediaListItem
  }
  description
  showInSlider
  showUntil
  event {
    uuid
    name
    slug
    kind
    startsAt
    endsAt
  }
  entityVersion
  createdDate
  createdBy {
    userId
    username
    displayName
    email
  }
  lastModifiedDate
  lastModifiedBy {
    userId
    username
    displayName
    email
  }
  viewerCanDelete
  viewerCanEdit
}
    ${MediaListItemFragmentDoc}`;
export const PreparationTaskItemFragmentDoc = gql`
    fragment PreparationTaskItem on PreparationTask {
  entityType
  entityId
  title
  createdDate
  claimedDate
  claimedBy {
    userId
    displayName
    username
  }
  possibleDuplicate
  duplicateCandidates {
    entityId
    title
    reason
    score
  }
}
    `;
export const AuthorPageResultsFragmentDoc = gql`
    fragment AuthorPageResults on AuthorPageResults {
  content {
    ...AuthorListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${AuthorListItemFragmentDoc}`;
export const AuthorDetailsFragmentDoc = gql`
    fragment AuthorDetails on Author {
  uuid
  name
  email
  title
  slogan
  profile
  isProfilePublic
  isActive
  linkedUsers {
    ...LinkedUser
  }
  viewerCanDelete
  viewerCanEdit
  entityVersion
}
    ${LinkedUserFragmentDoc}`;
export const CommentListItemFragmentDoc = gql`
    fragment CommentListItem on ArticleComment {
  uuid
  articleId
  parentCommentId
  author {
    ...RevisionAuthor
  }
  content
  moderationStatus
  aiAssessment {
    approved
    confidence
    reasoning
    provider
    model
    assessedAt
    attemptCount
  }
  createdDate
  lastModifiedDate
}
    ${RevisionAuthorFragmentDoc}`;
export const CommentDetailsFragmentDoc = gql`
    fragment CommentDetails on ArticleComment {
  uuid
  articleId
  parentCommentId
  author {
    ...RevisionAuthor
  }
  content
  moderationStatus
  aiAssessment {
    approved
    confidence
    reasoning
    provider
    model
    assessedAt
    attemptCount
  }
  rejectionReason
  rejectedBy {
    ...RevisionAuthor
  }
  approvedBy {
    ...RevisionAuthor
  }
  reactionCounts {
    emoji
    count
  }
  totalReactions
  editedAt
  hasPendingEdit
  createdDate
  lastModifiedDate
}
    ${RevisionAuthorFragmentDoc}`;
export const CommentActivityFieldsFragmentDoc = gql`
    fragment CommentActivityFields on CommentActivity {
  __typename
  id
  createdDate
  actor {
    userId
    username
    displayName
  }
  articleId
  articleSlug
  articleSubject
  comment {
    uuid
    content
    moderationStatus
    author {
      userId
      username
      displayName
    }
    aiAssessment {
      approved
      confidence
      reasoning
    }
    reactionCounts {
      emoji
      count
    }
    totalReactions
    rejectionReason
    createdDate
    editedAt
  }
}
    `;
export const ReactionActivityFieldsFragmentDoc = gql`
    fragment ReactionActivityFields on ReactionActivity {
  __typename
  id
  createdDate
  actor {
    userId
    username
    displayName
  }
  emoji
  target {
    __typename
    ... on Article {
      uuid
      slug
      subject
    }
    ... on ArticleComment {
      uuid
      articleId
      content
    }
  }
}
    `;
export const ReviewCommentActivityFieldsFragmentDoc = gql`
    fragment ReviewCommentActivityFields on ReviewCommentActivity {
  __typename
  id
  createdDate
  actor {
    userId
    username
    displayName
  }
  articleId
  articleSubject
  excerpt
  hasSuggestion
  isReply
}
    `;
export const CompanyPageResultsFragmentDoc = gql`
    fragment CompanyPageResults on CompanyPageResults {
  content {
    ...CompanyListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${CompanyListItemFragmentDoc}`;
export const CompanyDetailsFragmentDoc = gql`
    fragment CompanyDetails on Company {
  uuid
  name
  acronym
  description
  websiteUrl
  wikipediaUrl
  foundingYear
  country
  logo {
    ...MediaListItem
  }
  viewerCanDelete
  viewerCanEdit
  entityVersion
}
    ${MediaListItemFragmentDoc}`;
export const EventDetailsFragmentDoc = gql`
    fragment EventDetails on Event {
  uuid
  name
  slug
  description
  teaserImage {
    ...MediaListItem
  }
  kind
  startsAt
  endsAt
  allDay
  timeZone
  openingHours {
    date
    opens
    closes
    note
  }
  venue {
    name
    street
    city
    postalCode
    country
    latitude
    longitude
  }
  onlineUrl
  websiteUrl
  showOnHomepage
  showUntil
  entityVersion
  createdDate
  createdBy {
    userId
    displayName
  }
  lastModifiedDate
  lastModifiedBy {
    userId
    displayName
  }
  viewerCanDelete
  viewerCanEdit
}
    ${MediaListItemFragmentDoc}`;
export const EditSessionFragmentDoc = gql`
    fragment EditSession on EditSession {
  sessionId
  userSub
  displayName
  startedAt
  dirty
  own
}
    `;
export const GameConsolePageResultsFragmentDoc = gql`
    fragment GameConsolePageResults on GameConsolePageResults {
  content {
    ...GameConsoleListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${GameConsoleListItemFragmentDoc}`;
export const GameConsoleDetailsFragmentDoc = gql`
    fragment GameConsoleDetails on GameConsole {
  uuid
  name
  acronym
  type
  logo {
    ...MediaListItem
  }
  releaseDate
  releaseDateEurope
  releaseDateGermany
  releaseDateJapan
  releaseDateUnitedStates
  showInDatabaseView
  archived
  viewerCanDelete
  viewerCanEdit
  entityVersion
}
    ${MediaListItemFragmentDoc}`;
export const GamePageResultsFragmentDoc = gql`
    fragment GamePageResults on GamePageResults {
  content {
    ...GameListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${GameListItemFragmentDoc}`;
export const PlayerCountFragmentDoc = gql`
    fragment PlayerCount on PlayerCount {
  min
  max
}
    `;
export const GameDetailsFragmentDoc = gql`
    fragment GameDetails on Game {
  uuid
  name
  viewerCanDelete
  viewerCanEdit
  alternativeName
  acronym
  gameModes
  localPlayerCount {
    ...PlayerCount
  }
  onlinePlayerCount {
    ...PlayerCount
  }
  genres {
    ...GenreListItem
  }
  gameSeries {
    ...GameSeriesListItem
  }
  relatedGames {
    type
    game {
      uuid
      name
    }
  }
  inverseRelatedGames {
    type
    game {
      uuid
      name
    }
  }
  publisher {
    ...CompanyListItem
  }
  developer {
    ...CompanyListItem
  }
  additionalInformations
  usk
  pegi
  esrb
  consoleEditions {
    gameConsole {
      ...GameConsoleListItem
    }
    cover {
      ...MediaListItem
    }
    images {
      ...MediaListItem
    }
    releaseDate
    releaseDateJapan
    releaseDateUnitedStates
    releaseDateEurope
    releaseDateGermany
    packaging
    packagingJapan
    packagingUnitedStates
    packagingEurope
    packagingGermany
    amazonUrl
    overridePublisher
    publisher {
      ...CompanyListItem
    }
    overrideDeveloper
    developer {
      ...CompanyListItem
    }
    overrideRatings
    usk
    pegi
    esrb
  }
  entityVersion
}
    ${PlayerCountFragmentDoc}
${GenreListItemFragmentDoc}
${GameSeriesListItemFragmentDoc}
${CompanyListItemFragmentDoc}
${GameConsoleListItemFragmentDoc}
${MediaListItemFragmentDoc}`;
export const GameSeriesPageResultsFragmentDoc = gql`
    fragment GameSeriesPageResults on GameSeriesPageResults {
  content {
    ...GameSeriesListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${GameSeriesListItemFragmentDoc}`;
export const GameSeriesDetailsFragmentDoc = gql`
    fragment GameSeriesDetails on GameSeries {
  uuid
  name
  acronym
  viewerCanDelete
  viewerCanEdit
  entityVersion
}
    `;
export const GenrePageResultsFragmentDoc = gql`
    fragment GenrePageResults on GenrePageResults {
  content {
    ...GenreListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${GenreListItemFragmentDoc}`;
export const GenreDetailsFragmentDoc = gql`
    fragment GenreDetails on Genre {
  uuid
  name
  acronym
  viewerCanDelete
  viewerCanEdit
  entityVersion
}
    `;
export const CommitMetadataFragmentDoc = gql`
    fragment CommitMetadata on CommitMetadata {
  id
  commitDate
  author {
    ...RevisionAuthor
  }
}
    ${RevisionAuthorFragmentDoc}`;
export const ValueChangeFragmentDoc = gql`
    fragment ValueChange on ValueChange {
  propertyName
  left
  right
}
    `;
export const MapChangeFragmentDoc = gql`
    fragment MapChange on MapChange {
  propertyName
  left
  right
}
    `;
export const ListChangeFragmentDoc = gql`
    fragment ListChange on ListChange {
  propertyName
  left
  right
}
    `;
export const ArrayChangeFragmentDoc = gql`
    fragment ArrayChange on ArrayChange {
  propertyName
  left
  right
}
    `;
export const SetChangeFragmentDoc = gql`
    fragment SetChange on SetChange {
  propertyName
  left
  right
}
    `;
export const ChangeFragmentDoc = gql`
    fragment Change on Change {
  ...ValueChange
  ...MapChange
  ...ListChange
  ...ArrayChange
  ...SetChange
}
    ${ValueChangeFragmentDoc}
${MapChangeFragmentDoc}
${ListChangeFragmentDoc}
${ArrayChangeFragmentDoc}
${SetChangeFragmentDoc}`;
export const ChangesByCommitFragmentDoc = gql`
    fragment ChangesByCommit on ChangesByCommit {
  commit {
    ...CommitMetadata
  }
  changes {
    ...Change
  }
  summary
}
    ${CommitMetadataFragmentDoc}
${ChangeFragmentDoc}`;
export const MediaPageResultsFragmentDoc = gql`
    fragment MediaPageResults on MediaPageResults {
  content {
    ...MediaListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${MediaListItemFragmentDoc}`;
export const MediaDetailsFragmentDoc = gql`
    fragment MediaDetails on Media {
  uuid
  filename
  mediaType
  length
  copyright
  copyrightUrl
  license
  licenseUrl
  sourceUrl
  watermark
  viewerCanDelete
  viewerCanEdit
  tags {
    ...TagListItem
  }
  companies {
    ...CompanyListItem
  }
  gameSeries {
    ...GameSeriesListItem
  }
  games {
    ...GameListItem
  }
  gameConsoles {
    ...GameConsoleListItem
  }
  previewUrl256: previewUrl(width: 256, height: 256, resizing: FIT)
  previewUrl374: previewUrl(width: 374, height: 374)
  previewUrl822: previewUrl(width: 822, height: 822)
  nonWatermarkPreviewUrl374: previewUrl(width: 374, height: 374, watermark: false)
  nonWatermarkPreviewUrl822: previewUrl(width: 822, height: 822, watermark: false)
  createdDate
  lastModifiedDate
  entityVersion
}
    ${TagListItemFragmentDoc}
${CompanyListItemFragmentDoc}
${GameSeriesListItemFragmentDoc}
${GameListItemFragmentDoc}
${GameConsoleListItemFragmentDoc}`;
export const MediaBatchEditItemFragmentDoc = gql`
    fragment MediaBatchEditItem on Media {
  uuid
  filename
  mediaType
  length
  copyright
  copyrightUrl
  license
  licenseUrl
  sourceUrl
  watermark
  viewerCanEdit
  previewUrl110: previewUrl(width: 110, height: 110, resizing: FIT)
  previewUrl140: previewUrl(width: 140, height: 140, resizing: FIT)
  tags {
    ...TagListItem
  }
  companies {
    ...CompanyListItem
  }
  gameSeries {
    ...GameSeriesListItem
  }
  games {
    ...GameListItem
  }
  gameConsoles {
    ...GameConsoleListItem
  }
}
    ${TagListItemFragmentDoc}
${CompanyListItemFragmentDoc}
${GameSeriesListItemFragmentDoc}
${GameListItemFragmentDoc}
${GameConsoleListItemFragmentDoc}`;
export const QuickFilterListItemFragmentDoc = gql`
    fragment QuickFilterListItem on QuickFilter {
  uuid
  slug
  label
  icon
  visibleOn
  enabled
  visibleFrom
  visibleUntil
  sortIndex
  viewerCanEdit
}
    `;
export const QuickFilterDetailsFragmentDoc = gql`
    fragment QuickFilterDetails on QuickFilter {
  ...QuickFilterListItem
  filters {
    kind
    excludeKind
    game {
      ...GameListItem
    }
    gameSeries {
      ...GameSeriesListItem
    }
    gameConsole {
      ...GameConsoleListItem
    }
    genre {
      ...GenreListItem
    }
    company {
      ...CompanyListItem
    }
    event {
      ...EventListItem
    }
    author {
      ...AuthorListItem
    }
    tag {
      ...TagListItem
    }
    articleSeries {
      ...ArticleSeriesListItem
    }
    after
    before
    order
  }
  entityVersion
  createdDate
  lastModifiedDate
  viewerCanDelete
  viewerCanEdit
}
    ${QuickFilterListItemFragmentDoc}
${GameListItemFragmentDoc}
${GameSeriesListItemFragmentDoc}
${GameConsoleListItemFragmentDoc}
${GenreListItemFragmentDoc}
${CompanyListItemFragmentDoc}
${EventListItemFragmentDoc}
${AuthorListItemFragmentDoc}
${TagListItemFragmentDoc}
${ArticleSeriesListItemFragmentDoc}`;
export const QuickFilterPageResultsFragmentDoc = gql`
    fragment QuickFilterPageResults on QuickFilterPageResults {
  content {
    ...QuickFilterListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${QuickFilterListItemFragmentDoc}`;
export const RatingCategoryPageResultsFragmentDoc = gql`
    fragment RatingCategoryPageResults on RatingCategoryPageResults {
  content {
    ...RatingCategoryListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${RatingCategoryListItemFragmentDoc}`;
export const RatingCategoryDetailsPageResultsFragmentDoc = gql`
    fragment RatingCategoryDetailsPageResults on RatingCategoryPageResults {
  content {
    ...RatingCategoryDetails
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${RatingCategoryDetailsFragmentDoc}`;
export const AdminSearchResultItemFragmentDoc = gql`
    fragment AdminSearchResultItem on AdminSearchResult {
  id
  slug
  type
  headline
  text
  image {
    previewUrl(width: 64, height: 64, resizing: FIT)
  }
  details {
    __typename
    ... on ArticleSearchDetails {
      articleKind: kind
      publicationDateTime
      publishedState
    }
    ... on GameSearchDetails {
      acronym
      releaseDate
      usk
      pegi
      esrb
    }
    ... on GameSeriesSearchDetails {
      acronym
    }
    ... on ArticleSeriesSearchDetails {
      showInSlider
    }
    ... on EventSearchDetails {
      eventKind: kind
      startsAt
      endsAt
    }
    ... on GameConsoleSearchDetails {
      acronym
      releaseDate
    }
    ... on CompanySearchDetails {
      acronym
    }
    ... on MediaSearchDetails {
      mediaType
      filename
    }
    ... on TagSearchDetails {
      text
    }
    ... on AuthorSearchDetails {
      title
    }
  }
}
    `;
export const IndexerStatusFragmentDoc = gql`
    fragment IndexerStatus on IndexerStatus {
  queued
  running
  indexed
  total
}
    `;
export const ScheduleResultFragmentDoc = gql`
    fragment ScheduleResult on ScheduleResult {
  creates
  updates
  deletes
}
    `;
export const TagPageResultsFragmentDoc = gql`
    fragment TagPageResults on TagPageResults {
  content {
    ...TagListItem
  }
  totalElements
  totalPages
  hasPrevious
  hasNext
}
    ${TagListItemFragmentDoc}`;
export const TagDetailsFragmentDoc = gql`
    fragment TagDetails on Tag {
  uuid
  text
  normalizedText
  color
  contrastColor
  viewerCanDelete
  viewerCanEdit
  entityVersion
}
    `;
export const UploadPartNumberAndUploadUrlFragmentDoc = gql`
    fragment UploadPartNumberAndUploadUrl on UploadPart {
  number
  uploadUrl
}
    `;
export const UploadUuidAndPartNumberWithUploadUrlFragmentDoc = gql`
    fragment UploadUuidAndPartNumberWithUploadUrl on Upload {
  uuid
  parts {
    ...UploadPartNumberAndUploadUrl
  }
}
    ${UploadPartNumberAndUploadUrlFragmentDoc}`;
export const UserListItemFragmentDoc = gql`
    fragment UserListItem on User {
  sub
  loginName
  displayName
  email
  emailVerified
  state
  classification
  roles
  linkedAuthors {
    id
    displayName
    isPrimary
  }
  createdDate
  lastModifiedDate
}
    `;
export const UserDetailFragmentDoc = gql`
    fragment UserDetail on User {
  sub
  loginName
  displayName
  email
  state
  classification
  roles
  unknownRoleKeys
  linkedAuthors {
    id
    displayName
    isPrimary
  }
}
    `;
export const YouTubeVideoListItemFragmentDoc = gql`
    fragment YouTubeVideoListItem on YouTubeVideo {
  uuid
  videoId
  videoUrl
  title
  authorName
  available
  lastRefreshedAt
  thumbnail {
    uuid
    previewUrl128: previewUrl(width: 128, height: 128, resizing: FIT)
  }
  articles {
    uuid
    subject
  }
}
    `;
export const GetArticleDocument = gql`
    query GetArticle($id: UUID!) {
  article(id: $id) {
    ...ArticleDetails
  }
}
    ${ArticleDetailsFragmentDoc}`;

/**
 * __useGetArticleQuery__
 *
 * To run a query within a Vue component, call `useGetArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetArticleQuery(variables: GetArticleQueryVariables | VueCompositionApi.Ref<GetArticleQueryVariables> | ReactiveFunction<GetArticleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, variables, options);
}
export function useGetArticleLazyQuery(variables?: GetArticleQueryVariables | VueCompositionApi.Ref<GetArticleQueryVariables> | ReactiveFunction<GetArticleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleQuery, GetArticleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, variables, options);
}
export type GetArticleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleQuery, GetArticleQueryVariables>;
export const GetArticlesDocument = gql`
    query GetArticles($page: Int!, $limit: Int!) {
  allArticles(page: $page, limit: $limit) {
    ...ArticlePageResults
  }
}
    ${ArticlePageResultsFragmentDoc}`;

/**
 * __useGetArticlesQuery__
 *
 * To run a query within a Vue component, call `useGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticlesQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetArticlesQuery(variables: GetArticlesQueryVariables | VueCompositionApi.Ref<GetArticlesQueryVariables> | ReactiveFunction<GetArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticlesQuery, GetArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticlesQuery, GetArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticlesQuery, GetArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, variables, options);
}
export function useGetArticlesLazyQuery(variables?: GetArticlesQueryVariables | VueCompositionApi.Ref<GetArticlesQueryVariables> | ReactiveFunction<GetArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticlesQuery, GetArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticlesQuery, GetArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticlesQuery, GetArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, variables, options);
}
export type GetArticlesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticlesQuery, GetArticlesQueryVariables>;
export const FindArticlesDocument = gql`
    query FindArticles($query: String, $ids: [UUID!], $examples: [ArticleExampleInput!], $order: [String!], $page: Int!, $limit: Int!, $scope: ArticleScope) {
  findArticles(
    query: $query
    ids: $ids
    examples: $examples
    order: $order
    page: $page
    limit: $limit
    scope: $scope
  ) {
    ...ArticlePageResults
  }
}
    ${ArticlePageResultsFragmentDoc}`;

/**
 * __useFindArticlesQuery__
 *
 * To run a query within a Vue component, call `useFindArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindArticlesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindArticlesQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   examples: // value for 'examples'
 *   order: // value for 'order'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   scope: // value for 'scope'
 * });
 */
export function useFindArticlesQuery(variables: FindArticlesQueryVariables | VueCompositionApi.Ref<FindArticlesQueryVariables> | ReactiveFunction<FindArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindArticlesQuery, FindArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindArticlesQuery, FindArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindArticlesQuery, FindArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindArticlesQuery, FindArticlesQueryVariables>(FindArticlesDocument, variables, options);
}
export function useFindArticlesLazyQuery(variables?: FindArticlesQueryVariables | VueCompositionApi.Ref<FindArticlesQueryVariables> | ReactiveFunction<FindArticlesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindArticlesQuery, FindArticlesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindArticlesQuery, FindArticlesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindArticlesQuery, FindArticlesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindArticlesQuery, FindArticlesQueryVariables>(FindArticlesDocument, variables, options);
}
export type FindArticlesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindArticlesQuery, FindArticlesQueryVariables>;
export const CreateArticleDocument = gql`
    mutation CreateArticle($create: ArticleCreateInput!) {
  createArticle(create: $create) {
    ...ArticleDetails
  }
}
    ${ArticleDetailsFragmentDoc}`;

/**
 * __useCreateArticleMutation__
 *
 * To run a mutation, you first call `useCreateArticleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateArticleMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateArticleMutation(options: VueApolloComposable.UseMutationOptions<CreateArticleMutation, CreateArticleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateArticleMutation, CreateArticleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateArticleMutation, CreateArticleMutationVariables>(CreateArticleDocument, options);
}
export type CreateArticleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateArticleMutation, CreateArticleMutationVariables>;
export const UpdateArticleDocument = gql`
    mutation UpdateArticle($id: UUID!, $update: ArticleUpdateInput!, $expectedVersion: Int) {
  updateArticle(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...ArticleDetails
  }
}
    ${ArticleDetailsFragmentDoc}`;

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateArticleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateArticleMutation(options: VueApolloComposable.UseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(UpdateArticleDocument, options);
}
export type UpdateArticleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateArticleMutation, UpdateArticleMutationVariables>;
export const DeleteArticleDocument = gql`
    mutation DeleteArticle($id: UUID!) {
  deleteArticle(id: $id) {
    uuid
    subject
  }
}
    `;

/**
 * __useDeleteArticleMutation__
 *
 * To run a mutation, you first call `useDeleteArticleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteArticleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleMutation(options: VueApolloComposable.UseMutationOptions<DeleteArticleMutation, DeleteArticleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteArticleMutation, DeleteArticleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteArticleMutation, DeleteArticleMutationVariables>(DeleteArticleDocument, options);
}
export type DeleteArticleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteArticleMutation, DeleteArticleMutationVariables>;
export const PublishArticleDocument = gql`
    mutation PublishArticle($id: UUID!) {
  publishArticle(id: $id) {
    uuid
    publishedState
    publicationDateTime
  }
}
    `;

/**
 * __usePublishArticleMutation__
 *
 * To run a mutation, you first call `usePublishArticleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishArticleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishArticleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function usePublishArticleMutation(options: VueApolloComposable.UseMutationOptions<PublishArticleMutation, PublishArticleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PublishArticleMutation, PublishArticleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PublishArticleMutation, PublishArticleMutationVariables>(PublishArticleDocument, options);
}
export type PublishArticleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PublishArticleMutation, PublishArticleMutationVariables>;
export const UnpublishArticleDocument = gql`
    mutation UnpublishArticle($id: UUID!) {
  unpublishArticle(id: $id) {
    uuid
    publishedState
  }
}
    `;

/**
 * __useUnpublishArticleMutation__
 *
 * To run a mutation, you first call `useUnpublishArticleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishArticleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnpublishArticleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUnpublishArticleMutation(options: VueApolloComposable.UseMutationOptions<UnpublishArticleMutation, UnpublishArticleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnpublishArticleMutation, UnpublishArticleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnpublishArticleMutation, UnpublishArticleMutationVariables>(UnpublishArticleDocument, options);
}
export type UnpublishArticleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnpublishArticleMutation, UnpublishArticleMutationVariables>;
export const GetArticleRevisionsDocument = gql`
    query GetArticleRevisions($id: UUID!, $page: Int!, $limit: Int!, $author: String) {
  article(id: $id) {
    ...ArticleDetails
  }
  articleRevisions(id: $id, page: $page, limit: $limit, author: $author) {
    content {
      ...ChangesByCommit
    }
    page
    limit
    totalElements
    totalPages
  }
}
    ${ArticleDetailsFragmentDoc}
${ChangesByCommitFragmentDoc}`;

/**
 * __useGetArticleRevisionsQuery__
 *
 * To run a query within a Vue component, call `useGetArticleRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleRevisionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleRevisionsQuery({
 *   id: // value for 'id'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   author: // value for 'author'
 * });
 */
export function useGetArticleRevisionsQuery(variables: GetArticleRevisionsQueryVariables | VueCompositionApi.Ref<GetArticleRevisionsQueryVariables> | ReactiveFunction<GetArticleRevisionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleRevisionsQuery, GetArticleRevisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleRevisionsQuery, GetArticleRevisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleRevisionsQuery, GetArticleRevisionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleRevisionsQuery, GetArticleRevisionsQueryVariables>(GetArticleRevisionsDocument, variables, options);
}
export function useGetArticleRevisionsLazyQuery(variables?: GetArticleRevisionsQueryVariables | VueCompositionApi.Ref<GetArticleRevisionsQueryVariables> | ReactiveFunction<GetArticleRevisionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleRevisionsQuery, GetArticleRevisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleRevisionsQuery, GetArticleRevisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleRevisionsQuery, GetArticleRevisionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleRevisionsQuery, GetArticleRevisionsQueryVariables>(GetArticleRevisionsDocument, variables, options);
}
export type GetArticleRevisionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleRevisionsQuery, GetArticleRevisionsQueryVariables>;
export const GetArticleRevisionAuthorsDocument = gql`
    query GetArticleRevisionAuthors($id: UUID!) {
  articleRevisionAuthors(id: $id) {
    userId
    displayName
    username
    email
  }
}
    `;

/**
 * __useGetArticleRevisionAuthorsQuery__
 *
 * To run a query within a Vue component, call `useGetArticleRevisionAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleRevisionAuthorsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleRevisionAuthorsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetArticleRevisionAuthorsQuery(variables: GetArticleRevisionAuthorsQueryVariables | VueCompositionApi.Ref<GetArticleRevisionAuthorsQueryVariables> | ReactiveFunction<GetArticleRevisionAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleRevisionAuthorsQuery, GetArticleRevisionAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleRevisionAuthorsQuery, GetArticleRevisionAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleRevisionAuthorsQuery, GetArticleRevisionAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleRevisionAuthorsQuery, GetArticleRevisionAuthorsQueryVariables>(GetArticleRevisionAuthorsDocument, variables, options);
}
export function useGetArticleRevisionAuthorsLazyQuery(variables?: GetArticleRevisionAuthorsQueryVariables | VueCompositionApi.Ref<GetArticleRevisionAuthorsQueryVariables> | ReactiveFunction<GetArticleRevisionAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleRevisionAuthorsQuery, GetArticleRevisionAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleRevisionAuthorsQuery, GetArticleRevisionAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleRevisionAuthorsQuery, GetArticleRevisionAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleRevisionAuthorsQuery, GetArticleRevisionAuthorsQueryVariables>(GetArticleRevisionAuthorsDocument, variables, options);
}
export type GetArticleRevisionAuthorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleRevisionAuthorsQuery, GetArticleRevisionAuthorsQueryVariables>;
export const CreateArticlePreviewLinkDocument = gql`
    mutation CreateArticlePreviewLink($articleId: UUID!, $validUntil: ZonedDateTime!, $label: String) {
  createArticlePreviewLink(
    articleId: $articleId
    validUntil: $validUntil
    label: $label
  ) {
    uuid
    previewLinks {
      token
      url
      label
      validUntil
      createdAt
      createdBy {
        displayName
        username
      }
    }
  }
}
    `;

/**
 * __useCreateArticlePreviewLinkMutation__
 *
 * To run a mutation, you first call `useCreateArticlePreviewLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticlePreviewLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateArticlePreviewLinkMutation({
 *   variables: {
 *     articleId: // value for 'articleId'
 *     validUntil: // value for 'validUntil'
 *     label: // value for 'label'
 *   },
 * });
 */
export function useCreateArticlePreviewLinkMutation(options: VueApolloComposable.UseMutationOptions<CreateArticlePreviewLinkMutation, CreateArticlePreviewLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateArticlePreviewLinkMutation, CreateArticlePreviewLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateArticlePreviewLinkMutation, CreateArticlePreviewLinkMutationVariables>(CreateArticlePreviewLinkDocument, options);
}
export type CreateArticlePreviewLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateArticlePreviewLinkMutation, CreateArticlePreviewLinkMutationVariables>;
export const DeleteArticlePreviewLinkDocument = gql`
    mutation DeleteArticlePreviewLink($articleId: UUID!, $token: String!) {
  deleteArticlePreviewLink(articleId: $articleId, token: $token) {
    uuid
    previewLinks {
      token
    }
  }
}
    `;

/**
 * __useDeleteArticlePreviewLinkMutation__
 *
 * To run a mutation, you first call `useDeleteArticlePreviewLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticlePreviewLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteArticlePreviewLinkMutation({
 *   variables: {
 *     articleId: // value for 'articleId'
 *     token: // value for 'token'
 *   },
 * });
 */
export function useDeleteArticlePreviewLinkMutation(options: VueApolloComposable.UseMutationOptions<DeleteArticlePreviewLinkMutation, DeleteArticlePreviewLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteArticlePreviewLinkMutation, DeleteArticlePreviewLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteArticlePreviewLinkMutation, DeleteArticlePreviewLinkMutationVariables>(DeleteArticlePreviewLinkDocument, options);
}
export type DeleteArticlePreviewLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteArticlePreviewLinkMutation, DeleteArticlePreviewLinkMutationVariables>;
export const GetArticleReviewCommentsDocument = gql`
    query GetArticleReviewComments($id: UUID!) {
  article(id: $id) {
    uuid
    reviewComments {
      ...ReviewCommentFields
    }
  }
}
    ${ReviewCommentFieldsFragmentDoc}`;

/**
 * __useGetArticleReviewCommentsQuery__
 *
 * To run a query within a Vue component, call `useGetArticleReviewCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleReviewCommentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleReviewCommentsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetArticleReviewCommentsQuery(variables: GetArticleReviewCommentsQueryVariables | VueCompositionApi.Ref<GetArticleReviewCommentsQueryVariables> | ReactiveFunction<GetArticleReviewCommentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleReviewCommentsQuery, GetArticleReviewCommentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleReviewCommentsQuery, GetArticleReviewCommentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleReviewCommentsQuery, GetArticleReviewCommentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleReviewCommentsQuery, GetArticleReviewCommentsQueryVariables>(GetArticleReviewCommentsDocument, variables, options);
}
export function useGetArticleReviewCommentsLazyQuery(variables?: GetArticleReviewCommentsQueryVariables | VueCompositionApi.Ref<GetArticleReviewCommentsQueryVariables> | ReactiveFunction<GetArticleReviewCommentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleReviewCommentsQuery, GetArticleReviewCommentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleReviewCommentsQuery, GetArticleReviewCommentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleReviewCommentsQuery, GetArticleReviewCommentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleReviewCommentsQuery, GetArticleReviewCommentsQueryVariables>(GetArticleReviewCommentsDocument, variables, options);
}
export type GetArticleReviewCommentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleReviewCommentsQuery, GetArticleReviewCommentsQueryVariables>;
export const CreateArticleReviewCommentReplyDocument = gql`
    mutation CreateArticleReviewCommentReply($commentId: UUID!, $text: String!) {
  createArticleReviewCommentReply(commentId: $commentId, text: $text) {
    ...ReviewCommentFields
  }
}
    ${ReviewCommentFieldsFragmentDoc}`;

/**
 * __useCreateArticleReviewCommentReplyMutation__
 *
 * To run a mutation, you first call `useCreateArticleReviewCommentReplyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleReviewCommentReplyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateArticleReviewCommentReplyMutation({
 *   variables: {
 *     commentId: // value for 'commentId'
 *     text: // value for 'text'
 *   },
 * });
 */
export function useCreateArticleReviewCommentReplyMutation(options: VueApolloComposable.UseMutationOptions<CreateArticleReviewCommentReplyMutation, CreateArticleReviewCommentReplyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateArticleReviewCommentReplyMutation, CreateArticleReviewCommentReplyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateArticleReviewCommentReplyMutation, CreateArticleReviewCommentReplyMutationVariables>(CreateArticleReviewCommentReplyDocument, options);
}
export type CreateArticleReviewCommentReplyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateArticleReviewCommentReplyMutation, CreateArticleReviewCommentReplyMutationVariables>;
export const ResolveArticleReviewCommentDocument = gql`
    mutation ResolveArticleReviewComment($commentId: UUID!) {
  resolveArticleReviewComment(commentId: $commentId) {
    ...ReviewCommentFields
  }
}
    ${ReviewCommentFieldsFragmentDoc}`;

/**
 * __useResolveArticleReviewCommentMutation__
 *
 * To run a mutation, you first call `useResolveArticleReviewCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResolveArticleReviewCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResolveArticleReviewCommentMutation({
 *   variables: {
 *     commentId: // value for 'commentId'
 *   },
 * });
 */
export function useResolveArticleReviewCommentMutation(options: VueApolloComposable.UseMutationOptions<ResolveArticleReviewCommentMutation, ResolveArticleReviewCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResolveArticleReviewCommentMutation, ResolveArticleReviewCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResolveArticleReviewCommentMutation, ResolveArticleReviewCommentMutationVariables>(ResolveArticleReviewCommentDocument, options);
}
export type ResolveArticleReviewCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResolveArticleReviewCommentMutation, ResolveArticleReviewCommentMutationVariables>;
export const ReopenArticleReviewCommentDocument = gql`
    mutation ReopenArticleReviewComment($commentId: UUID!) {
  reopenArticleReviewComment(commentId: $commentId) {
    ...ReviewCommentFields
  }
}
    ${ReviewCommentFieldsFragmentDoc}`;

/**
 * __useReopenArticleReviewCommentMutation__
 *
 * To run a mutation, you first call `useReopenArticleReviewCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReopenArticleReviewCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReopenArticleReviewCommentMutation({
 *   variables: {
 *     commentId: // value for 'commentId'
 *   },
 * });
 */
export function useReopenArticleReviewCommentMutation(options: VueApolloComposable.UseMutationOptions<ReopenArticleReviewCommentMutation, ReopenArticleReviewCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReopenArticleReviewCommentMutation, ReopenArticleReviewCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReopenArticleReviewCommentMutation, ReopenArticleReviewCommentMutationVariables>(ReopenArticleReviewCommentDocument, options);
}
export type ReopenArticleReviewCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReopenArticleReviewCommentMutation, ReopenArticleReviewCommentMutationVariables>;
export const DeleteArticleReviewCommentDocument = gql`
    mutation DeleteArticleReviewComment($commentId: UUID!) {
  deleteArticleReviewComment(commentId: $commentId) {
    ...ReviewCommentFields
  }
}
    ${ReviewCommentFieldsFragmentDoc}`;

/**
 * __useDeleteArticleReviewCommentMutation__
 *
 * To run a mutation, you first call `useDeleteArticleReviewCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleReviewCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteArticleReviewCommentMutation({
 *   variables: {
 *     commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteArticleReviewCommentMutation(options: VueApolloComposable.UseMutationOptions<DeleteArticleReviewCommentMutation, DeleteArticleReviewCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteArticleReviewCommentMutation, DeleteArticleReviewCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteArticleReviewCommentMutation, DeleteArticleReviewCommentMutationVariables>(DeleteArticleReviewCommentDocument, options);
}
export type DeleteArticleReviewCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteArticleReviewCommentMutation, DeleteArticleReviewCommentMutationVariables>;
export const ArticleLegacyExportDocument = gql`
    query ArticleLegacyExport($id: UUID!) {
  articleLegacyExport(id: $id) {
    subject
    gameTitle
    teaserHtml
    textHtml
    conclusionHtml
    pros
    cons
    images {
      filename
      downloadUrl
      isTeaser
    }
  }
}
    `;

/**
 * __useArticleLegacyExportQuery__
 *
 * To run a query within a Vue component, call `useArticleLegacyExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleLegacyExportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArticleLegacyExportQuery({
 *   id: // value for 'id'
 * });
 */
export function useArticleLegacyExportQuery(variables: ArticleLegacyExportQueryVariables | VueCompositionApi.Ref<ArticleLegacyExportQueryVariables> | ReactiveFunction<ArticleLegacyExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ArticleLegacyExportQuery, ArticleLegacyExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleLegacyExportQuery, ArticleLegacyExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleLegacyExportQuery, ArticleLegacyExportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ArticleLegacyExportQuery, ArticleLegacyExportQueryVariables>(ArticleLegacyExportDocument, variables, options);
}
export function useArticleLegacyExportLazyQuery(variables?: ArticleLegacyExportQueryVariables | VueCompositionApi.Ref<ArticleLegacyExportQueryVariables> | ReactiveFunction<ArticleLegacyExportQueryVariables>, options: VueApolloComposable.UseQueryOptions<ArticleLegacyExportQuery, ArticleLegacyExportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleLegacyExportQuery, ArticleLegacyExportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleLegacyExportQuery, ArticleLegacyExportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ArticleLegacyExportQuery, ArticleLegacyExportQueryVariables>(ArticleLegacyExportDocument, variables, options);
}
export type ArticleLegacyExportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ArticleLegacyExportQuery, ArticleLegacyExportQueryVariables>;
export const ArticleReceiptDocument = gql`
    query ArticleReceipt($id: UUID!, $language: ReceiptLanguage!) {
  articleReceipt(id: $id, language: $language) {
    subject
    body
  }
}
    `;

/**
 * __useArticleReceiptQuery__
 *
 * To run a query within a Vue component, call `useArticleReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleReceiptQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArticleReceiptQuery({
 *   id: // value for 'id'
 *   language: // value for 'language'
 * });
 */
export function useArticleReceiptQuery(variables: ArticleReceiptQueryVariables | VueCompositionApi.Ref<ArticleReceiptQueryVariables> | ReactiveFunction<ArticleReceiptQueryVariables>, options: VueApolloComposable.UseQueryOptions<ArticleReceiptQuery, ArticleReceiptQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleReceiptQuery, ArticleReceiptQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleReceiptQuery, ArticleReceiptQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ArticleReceiptQuery, ArticleReceiptQueryVariables>(ArticleReceiptDocument, variables, options);
}
export function useArticleReceiptLazyQuery(variables?: ArticleReceiptQueryVariables | VueCompositionApi.Ref<ArticleReceiptQueryVariables> | ReactiveFunction<ArticleReceiptQueryVariables>, options: VueApolloComposable.UseQueryOptions<ArticleReceiptQuery, ArticleReceiptQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ArticleReceiptQuery, ArticleReceiptQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ArticleReceiptQuery, ArticleReceiptQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ArticleReceiptQuery, ArticleReceiptQueryVariables>(ArticleReceiptDocument, variables, options);
}
export type ArticleReceiptQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ArticleReceiptQuery, ArticleReceiptQueryVariables>;
export const GetArticleAnalysisDocument = gql`
    query GetArticleAnalysis($id: UUID!) {
  articleAnalysis(id: $id) {
    ...ArticleAnalysisDetails
  }
}
    ${ArticleAnalysisDetailsFragmentDoc}`;

/**
 * __useGetArticleAnalysisQuery__
 *
 * To run a query within a Vue component, call `useGetArticleAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleAnalysisQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleAnalysisQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetArticleAnalysisQuery(variables: GetArticleAnalysisQueryVariables | VueCompositionApi.Ref<GetArticleAnalysisQueryVariables> | ReactiveFunction<GetArticleAnalysisQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleAnalysisQuery, GetArticleAnalysisQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleAnalysisQuery, GetArticleAnalysisQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleAnalysisQuery, GetArticleAnalysisQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleAnalysisQuery, GetArticleAnalysisQueryVariables>(GetArticleAnalysisDocument, variables, options);
}
export function useGetArticleAnalysisLazyQuery(variables?: GetArticleAnalysisQueryVariables | VueCompositionApi.Ref<GetArticleAnalysisQueryVariables> | ReactiveFunction<GetArticleAnalysisQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleAnalysisQuery, GetArticleAnalysisQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleAnalysisQuery, GetArticleAnalysisQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleAnalysisQuery, GetArticleAnalysisQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleAnalysisQuery, GetArticleAnalysisQueryVariables>(GetArticleAnalysisDocument, variables, options);
}
export type GetArticleAnalysisQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleAnalysisQuery, GetArticleAnalysisQueryVariables>;
export const GetArticleAnalysesDocument = gql`
    query GetArticleAnalyses($articleId: UUID!) {
  articleAnalyses(articleId: $articleId) {
    ...ArticleAnalysisDetails
  }
}
    ${ArticleAnalysisDetailsFragmentDoc}`;

/**
 * __useGetArticleAnalysesQuery__
 *
 * To run a query within a Vue component, call `useGetArticleAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleAnalysesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleAnalysesQuery({
 *   articleId: // value for 'articleId'
 * });
 */
export function useGetArticleAnalysesQuery(variables: GetArticleAnalysesQueryVariables | VueCompositionApi.Ref<GetArticleAnalysesQueryVariables> | ReactiveFunction<GetArticleAnalysesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleAnalysesQuery, GetArticleAnalysesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleAnalysesQuery, GetArticleAnalysesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleAnalysesQuery, GetArticleAnalysesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleAnalysesQuery, GetArticleAnalysesQueryVariables>(GetArticleAnalysesDocument, variables, options);
}
export function useGetArticleAnalysesLazyQuery(variables?: GetArticleAnalysesQueryVariables | VueCompositionApi.Ref<GetArticleAnalysesQueryVariables> | ReactiveFunction<GetArticleAnalysesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleAnalysesQuery, GetArticleAnalysesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleAnalysesQuery, GetArticleAnalysesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleAnalysesQuery, GetArticleAnalysesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleAnalysesQuery, GetArticleAnalysesQueryVariables>(GetArticleAnalysesDocument, variables, options);
}
export type GetArticleAnalysesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleAnalysesQuery, GetArticleAnalysesQueryVariables>;
export const GetOpenArticleAnalysesDocument = gql`
    query GetOpenArticleAnalyses {
  openArticleAnalyses {
    ...ArticleAnalysisDetails
  }
}
    ${ArticleAnalysisDetailsFragmentDoc}`;

/**
 * __useGetOpenArticleAnalysesQuery__
 *
 * To run a query within a Vue component, call `useGetOpenArticleAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenArticleAnalysesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenArticleAnalysesQuery();
 */
export function useGetOpenArticleAnalysesQuery(options: VueApolloComposable.UseQueryOptions<GetOpenArticleAnalysesQuery, GetOpenArticleAnalysesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOpenArticleAnalysesQuery, GetOpenArticleAnalysesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOpenArticleAnalysesQuery, GetOpenArticleAnalysesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOpenArticleAnalysesQuery, GetOpenArticleAnalysesQueryVariables>(GetOpenArticleAnalysesDocument, {}, options);
}
export function useGetOpenArticleAnalysesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetOpenArticleAnalysesQuery, GetOpenArticleAnalysesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOpenArticleAnalysesQuery, GetOpenArticleAnalysesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOpenArticleAnalysesQuery, GetOpenArticleAnalysesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetOpenArticleAnalysesQuery, GetOpenArticleAnalysesQueryVariables>(GetOpenArticleAnalysesDocument, {}, options);
}
export type GetOpenArticleAnalysesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOpenArticleAnalysesQuery, GetOpenArticleAnalysesQueryVariables>;
export const GetMyOpenArticleAnalysesDocument = gql`
    query GetMyOpenArticleAnalyses {
  myOpenArticleAnalyses {
    ...ArticleAnalysisDetails
  }
}
    ${ArticleAnalysisDetailsFragmentDoc}`;

/**
 * __useGetMyOpenArticleAnalysesQuery__
 *
 * To run a query within a Vue component, call `useGetMyOpenArticleAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOpenArticleAnalysesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyOpenArticleAnalysesQuery();
 */
export function useGetMyOpenArticleAnalysesQuery(options: VueApolloComposable.UseQueryOptions<GetMyOpenArticleAnalysesQuery, GetMyOpenArticleAnalysesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyOpenArticleAnalysesQuery, GetMyOpenArticleAnalysesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyOpenArticleAnalysesQuery, GetMyOpenArticleAnalysesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMyOpenArticleAnalysesQuery, GetMyOpenArticleAnalysesQueryVariables>(GetMyOpenArticleAnalysesDocument, {}, options);
}
export function useGetMyOpenArticleAnalysesLazyQuery(options: VueApolloComposable.UseQueryOptions<GetMyOpenArticleAnalysesQuery, GetMyOpenArticleAnalysesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMyOpenArticleAnalysesQuery, GetMyOpenArticleAnalysesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMyOpenArticleAnalysesQuery, GetMyOpenArticleAnalysesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMyOpenArticleAnalysesQuery, GetMyOpenArticleAnalysesQueryVariables>(GetMyOpenArticleAnalysesDocument, {}, options);
}
export type GetMyOpenArticleAnalysesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMyOpenArticleAnalysesQuery, GetMyOpenArticleAnalysesQueryVariables>;
export const StartArticleAnalysisDocument = gql`
    mutation StartArticleAnalysis($articleId: UUID!, $sentiment: AnalysisSentiment!, $preferredProvider: String) {
  startArticleAnalysis(
    articleId: $articleId
    sentiment: $sentiment
    preferredProvider: $preferredProvider
  ) {
    ...ArticleAnalysisDetails
  }
}
    ${ArticleAnalysisDetailsFragmentDoc}`;

/**
 * __useStartArticleAnalysisMutation__
 *
 * To run a mutation, you first call `useStartArticleAnalysisMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartArticleAnalysisMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartArticleAnalysisMutation({
 *   variables: {
 *     articleId: // value for 'articleId'
 *     sentiment: // value for 'sentiment'
 *     preferredProvider: // value for 'preferredProvider'
 *   },
 * });
 */
export function useStartArticleAnalysisMutation(options: VueApolloComposable.UseMutationOptions<StartArticleAnalysisMutation, StartArticleAnalysisMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartArticleAnalysisMutation, StartArticleAnalysisMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<StartArticleAnalysisMutation, StartArticleAnalysisMutationVariables>(StartArticleAnalysisDocument, options);
}
export type StartArticleAnalysisMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<StartArticleAnalysisMutation, StartArticleAnalysisMutationVariables>;
export const GetAiProvidersDocument = gql`
    query GetAiProviders {
  aiProviders {
    id
    model
    available
  }
}
    `;

/**
 * __useGetAiProvidersQuery__
 *
 * To run a query within a Vue component, call `useGetAiProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiProvidersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAiProvidersQuery();
 */
export function useGetAiProvidersQuery(options: VueApolloComposable.UseQueryOptions<GetAiProvidersQuery, GetAiProvidersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAiProvidersQuery, GetAiProvidersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAiProvidersQuery, GetAiProvidersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAiProvidersQuery, GetAiProvidersQueryVariables>(GetAiProvidersDocument, {}, options);
}
export function useGetAiProvidersLazyQuery(options: VueApolloComposable.UseQueryOptions<GetAiProvidersQuery, GetAiProvidersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAiProvidersQuery, GetAiProvidersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAiProvidersQuery, GetAiProvidersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAiProvidersQuery, GetAiProvidersQueryVariables>(GetAiProvidersDocument, {}, options);
}
export type GetAiProvidersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAiProvidersQuery, GetAiProvidersQueryVariables>;
export const ReviewArticleAnalysisSuggestionDocument = gql`
    mutation ReviewArticleAnalysisSuggestion($analysisId: UUID!, $suggestionId: UUID!, $accepted: Boolean!) {
  reviewArticleAnalysisSuggestion(
    analysisId: $analysisId
    suggestionId: $suggestionId
    accepted: $accepted
  ) {
    ...ArticleAnalysisDetails
  }
}
    ${ArticleAnalysisDetailsFragmentDoc}`;

/**
 * __useReviewArticleAnalysisSuggestionMutation__
 *
 * To run a mutation, you first call `useReviewArticleAnalysisSuggestionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReviewArticleAnalysisSuggestionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReviewArticleAnalysisSuggestionMutation({
 *   variables: {
 *     analysisId: // value for 'analysisId'
 *     suggestionId: // value for 'suggestionId'
 *     accepted: // value for 'accepted'
 *   },
 * });
 */
export function useReviewArticleAnalysisSuggestionMutation(options: VueApolloComposable.UseMutationOptions<ReviewArticleAnalysisSuggestionMutation, ReviewArticleAnalysisSuggestionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReviewArticleAnalysisSuggestionMutation, ReviewArticleAnalysisSuggestionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReviewArticleAnalysisSuggestionMutation, ReviewArticleAnalysisSuggestionMutationVariables>(ReviewArticleAnalysisSuggestionDocument, options);
}
export type ReviewArticleAnalysisSuggestionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReviewArticleAnalysisSuggestionMutation, ReviewArticleAnalysisSuggestionMutationVariables>;
export const ApplyArticleAnalysisDocument = gql`
    mutation ApplyArticleAnalysis($analysisId: UUID!) {
  applyArticleAnalysis(analysisId: $analysisId) {
    ...ArticleAnalysisDetails
  }
}
    ${ArticleAnalysisDetailsFragmentDoc}`;

/**
 * __useApplyArticleAnalysisMutation__
 *
 * To run a mutation, you first call `useApplyArticleAnalysisMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApplyArticleAnalysisMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApplyArticleAnalysisMutation({
 *   variables: {
 *     analysisId: // value for 'analysisId'
 *   },
 * });
 */
export function useApplyArticleAnalysisMutation(options: VueApolloComposable.UseMutationOptions<ApplyArticleAnalysisMutation, ApplyArticleAnalysisMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApplyArticleAnalysisMutation, ApplyArticleAnalysisMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApplyArticleAnalysisMutation, ApplyArticleAnalysisMutationVariables>(ApplyArticleAnalysisDocument, options);
}
export type ApplyArticleAnalysisMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApplyArticleAnalysisMutation, ApplyArticleAnalysisMutationVariables>;
export const CloseArticleAnalysisDocument = gql`
    mutation CloseArticleAnalysis($analysisId: UUID!) {
  closeArticleAnalysis(analysisId: $analysisId) {
    ...ArticleAnalysisDetails
  }
}
    ${ArticleAnalysisDetailsFragmentDoc}`;

/**
 * __useCloseArticleAnalysisMutation__
 *
 * To run a mutation, you first call `useCloseArticleAnalysisMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloseArticleAnalysisMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloseArticleAnalysisMutation({
 *   variables: {
 *     analysisId: // value for 'analysisId'
 *   },
 * });
 */
export function useCloseArticleAnalysisMutation(options: VueApolloComposable.UseMutationOptions<CloseArticleAnalysisMutation, CloseArticleAnalysisMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CloseArticleAnalysisMutation, CloseArticleAnalysisMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CloseArticleAnalysisMutation, CloseArticleAnalysisMutationVariables>(CloseArticleAnalysisDocument, options);
}
export type CloseArticleAnalysisMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CloseArticleAnalysisMutation, CloseArticleAnalysisMutationVariables>;
export const RetryArticleAnalysisDocument = gql`
    mutation RetryArticleAnalysis($analysisId: UUID!) {
  retryArticleAnalysis(analysisId: $analysisId) {
    ...ArticleAnalysisDetails
  }
}
    ${ArticleAnalysisDetailsFragmentDoc}`;

/**
 * __useRetryArticleAnalysisMutation__
 *
 * To run a mutation, you first call `useRetryArticleAnalysisMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetryArticleAnalysisMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetryArticleAnalysisMutation({
 *   variables: {
 *     analysisId: // value for 'analysisId'
 *   },
 * });
 */
export function useRetryArticleAnalysisMutation(options: VueApolloComposable.UseMutationOptions<RetryArticleAnalysisMutation, RetryArticleAnalysisMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RetryArticleAnalysisMutation, RetryArticleAnalysisMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RetryArticleAnalysisMutation, RetryArticleAnalysisMutationVariables>(RetryArticleAnalysisDocument, options);
}
export type RetryArticleAnalysisMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RetryArticleAnalysisMutation, RetryArticleAnalysisMutationVariables>;
export const ImportYouTubeMediaDocument = gql`
    mutation ImportYouTubeMedia($youtubeUrl: String!) {
  importYouTubeMedia(youtubeUrl: $youtubeUrl) {
    media {
      ...MediaListItem
    }
    videoUrl
  }
}
    ${MediaListItemFragmentDoc}`;

/**
 * __useImportYouTubeMediaMutation__
 *
 * To run a mutation, you first call `useImportYouTubeMediaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportYouTubeMediaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportYouTubeMediaMutation({
 *   variables: {
 *     youtubeUrl: // value for 'youtubeUrl'
 *   },
 * });
 */
export function useImportYouTubeMediaMutation(options: VueApolloComposable.UseMutationOptions<ImportYouTubeMediaMutation, ImportYouTubeMediaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ImportYouTubeMediaMutation, ImportYouTubeMediaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ImportYouTubeMediaMutation, ImportYouTubeMediaMutationVariables>(ImportYouTubeMediaDocument, options);
}
export type ImportYouTubeMediaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ImportYouTubeMediaMutation, ImportYouTubeMediaMutationVariables>;
export const FindArticleSeriesDocument = gql`
    query FindArticleSeries($page: Int!, $limit: Int!, $order: [String!], $query: String, $ids: [UUID!]) {
  findArticleSeries(
    page: $page
    limit: $limit
    order: $order
    query: $query
    ids: $ids
  ) {
    content {
      ...ArticleSeriesListItem
    }
    number
    size
    numberOfElements
    totalPages
    totalElements
    isFirst
    isLast
    hasNext
    hasPrevious
  }
}
    ${ArticleSeriesListItemFragmentDoc}`;

/**
 * __useFindArticleSeriesQuery__
 *
 * To run a query within a Vue component, call `useFindArticleSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindArticleSeriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindArticleSeriesQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   order: // value for 'order'
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 * });
 */
export function useFindArticleSeriesQuery(variables: FindArticleSeriesQueryVariables | VueCompositionApi.Ref<FindArticleSeriesQueryVariables> | ReactiveFunction<FindArticleSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindArticleSeriesQuery, FindArticleSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindArticleSeriesQuery, FindArticleSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindArticleSeriesQuery, FindArticleSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindArticleSeriesQuery, FindArticleSeriesQueryVariables>(FindArticleSeriesDocument, variables, options);
}
export function useFindArticleSeriesLazyQuery(variables?: FindArticleSeriesQueryVariables | VueCompositionApi.Ref<FindArticleSeriesQueryVariables> | ReactiveFunction<FindArticleSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindArticleSeriesQuery, FindArticleSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindArticleSeriesQuery, FindArticleSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindArticleSeriesQuery, FindArticleSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindArticleSeriesQuery, FindArticleSeriesQueryVariables>(FindArticleSeriesDocument, variables, options);
}
export type FindArticleSeriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindArticleSeriesQuery, FindArticleSeriesQueryVariables>;
export const GetArticleSeriesDocument = gql`
    query GetArticleSeries($id: UUID!) {
  articleSeries(id: $id) {
    ...ArticleSeriesDetails
  }
}
    ${ArticleSeriesDetailsFragmentDoc}`;

/**
 * __useGetArticleSeriesQuery__
 *
 * To run a query within a Vue component, call `useGetArticleSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleSeriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleSeriesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetArticleSeriesQuery(variables: GetArticleSeriesQueryVariables | VueCompositionApi.Ref<GetArticleSeriesQueryVariables> | ReactiveFunction<GetArticleSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleSeriesQuery, GetArticleSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleSeriesQuery, GetArticleSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleSeriesQuery, GetArticleSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleSeriesQuery, GetArticleSeriesQueryVariables>(GetArticleSeriesDocument, variables, options);
}
export function useGetArticleSeriesLazyQuery(variables?: GetArticleSeriesQueryVariables | VueCompositionApi.Ref<GetArticleSeriesQueryVariables> | ReactiveFunction<GetArticleSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleSeriesQuery, GetArticleSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleSeriesQuery, GetArticleSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleSeriesQuery, GetArticleSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleSeriesQuery, GetArticleSeriesQueryVariables>(GetArticleSeriesDocument, variables, options);
}
export type GetArticleSeriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleSeriesQuery, GetArticleSeriesQueryVariables>;
export const CreateArticleSeriesDocument = gql`
    mutation CreateArticleSeries($create: ArticleSeriesCreateInput!) {
  createArticleSeries(create: $create) {
    ...ArticleSeriesDetails
  }
}
    ${ArticleSeriesDetailsFragmentDoc}`;

/**
 * __useCreateArticleSeriesMutation__
 *
 * To run a mutation, you first call `useCreateArticleSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateArticleSeriesMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateArticleSeriesMutation(options: VueApolloComposable.UseMutationOptions<CreateArticleSeriesMutation, CreateArticleSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateArticleSeriesMutation, CreateArticleSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateArticleSeriesMutation, CreateArticleSeriesMutationVariables>(CreateArticleSeriesDocument, options);
}
export type CreateArticleSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateArticleSeriesMutation, CreateArticleSeriesMutationVariables>;
export const UpdateArticleSeriesDocument = gql`
    mutation UpdateArticleSeries($id: UUID!, $update: ArticleSeriesUpdateInput!, $expectedVersion: Int) {
  updateArticleSeries(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...ArticleSeriesDetails
  }
}
    ${ArticleSeriesDetailsFragmentDoc}`;

/**
 * __useUpdateArticleSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateArticleSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateArticleSeriesMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateArticleSeriesMutation(options: VueApolloComposable.UseMutationOptions<UpdateArticleSeriesMutation, UpdateArticleSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateArticleSeriesMutation, UpdateArticleSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateArticleSeriesMutation, UpdateArticleSeriesMutationVariables>(UpdateArticleSeriesDocument, options);
}
export type UpdateArticleSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateArticleSeriesMutation, UpdateArticleSeriesMutationVariables>;
export const DeleteArticleSeriesDocument = gql`
    mutation DeleteArticleSeries($id: UUID!) {
  deleteArticleSeries(id: $id) {
    uuid
  }
}
    `;

/**
 * __useDeleteArticleSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteArticleSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteArticleSeriesMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleSeriesMutation(options: VueApolloComposable.UseMutationOptions<DeleteArticleSeriesMutation, DeleteArticleSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteArticleSeriesMutation, DeleteArticleSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteArticleSeriesMutation, DeleteArticleSeriesMutationVariables>(DeleteArticleSeriesDocument, options);
}
export type DeleteArticleSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteArticleSeriesMutation, DeleteArticleSeriesMutationVariables>;
export const MyPreparationTasksDocument = gql`
    query MyPreparationTasks {
  myPreparationTasks {
    ...PreparationTaskItem
  }
}
    ${PreparationTaskItemFragmentDoc}`;

/**
 * __useMyPreparationTasksQuery__
 *
 * To run a query within a Vue component, call `useMyPreparationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPreparationTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyPreparationTasksQuery();
 */
export function useMyPreparationTasksQuery(options: VueApolloComposable.UseQueryOptions<MyPreparationTasksQuery, MyPreparationTasksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyPreparationTasksQuery, MyPreparationTasksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyPreparationTasksQuery, MyPreparationTasksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyPreparationTasksQuery, MyPreparationTasksQueryVariables>(MyPreparationTasksDocument, {}, options);
}
export function useMyPreparationTasksLazyQuery(options: VueApolloComposable.UseQueryOptions<MyPreparationTasksQuery, MyPreparationTasksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyPreparationTasksQuery, MyPreparationTasksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyPreparationTasksQuery, MyPreparationTasksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MyPreparationTasksQuery, MyPreparationTasksQueryVariables>(MyPreparationTasksDocument, {}, options);
}
export type MyPreparationTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyPreparationTasksQuery, MyPreparationTasksQueryVariables>;
export const OpenPreparationTasksDocument = gql`
    query OpenPreparationTasks($page: Int!, $limit: Int!, $order: String, $type: PreparationEntityType, $status: PreparationStatus, $possibleDuplicate: Boolean) {
  openPreparationTasks(
    page: $page
    limit: $limit
    order: $order
    type: $type
    status: $status
    possibleDuplicate: $possibleDuplicate
  ) {
    content {
      ...PreparationTaskItem
    }
    totalElements
    totalPages
    hasPrevious
    hasNext
  }
}
    ${PreparationTaskItemFragmentDoc}`;

/**
 * __useOpenPreparationTasksQuery__
 *
 * To run a query within a Vue component, call `useOpenPreparationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenPreparationTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOpenPreparationTasksQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   order: // value for 'order'
 *   type: // value for 'type'
 *   status: // value for 'status'
 *   possibleDuplicate: // value for 'possibleDuplicate'
 * });
 */
export function useOpenPreparationTasksQuery(variables: OpenPreparationTasksQueryVariables | VueCompositionApi.Ref<OpenPreparationTasksQueryVariables> | ReactiveFunction<OpenPreparationTasksQueryVariables>, options: VueApolloComposable.UseQueryOptions<OpenPreparationTasksQuery, OpenPreparationTasksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OpenPreparationTasksQuery, OpenPreparationTasksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OpenPreparationTasksQuery, OpenPreparationTasksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OpenPreparationTasksQuery, OpenPreparationTasksQueryVariables>(OpenPreparationTasksDocument, variables, options);
}
export function useOpenPreparationTasksLazyQuery(variables?: OpenPreparationTasksQueryVariables | VueCompositionApi.Ref<OpenPreparationTasksQueryVariables> | ReactiveFunction<OpenPreparationTasksQueryVariables>, options: VueApolloComposable.UseQueryOptions<OpenPreparationTasksQuery, OpenPreparationTasksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OpenPreparationTasksQuery, OpenPreparationTasksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OpenPreparationTasksQuery, OpenPreparationTasksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OpenPreparationTasksQuery, OpenPreparationTasksQueryVariables>(OpenPreparationTasksDocument, variables, options);
}
export type OpenPreparationTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OpenPreparationTasksQuery, OpenPreparationTasksQueryVariables>;
export const PreparationTaskDocument = gql`
    query PreparationTask($entityId: UUID!) {
  preparationTask(entityId: $entityId) {
    ...PreparationTaskItem
  }
}
    ${PreparationTaskItemFragmentDoc}`;

/**
 * __usePreparationTaskQuery__
 *
 * To run a query within a Vue component, call `usePreparationTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreparationTaskQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePreparationTaskQuery({
 *   entityId: // value for 'entityId'
 * });
 */
export function usePreparationTaskQuery(variables: PreparationTaskQueryVariables | VueCompositionApi.Ref<PreparationTaskQueryVariables> | ReactiveFunction<PreparationTaskQueryVariables>, options: VueApolloComposable.UseQueryOptions<PreparationTaskQuery, PreparationTaskQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PreparationTaskQuery, PreparationTaskQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PreparationTaskQuery, PreparationTaskQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PreparationTaskQuery, PreparationTaskQueryVariables>(PreparationTaskDocument, variables, options);
}
export function usePreparationTaskLazyQuery(variables?: PreparationTaskQueryVariables | VueCompositionApi.Ref<PreparationTaskQueryVariables> | ReactiveFunction<PreparationTaskQueryVariables>, options: VueApolloComposable.UseQueryOptions<PreparationTaskQuery, PreparationTaskQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PreparationTaskQuery, PreparationTaskQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PreparationTaskQuery, PreparationTaskQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PreparationTaskQuery, PreparationTaskQueryVariables>(PreparationTaskDocument, variables, options);
}
export type PreparationTaskQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PreparationTaskQuery, PreparationTaskQueryVariables>;
export const ClaimPreparationTaskDocument = gql`
    mutation ClaimPreparationTask($entityId: UUID!) {
  claimPreparationTask(entityId: $entityId) {
    ...PreparationTaskItem
  }
}
    ${PreparationTaskItemFragmentDoc}`;

/**
 * __useClaimPreparationTaskMutation__
 *
 * To run a mutation, you first call `useClaimPreparationTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClaimPreparationTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClaimPreparationTaskMutation({
 *   variables: {
 *     entityId: // value for 'entityId'
 *   },
 * });
 */
export function useClaimPreparationTaskMutation(options: VueApolloComposable.UseMutationOptions<ClaimPreparationTaskMutation, ClaimPreparationTaskMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClaimPreparationTaskMutation, ClaimPreparationTaskMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ClaimPreparationTaskMutation, ClaimPreparationTaskMutationVariables>(ClaimPreparationTaskDocument, options);
}
export type ClaimPreparationTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClaimPreparationTaskMutation, ClaimPreparationTaskMutationVariables>;
export const ReleasePreparationTaskDocument = gql`
    mutation ReleasePreparationTask($entityId: UUID!) {
  releasePreparationTask(entityId: $entityId) {
    ...PreparationTaskItem
  }
}
    ${PreparationTaskItemFragmentDoc}`;

/**
 * __useReleasePreparationTaskMutation__
 *
 * To run a mutation, you first call `useReleasePreparationTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReleasePreparationTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReleasePreparationTaskMutation({
 *   variables: {
 *     entityId: // value for 'entityId'
 *   },
 * });
 */
export function useReleasePreparationTaskMutation(options: VueApolloComposable.UseMutationOptions<ReleasePreparationTaskMutation, ReleasePreparationTaskMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReleasePreparationTaskMutation, ReleasePreparationTaskMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReleasePreparationTaskMutation, ReleasePreparationTaskMutationVariables>(ReleasePreparationTaskDocument, options);
}
export type ReleasePreparationTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReleasePreparationTaskMutation, ReleasePreparationTaskMutationVariables>;
export const CompletePreparationTaskDocument = gql`
    mutation CompletePreparationTask($entityId: UUID!) {
  completePreparationTask(entityId: $entityId)
}
    `;

/**
 * __useCompletePreparationTaskMutation__
 *
 * To run a mutation, you first call `useCompletePreparationTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompletePreparationTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompletePreparationTaskMutation({
 *   variables: {
 *     entityId: // value for 'entityId'
 *   },
 * });
 */
export function useCompletePreparationTaskMutation(options: VueApolloComposable.UseMutationOptions<CompletePreparationTaskMutation, CompletePreparationTaskMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CompletePreparationTaskMutation, CompletePreparationTaskMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CompletePreparationTaskMutation, CompletePreparationTaskMutationVariables>(CompletePreparationTaskDocument, options);
}
export type CompletePreparationTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CompletePreparationTaskMutation, CompletePreparationTaskMutationVariables>;
export const GetAuthorDocument = gql`
    query GetAuthor($id: UUID!) {
  author(id: $id) {
    ...AuthorDetails
  }
}
    ${AuthorDetailsFragmentDoc}`;

/**
 * __useGetAuthorQuery__
 *
 * To run a query within a Vue component, call `useGetAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuthorQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetAuthorQuery(variables: GetAuthorQueryVariables | VueCompositionApi.Ref<GetAuthorQueryVariables> | ReactiveFunction<GetAuthorQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAuthorQuery, GetAuthorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAuthorQuery, GetAuthorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAuthorQuery, GetAuthorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAuthorQuery, GetAuthorQueryVariables>(GetAuthorDocument, variables, options);
}
export function useGetAuthorLazyQuery(variables?: GetAuthorQueryVariables | VueCompositionApi.Ref<GetAuthorQueryVariables> | ReactiveFunction<GetAuthorQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAuthorQuery, GetAuthorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAuthorQuery, GetAuthorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAuthorQuery, GetAuthorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAuthorQuery, GetAuthorQueryVariables>(GetAuthorDocument, variables, options);
}
export type GetAuthorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAuthorQuery, GetAuthorQueryVariables>;
export const CurrentUserPrimaryAuthorDocument = gql`
    query CurrentUserPrimaryAuthor {
  currentUserPrimaryAuthor {
    ...AuthorListItem
  }
}
    ${AuthorListItemFragmentDoc}`;

/**
 * __useCurrentUserPrimaryAuthorQuery__
 *
 * To run a query within a Vue component, call `useCurrentUserPrimaryAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPrimaryAuthorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentUserPrimaryAuthorQuery();
 */
export function useCurrentUserPrimaryAuthorQuery(options: VueApolloComposable.UseQueryOptions<CurrentUserPrimaryAuthorQuery, CurrentUserPrimaryAuthorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserPrimaryAuthorQuery, CurrentUserPrimaryAuthorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserPrimaryAuthorQuery, CurrentUserPrimaryAuthorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CurrentUserPrimaryAuthorQuery, CurrentUserPrimaryAuthorQueryVariables>(CurrentUserPrimaryAuthorDocument, {}, options);
}
export function useCurrentUserPrimaryAuthorLazyQuery(options: VueApolloComposable.UseQueryOptions<CurrentUserPrimaryAuthorQuery, CurrentUserPrimaryAuthorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentUserPrimaryAuthorQuery, CurrentUserPrimaryAuthorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentUserPrimaryAuthorQuery, CurrentUserPrimaryAuthorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CurrentUserPrimaryAuthorQuery, CurrentUserPrimaryAuthorQueryVariables>(CurrentUserPrimaryAuthorDocument, {}, options);
}
export type CurrentUserPrimaryAuthorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CurrentUserPrimaryAuthorQuery, CurrentUserPrimaryAuthorQueryVariables>;
export const GetAuthorsDocument = gql`
    query GetAuthors($page: Int!, $limit: Int!) {
  allAuthors(page: $page, limit: $limit) {
    content {
      ...AuthorListItem
    }
    totalElements
    totalPages
    hasPrevious
    hasNext
  }
}
    ${AuthorListItemFragmentDoc}`;

/**
 * __useGetAuthorsQuery__
 *
 * To run a query within a Vue component, call `useGetAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuthorsQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetAuthorsQuery(variables: GetAuthorsQueryVariables | VueCompositionApi.Ref<GetAuthorsQueryVariables> | ReactiveFunction<GetAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAuthorsQuery, GetAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAuthorsQuery, GetAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAuthorsQuery, GetAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAuthorsQuery, GetAuthorsQueryVariables>(GetAuthorsDocument, variables, options);
}
export function useGetAuthorsLazyQuery(variables?: GetAuthorsQueryVariables | VueCompositionApi.Ref<GetAuthorsQueryVariables> | ReactiveFunction<GetAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAuthorsQuery, GetAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAuthorsQuery, GetAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAuthorsQuery, GetAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAuthorsQuery, GetAuthorsQueryVariables>(GetAuthorsDocument, variables, options);
}
export type GetAuthorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAuthorsQuery, GetAuthorsQueryVariables>;
export const FindAuthorsDocument = gql`
    query FindAuthors($query: String, $ids: [UUID!], $examples: [AuthorExampleInput!], $order: [String!], $page: Int!, $limit: Int!) {
  findAuthors(
    query: $query
    ids: $ids
    examples: $examples
    order: $order
    page: $page
    limit: $limit
  ) {
    content {
      ...AuthorListItem
    }
    totalElements
    totalPages
    hasPrevious
    hasNext
  }
}
    ${AuthorListItemFragmentDoc}`;

/**
 * __useFindAuthorsQuery__
 *
 * To run a query within a Vue component, call `useFindAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAuthorsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindAuthorsQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   examples: // value for 'examples'
 *   order: // value for 'order'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindAuthorsQuery(variables: FindAuthorsQueryVariables | VueCompositionApi.Ref<FindAuthorsQueryVariables> | ReactiveFunction<FindAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindAuthorsQuery, FindAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindAuthorsQuery, FindAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindAuthorsQuery, FindAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindAuthorsQuery, FindAuthorsQueryVariables>(FindAuthorsDocument, variables, options);
}
export function useFindAuthorsLazyQuery(variables?: FindAuthorsQueryVariables | VueCompositionApi.Ref<FindAuthorsQueryVariables> | ReactiveFunction<FindAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindAuthorsQuery, FindAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindAuthorsQuery, FindAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindAuthorsQuery, FindAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindAuthorsQuery, FindAuthorsQueryVariables>(FindAuthorsDocument, variables, options);
}
export type FindAuthorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindAuthorsQuery, FindAuthorsQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($query: String!, $limit: Int) {
  searchUsers(query: $query, limit: $limit) {
    ...LinkedUser
  }
}
    ${LinkedUserFragmentDoc}`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a Vue component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchUsersQuery({
 *   query: // value for 'query'
 *   limit: // value for 'limit'
 * });
 */
export function useSearchUsersQuery(variables: SearchUsersQueryVariables | VueCompositionApi.Ref<SearchUsersQueryVariables> | ReactiveFunction<SearchUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, variables, options);
}
export function useSearchUsersLazyQuery(variables?: SearchUsersQueryVariables | VueCompositionApi.Ref<SearchUsersQueryVariables> | ReactiveFunction<SearchUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SearchUsersQuery, SearchUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, variables, options);
}
export type SearchUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SearchUsersQuery, SearchUsersQueryVariables>;
export const CreateAuthorDocument = gql`
    mutation CreateAuthor($create: AuthorCreateInput!) {
  createAuthor(create: $create) {
    ...AuthorDetails
  }
}
    ${AuthorDetailsFragmentDoc}`;

/**
 * __useCreateAuthorMutation__
 *
 * To run a mutation, you first call `useCreateAuthorMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAuthorMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateAuthorMutation(options: VueApolloComposable.UseMutationOptions<CreateAuthorMutation, CreateAuthorMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAuthorMutation, CreateAuthorMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAuthorMutation, CreateAuthorMutationVariables>(CreateAuthorDocument, options);
}
export type CreateAuthorMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAuthorMutation, CreateAuthorMutationVariables>;
export const UpdateAuthorDocument = gql`
    mutation UpdateAuthor($id: UUID!, $update: AuthorUpdateInput!, $expectedVersion: Int) {
  updateAuthor(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...AuthorDetails
  }
}
    ${AuthorDetailsFragmentDoc}`;

/**
 * __useUpdateAuthorMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAuthorMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateAuthorMutation(options: VueApolloComposable.UseMutationOptions<UpdateAuthorMutation, UpdateAuthorMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAuthorMutation, UpdateAuthorMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAuthorMutation, UpdateAuthorMutationVariables>(UpdateAuthorDocument, options);
}
export type UpdateAuthorMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAuthorMutation, UpdateAuthorMutationVariables>;
export const MergeAuthorsDocument = gql`
    mutation MergeAuthors($targetId: UUID!, $sourceId: UUID!, $resolved: AuthorMergeInput!) {
  mergeAuthors(targetId: $targetId, sourceId: $sourceId, resolved: $resolved) {
    ...AuthorDetails
  }
}
    ${AuthorDetailsFragmentDoc}`;

/**
 * __useMergeAuthorsMutation__
 *
 * To run a mutation, you first call `useMergeAuthorsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMergeAuthorsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMergeAuthorsMutation({
 *   variables: {
 *     targetId: // value for 'targetId'
 *     sourceId: // value for 'sourceId'
 *     resolved: // value for 'resolved'
 *   },
 * });
 */
export function useMergeAuthorsMutation(options: VueApolloComposable.UseMutationOptions<MergeAuthorsMutation, MergeAuthorsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MergeAuthorsMutation, MergeAuthorsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MergeAuthorsMutation, MergeAuthorsMutationVariables>(MergeAuthorsDocument, options);
}
export type MergeAuthorsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MergeAuthorsMutation, MergeAuthorsMutationVariables>;
export const UsersBySubsDocument = gql`
    query UsersBySubs($subs: [ID!]!) {
  usersBySubs(subs: $subs) {
    ...LinkedUser
  }
}
    ${LinkedUserFragmentDoc}`;

/**
 * __useUsersBySubsQuery__
 *
 * To run a query within a Vue component, call `useUsersBySubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersBySubsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersBySubsQuery({
 *   subs: // value for 'subs'
 * });
 */
export function useUsersBySubsQuery(variables: UsersBySubsQueryVariables | VueCompositionApi.Ref<UsersBySubsQueryVariables> | ReactiveFunction<UsersBySubsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersBySubsQuery, UsersBySubsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersBySubsQuery, UsersBySubsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersBySubsQuery, UsersBySubsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UsersBySubsQuery, UsersBySubsQueryVariables>(UsersBySubsDocument, variables, options);
}
export function useUsersBySubsLazyQuery(variables?: UsersBySubsQueryVariables | VueCompositionApi.Ref<UsersBySubsQueryVariables> | ReactiveFunction<UsersBySubsQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersBySubsQuery, UsersBySubsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersBySubsQuery, UsersBySubsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersBySubsQuery, UsersBySubsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UsersBySubsQuery, UsersBySubsQueryVariables>(UsersBySubsDocument, variables, options);
}
export type UsersBySubsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UsersBySubsQuery, UsersBySubsQueryVariables>;
export const DeleteAuthorDocument = gql`
    mutation DeleteAuthor($id: UUID!) {
  deleteAuthor(id: $id) {
    uuid
    name
  }
}
    `;

/**
 * __useDeleteAuthorMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAuthorMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAuthorMutation(options: VueApolloComposable.UseMutationOptions<DeleteAuthorMutation, DeleteAuthorMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAuthorMutation, DeleteAuthorMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAuthorMutation, DeleteAuthorMutationVariables>(DeleteAuthorDocument, options);
}
export type DeleteAuthorMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAuthorMutation, DeleteAuthorMutationVariables>;
export const GetArticleCommentsDocument = gql`
    query GetArticleComments($articleId: UUID!, $status: [CommentModerationStatus!], $page: Int!, $limit: Int!) {
  articleComments(
    articleId: $articleId
    status: $status
    page: $page
    limit: $limit
  ) {
    content {
      ...CommentDetails
    }
    totalElements
    totalPages
    hasPrevious
    hasNext
  }
}
    ${CommentDetailsFragmentDoc}`;

/**
 * __useGetArticleCommentsQuery__
 *
 * To run a query within a Vue component, call `useGetArticleCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleCommentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleCommentsQuery({
 *   articleId: // value for 'articleId'
 *   status: // value for 'status'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetArticleCommentsQuery(variables: GetArticleCommentsQueryVariables | VueCompositionApi.Ref<GetArticleCommentsQueryVariables> | ReactiveFunction<GetArticleCommentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleCommentsQuery, GetArticleCommentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleCommentsQuery, GetArticleCommentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleCommentsQuery, GetArticleCommentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleCommentsQuery, GetArticleCommentsQueryVariables>(GetArticleCommentsDocument, variables, options);
}
export function useGetArticleCommentsLazyQuery(variables?: GetArticleCommentsQueryVariables | VueCompositionApi.Ref<GetArticleCommentsQueryVariables> | ReactiveFunction<GetArticleCommentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleCommentsQuery, GetArticleCommentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleCommentsQuery, GetArticleCommentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleCommentsQuery, GetArticleCommentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleCommentsQuery, GetArticleCommentsQueryVariables>(GetArticleCommentsDocument, variables, options);
}
export type GetArticleCommentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleCommentsQuery, GetArticleCommentsQueryVariables>;
export const GetPendingCommentsDocument = gql`
    query GetPendingComments($page: Int!, $limit: Int!) {
  pendingComments(page: $page, limit: $limit) {
    content {
      ...CommentListItem
    }
    totalElements
    totalPages
    hasPrevious
    hasNext
  }
}
    ${CommentListItemFragmentDoc}`;

/**
 * __useGetPendingCommentsQuery__
 *
 * To run a query within a Vue component, call `useGetPendingCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingCommentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPendingCommentsQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetPendingCommentsQuery(variables: GetPendingCommentsQueryVariables | VueCompositionApi.Ref<GetPendingCommentsQueryVariables> | ReactiveFunction<GetPendingCommentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPendingCommentsQuery, GetPendingCommentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPendingCommentsQuery, GetPendingCommentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPendingCommentsQuery, GetPendingCommentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPendingCommentsQuery, GetPendingCommentsQueryVariables>(GetPendingCommentsDocument, variables, options);
}
export function useGetPendingCommentsLazyQuery(variables?: GetPendingCommentsQueryVariables | VueCompositionApi.Ref<GetPendingCommentsQueryVariables> | ReactiveFunction<GetPendingCommentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPendingCommentsQuery, GetPendingCommentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPendingCommentsQuery, GetPendingCommentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPendingCommentsQuery, GetPendingCommentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPendingCommentsQuery, GetPendingCommentsQueryVariables>(GetPendingCommentsDocument, variables, options);
}
export type GetPendingCommentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPendingCommentsQuery, GetPendingCommentsQueryVariables>;
export const GetPendingCommentsCountDocument = gql`
    query GetPendingCommentsCount {
  pendingCommentsCount
}
    `;

/**
 * __useGetPendingCommentsCountQuery__
 *
 * To run a query within a Vue component, call `useGetPendingCommentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingCommentsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPendingCommentsCountQuery();
 */
export function useGetPendingCommentsCountQuery(options: VueApolloComposable.UseQueryOptions<GetPendingCommentsCountQuery, GetPendingCommentsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPendingCommentsCountQuery, GetPendingCommentsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPendingCommentsCountQuery, GetPendingCommentsCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPendingCommentsCountQuery, GetPendingCommentsCountQueryVariables>(GetPendingCommentsCountDocument, {}, options);
}
export function useGetPendingCommentsCountLazyQuery(options: VueApolloComposable.UseQueryOptions<GetPendingCommentsCountQuery, GetPendingCommentsCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPendingCommentsCountQuery, GetPendingCommentsCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPendingCommentsCountQuery, GetPendingCommentsCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPendingCommentsCountQuery, GetPendingCommentsCountQueryVariables>(GetPendingCommentsCountDocument, {}, options);
}
export type GetPendingCommentsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPendingCommentsCountQuery, GetPendingCommentsCountQueryVariables>;
export const ApproveCommentDocument = gql`
    mutation ApproveComment($id: UUID!) {
  approveComment(id: $id) {
    ...CommentDetails
  }
}
    ${CommentDetailsFragmentDoc}`;

/**
 * __useApproveCommentMutation__
 *
 * To run a mutation, you first call `useApproveCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveCommentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useApproveCommentMutation(options: VueApolloComposable.UseMutationOptions<ApproveCommentMutation, ApproveCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveCommentMutation, ApproveCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApproveCommentMutation, ApproveCommentMutationVariables>(ApproveCommentDocument, options);
}
export type ApproveCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveCommentMutation, ApproveCommentMutationVariables>;
export const RejectCommentDocument = gql`
    mutation RejectComment($id: UUID!, $reason: String!) {
  rejectComment(id: $id, reason: $reason) {
    ...CommentDetails
  }
}
    ${CommentDetailsFragmentDoc}`;

/**
 * __useRejectCommentMutation__
 *
 * To run a mutation, you first call `useRejectCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectCommentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectCommentMutation(options: VueApolloComposable.UseMutationOptions<RejectCommentMutation, RejectCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectCommentMutation, RejectCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RejectCommentMutation, RejectCommentMutationVariables>(RejectCommentDocument, options);
}
export type RejectCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectCommentMutation, RejectCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($id: UUID!) {
  deleteComment(id: $id) {
    ...CommentDetails
  }
}
    ${CommentDetailsFragmentDoc}`;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCommentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(options: VueApolloComposable.UseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
}
export type DeleteCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const CommunityActivityStreamDocument = gql`
    query CommunityActivityStream($first: Int!, $before: String, $filter: ActivityStreamFilter) {
  activityStream(
    scope: COMMUNITY
    first: $first
    before: $before
    filter: $filter
  ) {
    content {
      __typename
      ...CommentActivityFields
      ...ReactionActivityFields
      ...ReviewCommentActivityFields
    }
    oldestCursor
  }
}
    ${CommentActivityFieldsFragmentDoc}
${ReactionActivityFieldsFragmentDoc}
${ReviewCommentActivityFieldsFragmentDoc}`;

/**
 * __useCommunityActivityStreamQuery__
 *
 * To run a query within a Vue component, call `useCommunityActivityStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityActivityStreamQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCommunityActivityStreamQuery({
 *   first: // value for 'first'
 *   before: // value for 'before'
 *   filter: // value for 'filter'
 * });
 */
export function useCommunityActivityStreamQuery(variables: CommunityActivityStreamQueryVariables | VueCompositionApi.Ref<CommunityActivityStreamQueryVariables> | ReactiveFunction<CommunityActivityStreamQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommunityActivityStreamQuery, CommunityActivityStreamQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommunityActivityStreamQuery, CommunityActivityStreamQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommunityActivityStreamQuery, CommunityActivityStreamQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CommunityActivityStreamQuery, CommunityActivityStreamQueryVariables>(CommunityActivityStreamDocument, variables, options);
}
export function useCommunityActivityStreamLazyQuery(variables?: CommunityActivityStreamQueryVariables | VueCompositionApi.Ref<CommunityActivityStreamQueryVariables> | ReactiveFunction<CommunityActivityStreamQueryVariables>, options: VueApolloComposable.UseQueryOptions<CommunityActivityStreamQuery, CommunityActivityStreamQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommunityActivityStreamQuery, CommunityActivityStreamQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommunityActivityStreamQuery, CommunityActivityStreamQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CommunityActivityStreamQuery, CommunityActivityStreamQueryVariables>(CommunityActivityStreamDocument, variables, options);
}
export type CommunityActivityStreamQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CommunityActivityStreamQuery, CommunityActivityStreamQueryVariables>;
export const CommunityActivityIndicatorDocument = gql`
    query CommunityActivityIndicator {
  activityIndicator(scope: COMMUNITY) {
    unreadCount
    pendingModerationCount
  }
  activityReadState(scope: COMMUNITY) {
    lastReadAt
  }
}
    `;

/**
 * __useCommunityActivityIndicatorQuery__
 *
 * To run a query within a Vue component, call `useCommunityActivityIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityActivityIndicatorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCommunityActivityIndicatorQuery();
 */
export function useCommunityActivityIndicatorQuery(options: VueApolloComposable.UseQueryOptions<CommunityActivityIndicatorQuery, CommunityActivityIndicatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommunityActivityIndicatorQuery, CommunityActivityIndicatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommunityActivityIndicatorQuery, CommunityActivityIndicatorQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CommunityActivityIndicatorQuery, CommunityActivityIndicatorQueryVariables>(CommunityActivityIndicatorDocument, {}, options);
}
export function useCommunityActivityIndicatorLazyQuery(options: VueApolloComposable.UseQueryOptions<CommunityActivityIndicatorQuery, CommunityActivityIndicatorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CommunityActivityIndicatorQuery, CommunityActivityIndicatorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CommunityActivityIndicatorQuery, CommunityActivityIndicatorQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CommunityActivityIndicatorQuery, CommunityActivityIndicatorQueryVariables>(CommunityActivityIndicatorDocument, {}, options);
}
export type CommunityActivityIndicatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CommunityActivityIndicatorQuery, CommunityActivityIndicatorQueryVariables>;
export const MarkCommunityActivitiesReadUpToDocument = gql`
    mutation MarkCommunityActivitiesReadUpTo($timestamp: ZonedDateTime!) {
  markActivitiesReadUpTo(scope: COMMUNITY, timestamp: $timestamp) {
    unreadCount
    pendingModerationCount
  }
}
    `;

/**
 * __useMarkCommunityActivitiesReadUpToMutation__
 *
 * To run a mutation, you first call `useMarkCommunityActivitiesReadUpToMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommunityActivitiesReadUpToMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkCommunityActivitiesReadUpToMutation({
 *   variables: {
 *     timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useMarkCommunityActivitiesReadUpToMutation(options: VueApolloComposable.UseMutationOptions<MarkCommunityActivitiesReadUpToMutation, MarkCommunityActivitiesReadUpToMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MarkCommunityActivitiesReadUpToMutation, MarkCommunityActivitiesReadUpToMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MarkCommunityActivitiesReadUpToMutation, MarkCommunityActivitiesReadUpToMutationVariables>(MarkCommunityActivitiesReadUpToDocument, options);
}
export type MarkCommunityActivitiesReadUpToMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MarkCommunityActivitiesReadUpToMutation, MarkCommunityActivitiesReadUpToMutationVariables>;
export const CommunityActivityAddedDocument = gql`
    subscription CommunityActivityAdded($filter: ActivityStreamFilter) {
  activityAdded(scope: COMMUNITY, filter: $filter) {
    __typename
    ...CommentActivityFields
    ...ReactionActivityFields
    ...ReviewCommentActivityFields
  }
}
    ${CommentActivityFieldsFragmentDoc}
${ReactionActivityFieldsFragmentDoc}
${ReviewCommentActivityFieldsFragmentDoc}`;

/**
 * __useCommunityActivityAddedSubscription__
 *
 * To run a query within a Vue component, call `useCommunityActivityAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommunityActivityAddedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useCommunityActivityAddedSubscription({
 *   filter: // value for 'filter'
 * });
 */
export function useCommunityActivityAddedSubscription(variables: CommunityActivityAddedSubscriptionVariables | VueCompositionApi.Ref<CommunityActivityAddedSubscriptionVariables> | ReactiveFunction<CommunityActivityAddedSubscriptionVariables> = {}, options: VueApolloComposable.UseSubscriptionOptions<CommunityActivityAddedSubscription, CommunityActivityAddedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<CommunityActivityAddedSubscription, CommunityActivityAddedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<CommunityActivityAddedSubscription, CommunityActivityAddedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<CommunityActivityAddedSubscription, CommunityActivityAddedSubscriptionVariables>(CommunityActivityAddedDocument, variables, options);
}
export type CommunityActivityAddedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<CommunityActivityAddedSubscription, CommunityActivityAddedSubscriptionVariables>;
export const CommunityActivityChangedDocument = gql`
    subscription CommunityActivityChanged {
  activityChanged(scope: COMMUNITY) {
    __typename
    ...CommentActivityFields
    ...ReactionActivityFields
    ...ReviewCommentActivityFields
  }
}
    ${CommentActivityFieldsFragmentDoc}
${ReactionActivityFieldsFragmentDoc}
${ReviewCommentActivityFieldsFragmentDoc}`;

/**
 * __useCommunityActivityChangedSubscription__
 *
 * To run a query within a Vue component, call `useCommunityActivityChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommunityActivityChangedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useCommunityActivityChangedSubscription();
 */
export function useCommunityActivityChangedSubscription(options: VueApolloComposable.UseSubscriptionOptions<CommunityActivityChangedSubscription, CommunityActivityChangedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<CommunityActivityChangedSubscription, CommunityActivityChangedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<CommunityActivityChangedSubscription, CommunityActivityChangedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<CommunityActivityChangedSubscription, CommunityActivityChangedSubscriptionVariables>(CommunityActivityChangedDocument, {}, options);
}
export type CommunityActivityChangedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<CommunityActivityChangedSubscription, CommunityActivityChangedSubscriptionVariables>;
export const CommunityActivityRemovedDocument = gql`
    subscription CommunityActivityRemoved {
  activityRemoved(scope: COMMUNITY)
}
    `;

/**
 * __useCommunityActivityRemovedSubscription__
 *
 * To run a query within a Vue component, call `useCommunityActivityRemovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommunityActivityRemovedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useCommunityActivityRemovedSubscription();
 */
export function useCommunityActivityRemovedSubscription(options: VueApolloComposable.UseSubscriptionOptions<CommunityActivityRemovedSubscription, CommunityActivityRemovedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<CommunityActivityRemovedSubscription, CommunityActivityRemovedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<CommunityActivityRemovedSubscription, CommunityActivityRemovedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<CommunityActivityRemovedSubscription, CommunityActivityRemovedSubscriptionVariables>(CommunityActivityRemovedDocument, {}, options);
}
export type CommunityActivityRemovedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<CommunityActivityRemovedSubscription, CommunityActivityRemovedSubscriptionVariables>;
export const CommunityActivityIndicatorChangedDocument = gql`
    subscription CommunityActivityIndicatorChanged {
  activityIndicatorChanged(scope: COMMUNITY) {
    unreadCount
    pendingModerationCount
  }
}
    `;

/**
 * __useCommunityActivityIndicatorChangedSubscription__
 *
 * To run a query within a Vue component, call `useCommunityActivityIndicatorChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommunityActivityIndicatorChangedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useCommunityActivityIndicatorChangedSubscription();
 */
export function useCommunityActivityIndicatorChangedSubscription(options: VueApolloComposable.UseSubscriptionOptions<CommunityActivityIndicatorChangedSubscription, CommunityActivityIndicatorChangedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<CommunityActivityIndicatorChangedSubscription, CommunityActivityIndicatorChangedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<CommunityActivityIndicatorChangedSubscription, CommunityActivityIndicatorChangedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<CommunityActivityIndicatorChangedSubscription, CommunityActivityIndicatorChangedSubscriptionVariables>(CommunityActivityIndicatorChangedDocument, {}, options);
}
export type CommunityActivityIndicatorChangedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<CommunityActivityIndicatorChangedSubscription, CommunityActivityIndicatorChangedSubscriptionVariables>;
export const GetCompanyDocument = gql`
    query GetCompany($id: UUID!) {
  company(id: $id) {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a Vue component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompanyQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCompanyQuery(variables: GetCompanyQueryVariables | VueCompositionApi.Ref<GetCompanyQueryVariables> | ReactiveFunction<GetCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyQuery, GetCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyQuery, GetCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyQuery, GetCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, variables, options);
}
export function useGetCompanyLazyQuery(variables?: GetCompanyQueryVariables | VueCompositionApi.Ref<GetCompanyQueryVariables> | ReactiveFunction<GetCompanyQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompanyQuery, GetCompanyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompanyQuery, GetCompanyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompanyQuery, GetCompanyQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, variables, options);
}
export type GetCompanyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompaniesDocument = gql`
    query GetCompanies($page: Int!, $limit: Int!) {
  allCompanies(page: $page, limit: $limit) {
    ...CompanyPageResults
  }
}
    ${CompanyPageResultsFragmentDoc}`;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a Vue component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCompaniesQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetCompaniesQuery(variables: GetCompaniesQueryVariables | VueCompositionApi.Ref<GetCompaniesQueryVariables> | ReactiveFunction<GetCompaniesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompaniesQuery, GetCompaniesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompaniesQuery, GetCompaniesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompaniesQuery, GetCompaniesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, variables, options);
}
export function useGetCompaniesLazyQuery(variables?: GetCompaniesQueryVariables | VueCompositionApi.Ref<GetCompaniesQueryVariables> | ReactiveFunction<GetCompaniesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCompaniesQuery, GetCompaniesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCompaniesQuery, GetCompaniesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCompaniesQuery, GetCompaniesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, variables, options);
}
export type GetCompaniesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const FindCompaniesDocument = gql`
    query FindCompanies($query: String, $ids: [UUID!], $page: Int!, $limit: Int!) {
  findCompanies(query: $query, ids: $ids, page: $page, limit: $limit) {
    ...CompanyPageResults
  }
}
    ${CompanyPageResultsFragmentDoc}`;

/**
 * __useFindCompaniesQuery__
 *
 * To run a query within a Vue component, call `useFindCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCompaniesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindCompaniesQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindCompaniesQuery(variables: FindCompaniesQueryVariables | VueCompositionApi.Ref<FindCompaniesQueryVariables> | ReactiveFunction<FindCompaniesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindCompaniesQuery, FindCompaniesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindCompaniesQuery, FindCompaniesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindCompaniesQuery, FindCompaniesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindCompaniesQuery, FindCompaniesQueryVariables>(FindCompaniesDocument, variables, options);
}
export function useFindCompaniesLazyQuery(variables?: FindCompaniesQueryVariables | VueCompositionApi.Ref<FindCompaniesQueryVariables> | ReactiveFunction<FindCompaniesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindCompaniesQuery, FindCompaniesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindCompaniesQuery, FindCompaniesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindCompaniesQuery, FindCompaniesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindCompaniesQuery, FindCompaniesQueryVariables>(FindCompaniesDocument, variables, options);
}
export type FindCompaniesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindCompaniesQuery, FindCompaniesQueryVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($create: CompanyCreateInput!) {
  createCompany(create: $create) {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCompanyMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateCompanyMutation(options: VueApolloComposable.UseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
}
export type CreateCompanyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($id: UUID!, $update: CompanyUpdateInput!, $expectedVersion: Int) {
  updateCompany(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCompanyMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateCompanyMutation(options: VueApolloComposable.UseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
}
export type UpdateCompanyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const MergeCompaniesDocument = gql`
    mutation MergeCompanies($targetId: UUID!, $sourceId: UUID!, $resolved: CompanyMergeInput!) {
  mergeCompanies(targetId: $targetId, sourceId: $sourceId, resolved: $resolved) {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useMergeCompaniesMutation__
 *
 * To run a mutation, you first call `useMergeCompaniesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMergeCompaniesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMergeCompaniesMutation({
 *   variables: {
 *     targetId: // value for 'targetId'
 *     sourceId: // value for 'sourceId'
 *     resolved: // value for 'resolved'
 *   },
 * });
 */
export function useMergeCompaniesMutation(options: VueApolloComposable.UseMutationOptions<MergeCompaniesMutation, MergeCompaniesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MergeCompaniesMutation, MergeCompaniesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MergeCompaniesMutation, MergeCompaniesMutationVariables>(MergeCompaniesDocument, options);
}
export type MergeCompaniesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MergeCompaniesMutation, MergeCompaniesMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation DeleteCompany($id: UUID!) {
  deleteCompany(id: $id) {
    uuid
    name
  }
}
    `;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCompanyMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyMutation(options: VueApolloComposable.UseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
}
export type DeleteCompanyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const CreateCompanyInlineDocument = gql`
    mutation CreateCompanyInline($create: CompanyCreateInput!) {
  createCompany(create: $create) {
    ...CompanyListItem
  }
}
    ${CompanyListItemFragmentDoc}`;

/**
 * __useCreateCompanyInlineMutation__
 *
 * To run a mutation, you first call `useCreateCompanyInlineMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyInlineMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCompanyInlineMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateCompanyInlineMutation(options: VueApolloComposable.UseMutationOptions<CreateCompanyInlineMutation, CreateCompanyInlineMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCompanyInlineMutation, CreateCompanyInlineMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCompanyInlineMutation, CreateCompanyInlineMutationVariables>(CreateCompanyInlineDocument, options);
}
export type CreateCompanyInlineMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCompanyInlineMutation, CreateCompanyInlineMutationVariables>;
export const GetArticleStatsDocument = gql`
    query GetArticleStats($from: ZonedDateTime!, $until: ZonedDateTime!) {
  articleStats(from: $from, until: $until) {
    totalCount
    newsCount
    testCount
    eventCount
    podcastCount
    communityCount
    kolumneCount
  }
}
    `;

/**
 * __useGetArticleStatsQuery__
 *
 * To run a query within a Vue component, call `useGetArticleStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleStatsQuery({
 *   from: // value for 'from'
 *   until: // value for 'until'
 * });
 */
export function useGetArticleStatsQuery(variables: GetArticleStatsQueryVariables | VueCompositionApi.Ref<GetArticleStatsQueryVariables> | ReactiveFunction<GetArticleStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleStatsQuery, GetArticleStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleStatsQuery, GetArticleStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleStatsQuery, GetArticleStatsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleStatsQuery, GetArticleStatsQueryVariables>(GetArticleStatsDocument, variables, options);
}
export function useGetArticleStatsLazyQuery(variables?: GetArticleStatsQueryVariables | VueCompositionApi.Ref<GetArticleStatsQueryVariables> | ReactiveFunction<GetArticleStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleStatsQuery, GetArticleStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleStatsQuery, GetArticleStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleStatsQuery, GetArticleStatsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleStatsQuery, GetArticleStatsQueryVariables>(GetArticleStatsDocument, variables, options);
}
export type GetArticleStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleStatsQuery, GetArticleStatsQueryVariables>;
export const GetEventDocument = gql`
    query GetEvent($id: UUID!) {
  event(id: $id) {
    ...EventDetails
  }
}
    ${EventDetailsFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a Vue component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEventQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetEventQuery(variables: GetEventQueryVariables | VueCompositionApi.Ref<GetEventQueryVariables> | ReactiveFunction<GetEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, variables, options);
}
export function useGetEventLazyQuery(variables?: GetEventQueryVariables | VueCompositionApi.Ref<GetEventQueryVariables> | ReactiveFunction<GetEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEventQuery, GetEventQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, variables, options);
}
export type GetEventQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetEventQuery, GetEventQueryVariables>;
export const FindEventsDocument = gql`
    query FindEvents($query: String, $kinds: [EventKind!], $upcoming: Boolean, $ids: [UUID!], $page: Int!, $limit: Int!, $order: [String!]) {
  findEvents(
    query: $query
    kinds: $kinds
    upcoming: $upcoming
    ids: $ids
    page: $page
    limit: $limit
    order: $order
  ) {
    content {
      ...EventListItem
    }
    number
    size
    totalElements
    totalPages
    isFirst
    isLast
    hasNext
    hasPrevious
  }
}
    ${EventListItemFragmentDoc}`;

/**
 * __useFindEventsQuery__
 *
 * To run a query within a Vue component, call `useFindEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindEventsQuery({
 *   query: // value for 'query'
 *   kinds: // value for 'kinds'
 *   upcoming: // value for 'upcoming'
 *   ids: // value for 'ids'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   order: // value for 'order'
 * });
 */
export function useFindEventsQuery(variables: FindEventsQueryVariables | VueCompositionApi.Ref<FindEventsQueryVariables> | ReactiveFunction<FindEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindEventsQuery, FindEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindEventsQuery, FindEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindEventsQuery, FindEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindEventsQuery, FindEventsQueryVariables>(FindEventsDocument, variables, options);
}
export function useFindEventsLazyQuery(variables?: FindEventsQueryVariables | VueCompositionApi.Ref<FindEventsQueryVariables> | ReactiveFunction<FindEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindEventsQuery, FindEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindEventsQuery, FindEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindEventsQuery, FindEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindEventsQuery, FindEventsQueryVariables>(FindEventsDocument, variables, options);
}
export type FindEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindEventsQuery, FindEventsQueryVariables>;
export const AllEventsDocument = gql`
    query AllEvents($page: Int!, $limit: Int!, $order: [String!]) {
  allEvents(page: $page, limit: $limit, order: $order) {
    content {
      ...EventListItem
    }
    totalElements
  }
}
    ${EventListItemFragmentDoc}`;

/**
 * __useAllEventsQuery__
 *
 * To run a query within a Vue component, call `useAllEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllEventsQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   order: // value for 'order'
 * });
 */
export function useAllEventsQuery(variables: AllEventsQueryVariables | VueCompositionApi.Ref<AllEventsQueryVariables> | ReactiveFunction<AllEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllEventsQuery, AllEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllEventsQuery, AllEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllEventsQuery, AllEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllEventsQuery, AllEventsQueryVariables>(AllEventsDocument, variables, options);
}
export function useAllEventsLazyQuery(variables?: AllEventsQueryVariables | VueCompositionApi.Ref<AllEventsQueryVariables> | ReactiveFunction<AllEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllEventsQuery, AllEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllEventsQuery, AllEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllEventsQuery, AllEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllEventsQuery, AllEventsQueryVariables>(AllEventsDocument, variables, options);
}
export type AllEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllEventsQuery, AllEventsQueryVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($create: EventCreateInput!) {
  createEvent(create: $create) {
    ...EventDetails
  }
}
    ${EventDetailsFragmentDoc}`;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateEventMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateEventMutation(options: VueApolloComposable.UseMutationOptions<CreateEventMutation, CreateEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateEventMutation, CreateEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
}
export type CreateEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateEventMutation, CreateEventMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($id: UUID!, $update: EventUpdateInput!, $expectedVersion: Int) {
  updateEvent(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...EventDetails
  }
}
    ${EventDetailsFragmentDoc}`;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEventMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateEventMutation(options: VueApolloComposable.UseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
}
export type UpdateEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateEventMutation, UpdateEventMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($id: UUID!) {
  deleteEvent(id: $id) {
    uuid
    name
  }
}
    `;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteEventMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(options: VueApolloComposable.UseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
}
export type DeleteEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteEventMutation, DeleteEventMutationVariables>;
export const EditSessionsDocument = gql`
    query EditSessions($entityType: EditSessionEntityType!, $entityId: ID!) {
  editSessions(entityType: $entityType, entityId: $entityId) {
    ...EditSession
  }
}
    ${EditSessionFragmentDoc}`;

/**
 * __useEditSessionsQuery__
 *
 * To run a query within a Vue component, call `useEditSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSessionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEditSessionsQuery({
 *   entityType: // value for 'entityType'
 *   entityId: // value for 'entityId'
 * });
 */
export function useEditSessionsQuery(variables: EditSessionsQueryVariables | VueCompositionApi.Ref<EditSessionsQueryVariables> | ReactiveFunction<EditSessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<EditSessionsQuery, EditSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EditSessionsQuery, EditSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EditSessionsQuery, EditSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EditSessionsQuery, EditSessionsQueryVariables>(EditSessionsDocument, variables, options);
}
export function useEditSessionsLazyQuery(variables?: EditSessionsQueryVariables | VueCompositionApi.Ref<EditSessionsQueryVariables> | ReactiveFunction<EditSessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<EditSessionsQuery, EditSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EditSessionsQuery, EditSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EditSessionsQuery, EditSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EditSessionsQuery, EditSessionsQueryVariables>(EditSessionsDocument, variables, options);
}
export type EditSessionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EditSessionsQuery, EditSessionsQueryVariables>;
export const EditSessionHeartbeatDocument = gql`
    mutation EditSessionHeartbeat($entityType: EditSessionEntityType!, $entityId: ID!, $sessionId: ID!, $dirty: Boolean!) {
  editSessionHeartbeat(
    entityType: $entityType
    entityId: $entityId
    sessionId: $sessionId
    dirty: $dirty
  ) {
    ...EditSession
  }
}
    ${EditSessionFragmentDoc}`;

/**
 * __useEditSessionHeartbeatMutation__
 *
 * To run a mutation, you first call `useEditSessionHeartbeatMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditSessionHeartbeatMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditSessionHeartbeatMutation({
 *   variables: {
 *     entityType: // value for 'entityType'
 *     entityId: // value for 'entityId'
 *     sessionId: // value for 'sessionId'
 *     dirty: // value for 'dirty'
 *   },
 * });
 */
export function useEditSessionHeartbeatMutation(options: VueApolloComposable.UseMutationOptions<EditSessionHeartbeatMutation, EditSessionHeartbeatMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditSessionHeartbeatMutation, EditSessionHeartbeatMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditSessionHeartbeatMutation, EditSessionHeartbeatMutationVariables>(EditSessionHeartbeatDocument, options);
}
export type EditSessionHeartbeatMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditSessionHeartbeatMutation, EditSessionHeartbeatMutationVariables>;
export const EndEditSessionDocument = gql`
    mutation EndEditSession($entityType: EditSessionEntityType!, $entityId: ID!, $sessionId: ID!) {
  endEditSession(
    entityType: $entityType
    entityId: $entityId
    sessionId: $sessionId
  )
}
    `;

/**
 * __useEndEditSessionMutation__
 *
 * To run a mutation, you first call `useEndEditSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEndEditSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEndEditSessionMutation({
 *   variables: {
 *     entityType: // value for 'entityType'
 *     entityId: // value for 'entityId'
 *     sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useEndEditSessionMutation(options: VueApolloComposable.UseMutationOptions<EndEditSessionMutation, EndEditSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EndEditSessionMutation, EndEditSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EndEditSessionMutation, EndEditSessionMutationVariables>(EndEditSessionDocument, options);
}
export type EndEditSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EndEditSessionMutation, EndEditSessionMutationVariables>;
export const GetGameConsoleDocument = gql`
    query GetGameConsole($id: UUID!) {
  gameConsole(id: $id) {
    ...GameConsoleDetails
  }
}
    ${GameConsoleDetailsFragmentDoc}`;

/**
 * __useGetGameConsoleQuery__
 *
 * To run a query within a Vue component, call `useGetGameConsoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameConsoleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGameConsoleQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetGameConsoleQuery(variables: GetGameConsoleQueryVariables | VueCompositionApi.Ref<GetGameConsoleQueryVariables> | ReactiveFunction<GetGameConsoleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGameConsoleQuery, GetGameConsoleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGameConsoleQuery, GetGameConsoleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGameConsoleQuery, GetGameConsoleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGameConsoleQuery, GetGameConsoleQueryVariables>(GetGameConsoleDocument, variables, options);
}
export function useGetGameConsoleLazyQuery(variables?: GetGameConsoleQueryVariables | VueCompositionApi.Ref<GetGameConsoleQueryVariables> | ReactiveFunction<GetGameConsoleQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGameConsoleQuery, GetGameConsoleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGameConsoleQuery, GetGameConsoleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGameConsoleQuery, GetGameConsoleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGameConsoleQuery, GetGameConsoleQueryVariables>(GetGameConsoleDocument, variables, options);
}
export type GetGameConsoleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGameConsoleQuery, GetGameConsoleQueryVariables>;
export const GetGameConsolesDocument = gql`
    query GetGameConsoles($page: Int!, $limit: Int!) {
  allGameConsoles(page: $page, limit: $limit) {
    ...GameConsolePageResults
  }
}
    ${GameConsolePageResultsFragmentDoc}`;

/**
 * __useGetGameConsolesQuery__
 *
 * To run a query within a Vue component, call `useGetGameConsolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameConsolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGameConsolesQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetGameConsolesQuery(variables: GetGameConsolesQueryVariables | VueCompositionApi.Ref<GetGameConsolesQueryVariables> | ReactiveFunction<GetGameConsolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGameConsolesQuery, GetGameConsolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGameConsolesQuery, GetGameConsolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGameConsolesQuery, GetGameConsolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGameConsolesQuery, GetGameConsolesQueryVariables>(GetGameConsolesDocument, variables, options);
}
export function useGetGameConsolesLazyQuery(variables?: GetGameConsolesQueryVariables | VueCompositionApi.Ref<GetGameConsolesQueryVariables> | ReactiveFunction<GetGameConsolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGameConsolesQuery, GetGameConsolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGameConsolesQuery, GetGameConsolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGameConsolesQuery, GetGameConsolesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGameConsolesQuery, GetGameConsolesQueryVariables>(GetGameConsolesDocument, variables, options);
}
export type GetGameConsolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGameConsolesQuery, GetGameConsolesQueryVariables>;
export const FindGameConsolesDocument = gql`
    query FindGameConsoles($query: String, $ids: [UUID!], $examples: [GameConsoleExampleInput!], $order: [String!], $page: Int!, $limit: Int!) {
  findGameConsoles(
    query: $query
    ids: $ids
    examples: $examples
    order: $order
    page: $page
    limit: $limit
  ) {
    ...GameConsolePageResults
  }
}
    ${GameConsolePageResultsFragmentDoc}`;

/**
 * __useFindGameConsolesQuery__
 *
 * To run a query within a Vue component, call `useFindGameConsolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindGameConsolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindGameConsolesQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   examples: // value for 'examples'
 *   order: // value for 'order'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindGameConsolesQuery(variables: FindGameConsolesQueryVariables | VueCompositionApi.Ref<FindGameConsolesQueryVariables> | ReactiveFunction<FindGameConsolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindGameConsolesQuery, FindGameConsolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindGameConsolesQuery, FindGameConsolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindGameConsolesQuery, FindGameConsolesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindGameConsolesQuery, FindGameConsolesQueryVariables>(FindGameConsolesDocument, variables, options);
}
export function useFindGameConsolesLazyQuery(variables?: FindGameConsolesQueryVariables | VueCompositionApi.Ref<FindGameConsolesQueryVariables> | ReactiveFunction<FindGameConsolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindGameConsolesQuery, FindGameConsolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindGameConsolesQuery, FindGameConsolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindGameConsolesQuery, FindGameConsolesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindGameConsolesQuery, FindGameConsolesQueryVariables>(FindGameConsolesDocument, variables, options);
}
export type FindGameConsolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindGameConsolesQuery, FindGameConsolesQueryVariables>;
export const CreateGameConsoleDocument = gql`
    mutation CreateGameConsole($create: GameConsoleCreateInput!) {
  createGameConsole(create: $create) {
    ...GameConsoleDetails
  }
}
    ${GameConsoleDetailsFragmentDoc}`;

/**
 * __useCreateGameConsoleMutation__
 *
 * To run a mutation, you first call `useCreateGameConsoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGameConsoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGameConsoleMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateGameConsoleMutation(options: VueApolloComposable.UseMutationOptions<CreateGameConsoleMutation, CreateGameConsoleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateGameConsoleMutation, CreateGameConsoleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateGameConsoleMutation, CreateGameConsoleMutationVariables>(CreateGameConsoleDocument, options);
}
export type CreateGameConsoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateGameConsoleMutation, CreateGameConsoleMutationVariables>;
export const UpdateGameConsoleDocument = gql`
    mutation UpdateGameConsole($id: UUID!, $update: GameConsoleUpdateInput!, $expectedVersion: Int) {
  updateGameConsole(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...GameConsoleDetails
  }
}
    ${GameConsoleDetailsFragmentDoc}`;

/**
 * __useUpdateGameConsoleMutation__
 *
 * To run a mutation, you first call `useUpdateGameConsoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGameConsoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGameConsoleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateGameConsoleMutation(options: VueApolloComposable.UseMutationOptions<UpdateGameConsoleMutation, UpdateGameConsoleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateGameConsoleMutation, UpdateGameConsoleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateGameConsoleMutation, UpdateGameConsoleMutationVariables>(UpdateGameConsoleDocument, options);
}
export type UpdateGameConsoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateGameConsoleMutation, UpdateGameConsoleMutationVariables>;
export const DeleteGameConsoleDocument = gql`
    mutation DeleteGameConsole($id: UUID!) {
  deleteGameConsole(id: $id) {
    uuid
    name
  }
}
    `;

/**
 * __useDeleteGameConsoleMutation__
 *
 * To run a mutation, you first call `useDeleteGameConsoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGameConsoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGameConsoleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGameConsoleMutation(options: VueApolloComposable.UseMutationOptions<DeleteGameConsoleMutation, DeleteGameConsoleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteGameConsoleMutation, DeleteGameConsoleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteGameConsoleMutation, DeleteGameConsoleMutationVariables>(DeleteGameConsoleDocument, options);
}
export type DeleteGameConsoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteGameConsoleMutation, DeleteGameConsoleMutationVariables>;
export const GetGameDocument = gql`
    query GetGame($id: UUID!) {
  game(id: $id) {
    ...GameDetails
  }
}
    ${GameDetailsFragmentDoc}`;

/**
 * __useGetGameQuery__
 *
 * To run a query within a Vue component, call `useGetGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGameQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetGameQuery(variables: GetGameQueryVariables | VueCompositionApi.Ref<GetGameQueryVariables> | ReactiveFunction<GetGameQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGameQuery, GetGameQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGameQuery, GetGameQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGameQuery, GetGameQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGameQuery, GetGameQueryVariables>(GetGameDocument, variables, options);
}
export function useGetGameLazyQuery(variables?: GetGameQueryVariables | VueCompositionApi.Ref<GetGameQueryVariables> | ReactiveFunction<GetGameQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGameQuery, GetGameQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGameQuery, GetGameQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGameQuery, GetGameQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGameQuery, GetGameQueryVariables>(GetGameDocument, variables, options);
}
export type GetGameQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGameQuery, GetGameQueryVariables>;
export const GetGamesDocument = gql`
    query GetGames($page: Int!, $limit: Int!) {
  allGames(page: $page, limit: $limit) {
    ...GamePageResults
  }
}
    ${GamePageResultsFragmentDoc}`;

/**
 * __useGetGamesQuery__
 *
 * To run a query within a Vue component, call `useGetGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGamesQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetGamesQuery(variables: GetGamesQueryVariables | VueCompositionApi.Ref<GetGamesQueryVariables> | ReactiveFunction<GetGamesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGamesQuery, GetGamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGamesQuery, GetGamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGamesQuery, GetGamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGamesQuery, GetGamesQueryVariables>(GetGamesDocument, variables, options);
}
export function useGetGamesLazyQuery(variables?: GetGamesQueryVariables | VueCompositionApi.Ref<GetGamesQueryVariables> | ReactiveFunction<GetGamesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGamesQuery, GetGamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGamesQuery, GetGamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGamesQuery, GetGamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGamesQuery, GetGamesQueryVariables>(GetGamesDocument, variables, options);
}
export type GetGamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGamesQuery, GetGamesQueryVariables>;
export const FindGamesDocument = gql`
    query FindGames($query: String, $ids: [UUID!], $examples: [GameExampleInput!], $order: [String!], $page: Int!, $limit: Int!) {
  findGames(
    query: $query
    ids: $ids
    examples: $examples
    order: $order
    page: $page
    limit: $limit
  ) {
    ...GamePageResults
  }
}
    ${GamePageResultsFragmentDoc}`;

/**
 * __useFindGamesQuery__
 *
 * To run a query within a Vue component, call `useFindGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindGamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindGamesQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   examples: // value for 'examples'
 *   order: // value for 'order'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindGamesQuery(variables: FindGamesQueryVariables | VueCompositionApi.Ref<FindGamesQueryVariables> | ReactiveFunction<FindGamesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindGamesQuery, FindGamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindGamesQuery, FindGamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindGamesQuery, FindGamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindGamesQuery, FindGamesQueryVariables>(FindGamesDocument, variables, options);
}
export function useFindGamesLazyQuery(variables?: FindGamesQueryVariables | VueCompositionApi.Ref<FindGamesQueryVariables> | ReactiveFunction<FindGamesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindGamesQuery, FindGamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindGamesQuery, FindGamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindGamesQuery, FindGamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindGamesQuery, FindGamesQueryVariables>(FindGamesDocument, variables, options);
}
export type FindGamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindGamesQuery, FindGamesQueryVariables>;
export const CreateGameDocument = gql`
    mutation CreateGame($create: GameCreateInput!) {
  createGame(create: $create) {
    ...GameDetails
  }
}
    ${GameDetailsFragmentDoc}`;

/**
 * __useCreateGameMutation__
 *
 * To run a mutation, you first call `useCreateGameMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGameMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGameMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateGameMutation(options: VueApolloComposable.UseMutationOptions<CreateGameMutation, CreateGameMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateGameMutation, CreateGameMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateGameMutation, CreateGameMutationVariables>(CreateGameDocument, options);
}
export type CreateGameMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateGameMutation, CreateGameMutationVariables>;
export const UpdateGameDocument = gql`
    mutation UpdateGame($id: UUID!, $update: GameUpdateInput!, $expectedVersion: Int) {
  updateGame(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...GameDetails
  }
}
    ${GameDetailsFragmentDoc}`;

/**
 * __useUpdateGameMutation__
 *
 * To run a mutation, you first call `useUpdateGameMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGameMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGameMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateGameMutation(options: VueApolloComposable.UseMutationOptions<UpdateGameMutation, UpdateGameMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateGameMutation, UpdateGameMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateGameMutation, UpdateGameMutationVariables>(UpdateGameDocument, options);
}
export type UpdateGameMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateGameMutation, UpdateGameMutationVariables>;
export const DeleteGameDocument = gql`
    mutation DeleteGame($id: UUID!) {
  deleteGame(id: $id) {
    uuid
    name
  }
}
    `;

/**
 * __useDeleteGameMutation__
 *
 * To run a mutation, you first call `useDeleteGameMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGameMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGameMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGameMutation(options: VueApolloComposable.UseMutationOptions<DeleteGameMutation, DeleteGameMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteGameMutation, DeleteGameMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteGameMutation, DeleteGameMutationVariables>(DeleteGameDocument, options);
}
export type DeleteGameMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteGameMutation, DeleteGameMutationVariables>;
export const GetGameSeriesDocument = gql`
    query GetGameSeries($id: UUID!) {
  gameSeries(id: $id) {
    ...GameSeriesDetails
  }
}
    ${GameSeriesDetailsFragmentDoc}`;

/**
 * __useGetGameSeriesQuery__
 *
 * To run a query within a Vue component, call `useGetGameSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameSeriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGameSeriesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetGameSeriesQuery(variables: GetGameSeriesQueryVariables | VueCompositionApi.Ref<GetGameSeriesQueryVariables> | ReactiveFunction<GetGameSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGameSeriesQuery, GetGameSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGameSeriesQuery, GetGameSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGameSeriesQuery, GetGameSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGameSeriesQuery, GetGameSeriesQueryVariables>(GetGameSeriesDocument, variables, options);
}
export function useGetGameSeriesLazyQuery(variables?: GetGameSeriesQueryVariables | VueCompositionApi.Ref<GetGameSeriesQueryVariables> | ReactiveFunction<GetGameSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGameSeriesQuery, GetGameSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGameSeriesQuery, GetGameSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGameSeriesQuery, GetGameSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGameSeriesQuery, GetGameSeriesQueryVariables>(GetGameSeriesDocument, variables, options);
}
export type GetGameSeriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGameSeriesQuery, GetGameSeriesQueryVariables>;
export const GetAllGameSeriesDocument = gql`
    query GetAllGameSeries($page: Int!, $limit: Int!) {
  allGameSeries(page: $page, limit: $limit) {
    ...GameSeriesPageResults
  }
}
    ${GameSeriesPageResultsFragmentDoc}`;

/**
 * __useGetAllGameSeriesQuery__
 *
 * To run a query within a Vue component, call `useGetAllGameSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGameSeriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllGameSeriesQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetAllGameSeriesQuery(variables: GetAllGameSeriesQueryVariables | VueCompositionApi.Ref<GetAllGameSeriesQueryVariables> | ReactiveFunction<GetAllGameSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAllGameSeriesQuery, GetAllGameSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllGameSeriesQuery, GetAllGameSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllGameSeriesQuery, GetAllGameSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAllGameSeriesQuery, GetAllGameSeriesQueryVariables>(GetAllGameSeriesDocument, variables, options);
}
export function useGetAllGameSeriesLazyQuery(variables?: GetAllGameSeriesQueryVariables | VueCompositionApi.Ref<GetAllGameSeriesQueryVariables> | ReactiveFunction<GetAllGameSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAllGameSeriesQuery, GetAllGameSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAllGameSeriesQuery, GetAllGameSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAllGameSeriesQuery, GetAllGameSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAllGameSeriesQuery, GetAllGameSeriesQueryVariables>(GetAllGameSeriesDocument, variables, options);
}
export type GetAllGameSeriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAllGameSeriesQuery, GetAllGameSeriesQueryVariables>;
export const FindGameSeriesDocument = gql`
    query FindGameSeries($query: String, $ids: [UUID!], $page: Int!, $limit: Int!) {
  findGameSeries(query: $query, ids: $ids, page: $page, limit: $limit) {
    ...GameSeriesPageResults
  }
}
    ${GameSeriesPageResultsFragmentDoc}`;

/**
 * __useFindGameSeriesQuery__
 *
 * To run a query within a Vue component, call `useFindGameSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindGameSeriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindGameSeriesQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindGameSeriesQuery(variables: FindGameSeriesQueryVariables | VueCompositionApi.Ref<FindGameSeriesQueryVariables> | ReactiveFunction<FindGameSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindGameSeriesQuery, FindGameSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindGameSeriesQuery, FindGameSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindGameSeriesQuery, FindGameSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindGameSeriesQuery, FindGameSeriesQueryVariables>(FindGameSeriesDocument, variables, options);
}
export function useFindGameSeriesLazyQuery(variables?: FindGameSeriesQueryVariables | VueCompositionApi.Ref<FindGameSeriesQueryVariables> | ReactiveFunction<FindGameSeriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindGameSeriesQuery, FindGameSeriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindGameSeriesQuery, FindGameSeriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindGameSeriesQuery, FindGameSeriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindGameSeriesQuery, FindGameSeriesQueryVariables>(FindGameSeriesDocument, variables, options);
}
export type FindGameSeriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindGameSeriesQuery, FindGameSeriesQueryVariables>;
export const CreateGameSeriesDocument = gql`
    mutation CreateGameSeries($create: GameSeriesCreateInput!) {
  createGameSeries(create: $create) {
    ...GameSeriesDetails
  }
}
    ${GameSeriesDetailsFragmentDoc}`;

/**
 * __useCreateGameSeriesMutation__
 *
 * To run a mutation, you first call `useCreateGameSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGameSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGameSeriesMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateGameSeriesMutation(options: VueApolloComposable.UseMutationOptions<CreateGameSeriesMutation, CreateGameSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateGameSeriesMutation, CreateGameSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateGameSeriesMutation, CreateGameSeriesMutationVariables>(CreateGameSeriesDocument, options);
}
export type CreateGameSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateGameSeriesMutation, CreateGameSeriesMutationVariables>;
export const UpdateGameSeriesDocument = gql`
    mutation UpdateGameSeries($id: UUID!, $update: GameSeriesUpdateInput!, $expectedVersion: Int) {
  updateGameSeries(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...GameSeriesDetails
  }
}
    ${GameSeriesDetailsFragmentDoc}`;

/**
 * __useUpdateGameSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateGameSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGameSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGameSeriesMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateGameSeriesMutation(options: VueApolloComposable.UseMutationOptions<UpdateGameSeriesMutation, UpdateGameSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateGameSeriesMutation, UpdateGameSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateGameSeriesMutation, UpdateGameSeriesMutationVariables>(UpdateGameSeriesDocument, options);
}
export type UpdateGameSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateGameSeriesMutation, UpdateGameSeriesMutationVariables>;
export const DeleteGameSeriesDocument = gql`
    mutation DeleteGameSeries($id: UUID!) {
  deleteGameSeries(id: $id) {
    uuid
    name
  }
}
    `;

/**
 * __useDeleteGameSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteGameSeriesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGameSeriesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGameSeriesMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGameSeriesMutation(options: VueApolloComposable.UseMutationOptions<DeleteGameSeriesMutation, DeleteGameSeriesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteGameSeriesMutation, DeleteGameSeriesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteGameSeriesMutation, DeleteGameSeriesMutationVariables>(DeleteGameSeriesDocument, options);
}
export type DeleteGameSeriesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteGameSeriesMutation, DeleteGameSeriesMutationVariables>;
export const GetGenreDocument = gql`
    query GetGenre($id: UUID!) {
  genre(id: $id) {
    ...GenreDetails
  }
}
    ${GenreDetailsFragmentDoc}`;

/**
 * __useGetGenreQuery__
 *
 * To run a query within a Vue component, call `useGetGenreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenreQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGenreQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetGenreQuery(variables: GetGenreQueryVariables | VueCompositionApi.Ref<GetGenreQueryVariables> | ReactiveFunction<GetGenreQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGenreQuery, GetGenreQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGenreQuery, GetGenreQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGenreQuery, GetGenreQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGenreQuery, GetGenreQueryVariables>(GetGenreDocument, variables, options);
}
export function useGetGenreLazyQuery(variables?: GetGenreQueryVariables | VueCompositionApi.Ref<GetGenreQueryVariables> | ReactiveFunction<GetGenreQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGenreQuery, GetGenreQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGenreQuery, GetGenreQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGenreQuery, GetGenreQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGenreQuery, GetGenreQueryVariables>(GetGenreDocument, variables, options);
}
export type GetGenreQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGenreQuery, GetGenreQueryVariables>;
export const GetGenresDocument = gql`
    query GetGenres($page: Int!, $limit: Int!) {
  allGenres(page: $page, limit: $limit) {
    ...GenrePageResults
  }
}
    ${GenrePageResultsFragmentDoc}`;

/**
 * __useGetGenresQuery__
 *
 * To run a query within a Vue component, call `useGetGenresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenresQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGenresQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetGenresQuery(variables: GetGenresQueryVariables | VueCompositionApi.Ref<GetGenresQueryVariables> | ReactiveFunction<GetGenresQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGenresQuery, GetGenresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGenresQuery, GetGenresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGenresQuery, GetGenresQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetGenresQuery, GetGenresQueryVariables>(GetGenresDocument, variables, options);
}
export function useGetGenresLazyQuery(variables?: GetGenresQueryVariables | VueCompositionApi.Ref<GetGenresQueryVariables> | ReactiveFunction<GetGenresQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetGenresQuery, GetGenresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetGenresQuery, GetGenresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetGenresQuery, GetGenresQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetGenresQuery, GetGenresQueryVariables>(GetGenresDocument, variables, options);
}
export type GetGenresQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetGenresQuery, GetGenresQueryVariables>;
export const FindGenresDocument = gql`
    query FindGenres($query: String, $ids: [UUID!], $page: Int!, $limit: Int!) {
  findGenres(query: $query, ids: $ids, page: $page, limit: $limit) {
    ...GenrePageResults
  }
}
    ${GenrePageResultsFragmentDoc}`;

/**
 * __useFindGenresQuery__
 *
 * To run a query within a Vue component, call `useFindGenresQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindGenresQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindGenresQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindGenresQuery(variables: FindGenresQueryVariables | VueCompositionApi.Ref<FindGenresQueryVariables> | ReactiveFunction<FindGenresQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindGenresQuery, FindGenresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindGenresQuery, FindGenresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindGenresQuery, FindGenresQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindGenresQuery, FindGenresQueryVariables>(FindGenresDocument, variables, options);
}
export function useFindGenresLazyQuery(variables?: FindGenresQueryVariables | VueCompositionApi.Ref<FindGenresQueryVariables> | ReactiveFunction<FindGenresQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindGenresQuery, FindGenresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindGenresQuery, FindGenresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindGenresQuery, FindGenresQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindGenresQuery, FindGenresQueryVariables>(FindGenresDocument, variables, options);
}
export type FindGenresQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindGenresQuery, FindGenresQueryVariables>;
export const CreateGenreDocument = gql`
    mutation CreateGenre($create: GenreCreateInput!) {
  createGenre(create: $create) {
    ...GenreDetails
  }
}
    ${GenreDetailsFragmentDoc}`;

/**
 * __useCreateGenreMutation__
 *
 * To run a mutation, you first call `useCreateGenreMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenreMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGenreMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateGenreMutation(options: VueApolloComposable.UseMutationOptions<CreateGenreMutation, CreateGenreMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateGenreMutation, CreateGenreMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateGenreMutation, CreateGenreMutationVariables>(CreateGenreDocument, options);
}
export type CreateGenreMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateGenreMutation, CreateGenreMutationVariables>;
export const UpdateGenreDocument = gql`
    mutation UpdateGenre($id: UUID!, $update: GenreUpdateInput!, $expectedVersion: Int) {
  updateGenre(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...GenreDetails
  }
}
    ${GenreDetailsFragmentDoc}`;

/**
 * __useUpdateGenreMutation__
 *
 * To run a mutation, you first call `useUpdateGenreMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenreMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGenreMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateGenreMutation(options: VueApolloComposable.UseMutationOptions<UpdateGenreMutation, UpdateGenreMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateGenreMutation, UpdateGenreMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateGenreMutation, UpdateGenreMutationVariables>(UpdateGenreDocument, options);
}
export type UpdateGenreMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateGenreMutation, UpdateGenreMutationVariables>;
export const DeleteGenreDocument = gql`
    mutation DeleteGenre($id: UUID!) {
  deleteGenre(id: $id) {
    uuid
    name
  }
}
    `;

/**
 * __useDeleteGenreMutation__
 *
 * To run a mutation, you first call `useDeleteGenreMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenreMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGenreMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGenreMutation(options: VueApolloComposable.UseMutationOptions<DeleteGenreMutation, DeleteGenreMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteGenreMutation, DeleteGenreMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteGenreMutation, DeleteGenreMutationVariables>(DeleteGenreDocument, options);
}
export type DeleteGenreMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteGenreMutation, DeleteGenreMutationVariables>;
export const GetMediaDocument = gql`
    query GetMedia($id: UUID!) {
  media(id: $id) {
    ...MediaDetails
  }
}
    ${MediaDetailsFragmentDoc}`;

/**
 * __useGetMediaQuery__
 *
 * To run a query within a Vue component, call `useGetMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMediaQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetMediaQuery(variables: GetMediaQueryVariables | VueCompositionApi.Ref<GetMediaQueryVariables> | ReactiveFunction<GetMediaQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMediaQuery, GetMediaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMediaQuery, GetMediaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMediaQuery, GetMediaQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMediaQuery, GetMediaQueryVariables>(GetMediaDocument, variables, options);
}
export function useGetMediaLazyQuery(variables?: GetMediaQueryVariables | VueCompositionApi.Ref<GetMediaQueryVariables> | ReactiveFunction<GetMediaQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMediaQuery, GetMediaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMediaQuery, GetMediaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMediaQuery, GetMediaQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMediaQuery, GetMediaQueryVariables>(GetMediaDocument, variables, options);
}
export type GetMediaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMediaQuery, GetMediaQueryVariables>;
export const GetMediasDocument = gql`
    query GetMedias($page: Int!, $limit: Int!) {
  allMedia(page: $page, limit: $limit) {
    ...MediaPageResults
  }
}
    ${MediaPageResultsFragmentDoc}`;

/**
 * __useGetMediasQuery__
 *
 * To run a query within a Vue component, call `useGetMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediasQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMediasQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetMediasQuery(variables: GetMediasQueryVariables | VueCompositionApi.Ref<GetMediasQueryVariables> | ReactiveFunction<GetMediasQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMediasQuery, GetMediasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMediasQuery, GetMediasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMediasQuery, GetMediasQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetMediasQuery, GetMediasQueryVariables>(GetMediasDocument, variables, options);
}
export function useGetMediasLazyQuery(variables?: GetMediasQueryVariables | VueCompositionApi.Ref<GetMediasQueryVariables> | ReactiveFunction<GetMediasQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetMediasQuery, GetMediasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetMediasQuery, GetMediasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetMediasQuery, GetMediasQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetMediasQuery, GetMediasQueryVariables>(GetMediasDocument, variables, options);
}
export type GetMediasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetMediasQuery, GetMediasQueryVariables>;
export const FindMediasDocument = gql`
    query FindMedias($query: String, $ids: [UUID!], $examples: [MediaExampleInput!], $page: Int!, $limit: Int!, $order: [String!]) {
  findMedia(
    query: $query
    ids: $ids
    examples: $examples
    page: $page
    limit: $limit
    order: $order
  ) {
    ...MediaPageResults
  }
}
    ${MediaPageResultsFragmentDoc}`;

/**
 * __useFindMediasQuery__
 *
 * To run a query within a Vue component, call `useFindMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMediasQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindMediasQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   examples: // value for 'examples'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   order: // value for 'order'
 * });
 */
export function useFindMediasQuery(variables: FindMediasQueryVariables | VueCompositionApi.Ref<FindMediasQueryVariables> | ReactiveFunction<FindMediasQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindMediasQuery, FindMediasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindMediasQuery, FindMediasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindMediasQuery, FindMediasQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindMediasQuery, FindMediasQueryVariables>(FindMediasDocument, variables, options);
}
export function useFindMediasLazyQuery(variables?: FindMediasQueryVariables | VueCompositionApi.Ref<FindMediasQueryVariables> | ReactiveFunction<FindMediasQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindMediasQuery, FindMediasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindMediasQuery, FindMediasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindMediasQuery, FindMediasQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindMediasQuery, FindMediasQueryVariables>(FindMediasDocument, variables, options);
}
export type FindMediasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindMediasQuery, FindMediasQueryVariables>;
export const UpdateMediaDocument = gql`
    mutation UpdateMedia($id: UUID!, $update: MediaUpdateInput!, $expectedVersion: Int) {
  updateMedia(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...MediaDetails
  }
}
    ${MediaDetailsFragmentDoc}`;

/**
 * __useUpdateMediaMutation__
 *
 * To run a mutation, you first call `useUpdateMediaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMediaMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateMediaMutation(options: VueApolloComposable.UseMutationOptions<UpdateMediaMutation, UpdateMediaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMediaMutation, UpdateMediaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMediaMutation, UpdateMediaMutationVariables>(UpdateMediaDocument, options);
}
export type UpdateMediaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMediaMutation, UpdateMediaMutationVariables>;
export const DeleteMediaDocument = gql`
    mutation DeleteMedia($id: UUID!) {
  deleteMedia(id: $id) {
    uuid
  }
}
    `;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMediaMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMediaMutation(options: VueApolloComposable.UseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMediaMutation, DeleteMediaMutationVariables>(DeleteMediaDocument, options);
}
export type DeleteMediaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMediaMutation, DeleteMediaMutationVariables>;
export const FindMediasForBatchEditDocument = gql`
    query FindMediasForBatchEdit($ids: [UUID!]!) {
  findMedia(ids: $ids, page: 0, limit: 500, order: ["filename"]) {
    content {
      ...MediaBatchEditItem
    }
    totalElements
  }
}
    ${MediaBatchEditItemFragmentDoc}`;

/**
 * __useFindMediasForBatchEditQuery__
 *
 * To run a query within a Vue component, call `useFindMediasForBatchEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMediasForBatchEditQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindMediasForBatchEditQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useFindMediasForBatchEditQuery(variables: FindMediasForBatchEditQueryVariables | VueCompositionApi.Ref<FindMediasForBatchEditQueryVariables> | ReactiveFunction<FindMediasForBatchEditQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindMediasForBatchEditQuery, FindMediasForBatchEditQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindMediasForBatchEditQuery, FindMediasForBatchEditQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindMediasForBatchEditQuery, FindMediasForBatchEditQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindMediasForBatchEditQuery, FindMediasForBatchEditQueryVariables>(FindMediasForBatchEditDocument, variables, options);
}
export function useFindMediasForBatchEditLazyQuery(variables?: FindMediasForBatchEditQueryVariables | VueCompositionApi.Ref<FindMediasForBatchEditQueryVariables> | ReactiveFunction<FindMediasForBatchEditQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindMediasForBatchEditQuery, FindMediasForBatchEditQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindMediasForBatchEditQuery, FindMediasForBatchEditQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindMediasForBatchEditQuery, FindMediasForBatchEditQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindMediasForBatchEditQuery, FindMediasForBatchEditQueryVariables>(FindMediasForBatchEditDocument, variables, options);
}
export type FindMediasForBatchEditQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindMediasForBatchEditQuery, FindMediasForBatchEditQueryVariables>;
export const GetQuickFilterDocument = gql`
    query GetQuickFilter($id: UUID!) {
  quickFilter(id: $id) {
    ...QuickFilterDetails
  }
}
    ${QuickFilterDetailsFragmentDoc}`;

/**
 * __useGetQuickFilterQuery__
 *
 * To run a query within a Vue component, call `useGetQuickFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickFilterQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuickFilterQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetQuickFilterQuery(variables: GetQuickFilterQueryVariables | VueCompositionApi.Ref<GetQuickFilterQueryVariables> | ReactiveFunction<GetQuickFilterQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuickFilterQuery, GetQuickFilterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuickFilterQuery, GetQuickFilterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuickFilterQuery, GetQuickFilterQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQuickFilterQuery, GetQuickFilterQueryVariables>(GetQuickFilterDocument, variables, options);
}
export function useGetQuickFilterLazyQuery(variables?: GetQuickFilterQueryVariables | VueCompositionApi.Ref<GetQuickFilterQueryVariables> | ReactiveFunction<GetQuickFilterQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuickFilterQuery, GetQuickFilterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuickFilterQuery, GetQuickFilterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuickFilterQuery, GetQuickFilterQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQuickFilterQuery, GetQuickFilterQueryVariables>(GetQuickFilterDocument, variables, options);
}
export type GetQuickFilterQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQuickFilterQuery, GetQuickFilterQueryVariables>;
export const GetQuickFiltersDocument = gql`
    query GetQuickFilters($page: Int!, $limit: Int!) {
  allQuickFilters(page: $page, limit: $limit) {
    ...QuickFilterPageResults
  }
}
    ${QuickFilterPageResultsFragmentDoc}`;

/**
 * __useGetQuickFiltersQuery__
 *
 * To run a query within a Vue component, call `useGetQuickFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickFiltersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuickFiltersQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetQuickFiltersQuery(variables: GetQuickFiltersQueryVariables | VueCompositionApi.Ref<GetQuickFiltersQueryVariables> | ReactiveFunction<GetQuickFiltersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuickFiltersQuery, GetQuickFiltersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>(GetQuickFiltersDocument, variables, options);
}
export function useGetQuickFiltersLazyQuery(variables?: GetQuickFiltersQueryVariables | VueCompositionApi.Ref<GetQuickFiltersQueryVariables> | ReactiveFunction<GetQuickFiltersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetQuickFiltersQuery, GetQuickFiltersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>(GetQuickFiltersDocument, variables, options);
}
export type GetQuickFiltersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetQuickFiltersQuery, GetQuickFiltersQueryVariables>;
export const FindQuickFiltersDocument = gql`
    query FindQuickFilters($query: String, $visibleOn: ArticleListPage, $page: Int!, $limit: Int!) {
  findQuickFilters(
    query: $query
    visibleOn: $visibleOn
    page: $page
    limit: $limit
  ) {
    ...QuickFilterPageResults
  }
}
    ${QuickFilterPageResultsFragmentDoc}`;

/**
 * __useFindQuickFiltersQuery__
 *
 * To run a query within a Vue component, call `useFindQuickFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindQuickFiltersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindQuickFiltersQuery({
 *   query: // value for 'query'
 *   visibleOn: // value for 'visibleOn'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindQuickFiltersQuery(variables: FindQuickFiltersQueryVariables | VueCompositionApi.Ref<FindQuickFiltersQueryVariables> | ReactiveFunction<FindQuickFiltersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindQuickFiltersQuery, FindQuickFiltersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindQuickFiltersQuery, FindQuickFiltersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindQuickFiltersQuery, FindQuickFiltersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindQuickFiltersQuery, FindQuickFiltersQueryVariables>(FindQuickFiltersDocument, variables, options);
}
export function useFindQuickFiltersLazyQuery(variables?: FindQuickFiltersQueryVariables | VueCompositionApi.Ref<FindQuickFiltersQueryVariables> | ReactiveFunction<FindQuickFiltersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindQuickFiltersQuery, FindQuickFiltersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindQuickFiltersQuery, FindQuickFiltersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindQuickFiltersQuery, FindQuickFiltersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindQuickFiltersQuery, FindQuickFiltersQueryVariables>(FindQuickFiltersDocument, variables, options);
}
export type FindQuickFiltersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindQuickFiltersQuery, FindQuickFiltersQueryVariables>;
export const CreateQuickFilterDocument = gql`
    mutation CreateQuickFilter($create: QuickFilterCreateInput!) {
  createQuickFilter(create: $create) {
    ...QuickFilterDetails
  }
}
    ${QuickFilterDetailsFragmentDoc}`;

/**
 * __useCreateQuickFilterMutation__
 *
 * To run a mutation, you first call `useCreateQuickFilterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuickFilterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQuickFilterMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateQuickFilterMutation(options: VueApolloComposable.UseMutationOptions<CreateQuickFilterMutation, CreateQuickFilterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateQuickFilterMutation, CreateQuickFilterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateQuickFilterMutation, CreateQuickFilterMutationVariables>(CreateQuickFilterDocument, options);
}
export type CreateQuickFilterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateQuickFilterMutation, CreateQuickFilterMutationVariables>;
export const UpdateQuickFilterDocument = gql`
    mutation UpdateQuickFilter($id: UUID!, $update: QuickFilterUpdateInput!, $expectedVersion: Int) {
  updateQuickFilter(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...QuickFilterDetails
  }
}
    ${QuickFilterDetailsFragmentDoc}`;

/**
 * __useUpdateQuickFilterMutation__
 *
 * To run a mutation, you first call `useUpdateQuickFilterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickFilterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuickFilterMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateQuickFilterMutation(options: VueApolloComposable.UseMutationOptions<UpdateQuickFilterMutation, UpdateQuickFilterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateQuickFilterMutation, UpdateQuickFilterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateQuickFilterMutation, UpdateQuickFilterMutationVariables>(UpdateQuickFilterDocument, options);
}
export type UpdateQuickFilterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateQuickFilterMutation, UpdateQuickFilterMutationVariables>;
export const ReorderQuickFiltersDocument = gql`
    mutation ReorderQuickFilters($orderedIds: [UUID!]!) {
  reorderQuickFilters(orderedIds: $orderedIds) {
    ...QuickFilterListItem
  }
}
    ${QuickFilterListItemFragmentDoc}`;

/**
 * __useReorderQuickFiltersMutation__
 *
 * To run a mutation, you first call `useReorderQuickFiltersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReorderQuickFiltersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReorderQuickFiltersMutation({
 *   variables: {
 *     orderedIds: // value for 'orderedIds'
 *   },
 * });
 */
export function useReorderQuickFiltersMutation(options: VueApolloComposable.UseMutationOptions<ReorderQuickFiltersMutation, ReorderQuickFiltersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReorderQuickFiltersMutation, ReorderQuickFiltersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReorderQuickFiltersMutation, ReorderQuickFiltersMutationVariables>(ReorderQuickFiltersDocument, options);
}
export type ReorderQuickFiltersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReorderQuickFiltersMutation, ReorderQuickFiltersMutationVariables>;
export const DeleteQuickFilterDocument = gql`
    mutation DeleteQuickFilter($id: UUID!) {
  deleteQuickFilter(id: $id) {
    ...QuickFilterListItem
  }
}
    ${QuickFilterListItemFragmentDoc}`;

/**
 * __useDeleteQuickFilterMutation__
 *
 * To run a mutation, you first call `useDeleteQuickFilterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuickFilterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteQuickFilterMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuickFilterMutation(options: VueApolloComposable.UseMutationOptions<DeleteQuickFilterMutation, DeleteQuickFilterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteQuickFilterMutation, DeleteQuickFilterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteQuickFilterMutation, DeleteQuickFilterMutationVariables>(DeleteQuickFilterDocument, options);
}
export type DeleteQuickFilterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteQuickFilterMutation, DeleteQuickFilterMutationVariables>;
export const GetRatingCategoryDocument = gql`
    query GetRatingCategory($id: UUID!) {
  ratingCategory(id: $id) {
    ...RatingCategoryDetails
  }
}
    ${RatingCategoryDetailsFragmentDoc}`;

/**
 * __useGetRatingCategoryQuery__
 *
 * To run a query within a Vue component, call `useGetRatingCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingCategoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRatingCategoryQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetRatingCategoryQuery(variables: GetRatingCategoryQueryVariables | VueCompositionApi.Ref<GetRatingCategoryQueryVariables> | ReactiveFunction<GetRatingCategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRatingCategoryQuery, GetRatingCategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRatingCategoryQuery, GetRatingCategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRatingCategoryQuery, GetRatingCategoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRatingCategoryQuery, GetRatingCategoryQueryVariables>(GetRatingCategoryDocument, variables, options);
}
export function useGetRatingCategoryLazyQuery(variables?: GetRatingCategoryQueryVariables | VueCompositionApi.Ref<GetRatingCategoryQueryVariables> | ReactiveFunction<GetRatingCategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRatingCategoryQuery, GetRatingCategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRatingCategoryQuery, GetRatingCategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRatingCategoryQuery, GetRatingCategoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRatingCategoryQuery, GetRatingCategoryQueryVariables>(GetRatingCategoryDocument, variables, options);
}
export type GetRatingCategoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRatingCategoryQuery, GetRatingCategoryQueryVariables>;
export const GetRatingCategoriesDocument = gql`
    query GetRatingCategories($page: Int!, $limit: Int!) {
  allRatingCategories(page: $page, limit: $limit) {
    ...RatingCategoryPageResults
  }
}
    ${RatingCategoryPageResultsFragmentDoc}`;

/**
 * __useGetRatingCategoriesQuery__
 *
 * To run a query within a Vue component, call `useGetRatingCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRatingCategoriesQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetRatingCategoriesQuery(variables: GetRatingCategoriesQueryVariables | VueCompositionApi.Ref<GetRatingCategoriesQueryVariables> | ReactiveFunction<GetRatingCategoriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRatingCategoriesQuery, GetRatingCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRatingCategoriesQuery, GetRatingCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRatingCategoriesQuery, GetRatingCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRatingCategoriesQuery, GetRatingCategoriesQueryVariables>(GetRatingCategoriesDocument, variables, options);
}
export function useGetRatingCategoriesLazyQuery(variables?: GetRatingCategoriesQueryVariables | VueCompositionApi.Ref<GetRatingCategoriesQueryVariables> | ReactiveFunction<GetRatingCategoriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRatingCategoriesQuery, GetRatingCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRatingCategoriesQuery, GetRatingCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRatingCategoriesQuery, GetRatingCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRatingCategoriesQuery, GetRatingCategoriesQueryVariables>(GetRatingCategoriesDocument, variables, options);
}
export type GetRatingCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRatingCategoriesQuery, GetRatingCategoriesQueryVariables>;
export const GetRatingCategoryDetailsDocument = gql`
    query GetRatingCategoryDetails($page: Int!, $limit: Int!) {
  allRatingCategories(page: $page, limit: $limit) {
    ...RatingCategoryDetailsPageResults
  }
}
    ${RatingCategoryDetailsPageResultsFragmentDoc}`;

/**
 * __useGetRatingCategoryDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetRatingCategoryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingCategoryDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRatingCategoryDetailsQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetRatingCategoryDetailsQuery(variables: GetRatingCategoryDetailsQueryVariables | VueCompositionApi.Ref<GetRatingCategoryDetailsQueryVariables> | ReactiveFunction<GetRatingCategoryDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRatingCategoryDetailsQuery, GetRatingCategoryDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRatingCategoryDetailsQuery, GetRatingCategoryDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRatingCategoryDetailsQuery, GetRatingCategoryDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRatingCategoryDetailsQuery, GetRatingCategoryDetailsQueryVariables>(GetRatingCategoryDetailsDocument, variables, options);
}
export function useGetRatingCategoryDetailsLazyQuery(variables?: GetRatingCategoryDetailsQueryVariables | VueCompositionApi.Ref<GetRatingCategoryDetailsQueryVariables> | ReactiveFunction<GetRatingCategoryDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRatingCategoryDetailsQuery, GetRatingCategoryDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRatingCategoryDetailsQuery, GetRatingCategoryDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRatingCategoryDetailsQuery, GetRatingCategoryDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetRatingCategoryDetailsQuery, GetRatingCategoryDetailsQueryVariables>(GetRatingCategoryDetailsDocument, variables, options);
}
export type GetRatingCategoryDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRatingCategoryDetailsQuery, GetRatingCategoryDetailsQueryVariables>;
export const FindRatingCategoriesDocument = gql`
    query FindRatingCategories($query: String, $ids: [UUID!], $page: Int!, $limit: Int!) {
  findRatingCategories(query: $query, ids: $ids, page: $page, limit: $limit) {
    ...RatingCategoryPageResults
  }
}
    ${RatingCategoryPageResultsFragmentDoc}`;

/**
 * __useFindRatingCategoriesQuery__
 *
 * To run a query within a Vue component, call `useFindRatingCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRatingCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindRatingCategoriesQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindRatingCategoriesQuery(variables: FindRatingCategoriesQueryVariables | VueCompositionApi.Ref<FindRatingCategoriesQueryVariables> | ReactiveFunction<FindRatingCategoriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindRatingCategoriesQuery, FindRatingCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindRatingCategoriesQuery, FindRatingCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindRatingCategoriesQuery, FindRatingCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindRatingCategoriesQuery, FindRatingCategoriesQueryVariables>(FindRatingCategoriesDocument, variables, options);
}
export function useFindRatingCategoriesLazyQuery(variables?: FindRatingCategoriesQueryVariables | VueCompositionApi.Ref<FindRatingCategoriesQueryVariables> | ReactiveFunction<FindRatingCategoriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindRatingCategoriesQuery, FindRatingCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindRatingCategoriesQuery, FindRatingCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindRatingCategoriesQuery, FindRatingCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindRatingCategoriesQuery, FindRatingCategoriesQueryVariables>(FindRatingCategoriesDocument, variables, options);
}
export type FindRatingCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindRatingCategoriesQuery, FindRatingCategoriesQueryVariables>;
export const CreateRatingCategoryDocument = gql`
    mutation CreateRatingCategory($create: RatingCategoryCreateInput!) {
  createRatingCategory(create: $create) {
    ...RatingCategoryDetails
  }
}
    ${RatingCategoryDetailsFragmentDoc}`;

/**
 * __useCreateRatingCategoryMutation__
 *
 * To run a mutation, you first call `useCreateRatingCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRatingCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRatingCategoryMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateRatingCategoryMutation(options: VueApolloComposable.UseMutationOptions<CreateRatingCategoryMutation, CreateRatingCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateRatingCategoryMutation, CreateRatingCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateRatingCategoryMutation, CreateRatingCategoryMutationVariables>(CreateRatingCategoryDocument, options);
}
export type CreateRatingCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateRatingCategoryMutation, CreateRatingCategoryMutationVariables>;
export const UpdateRatingCategoryDocument = gql`
    mutation UpdateRatingCategory($id: UUID!, $update: RatingCategoryUpdateInput!, $expectedVersion: Int) {
  updateRatingCategory(
    id: $id
    update: $update
    expectedVersion: $expectedVersion
  ) {
    ...RatingCategoryDetails
  }
}
    ${RatingCategoryDetailsFragmentDoc}`;

/**
 * __useUpdateRatingCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateRatingCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRatingCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRatingCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateRatingCategoryMutation(options: VueApolloComposable.UseMutationOptions<UpdateRatingCategoryMutation, UpdateRatingCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateRatingCategoryMutation, UpdateRatingCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateRatingCategoryMutation, UpdateRatingCategoryMutationVariables>(UpdateRatingCategoryDocument, options);
}
export type UpdateRatingCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateRatingCategoryMutation, UpdateRatingCategoryMutationVariables>;
export const DeleteRatingCategoryDocument = gql`
    mutation DeleteRatingCategory($id: UUID!) {
  deleteRatingCategory(id: $id) {
    ...RatingCategoryListItem
  }
}
    ${RatingCategoryListItemFragmentDoc}`;

/**
 * __useDeleteRatingCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteRatingCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRatingCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRatingCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRatingCategoryMutation(options: VueApolloComposable.UseMutationOptions<DeleteRatingCategoryMutation, DeleteRatingCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteRatingCategoryMutation, DeleteRatingCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteRatingCategoryMutation, DeleteRatingCategoryMutationVariables>(DeleteRatingCategoryDocument, options);
}
export type DeleteRatingCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteRatingCategoryMutation, DeleteRatingCategoryMutationVariables>;
export const AdminSearchDocument = gql`
    query AdminSearch($query: String!, $groups: [AdminSearchGroupInput!]!) {
  adminSearch(query: $query, groups: $groups) {
    query
    groups {
      key
      totalHits
      page
      size
      results {
        ...AdminSearchResultItem
      }
    }
  }
}
    ${AdminSearchResultItemFragmentDoc}`;

/**
 * __useAdminSearchQuery__
 *
 * To run a query within a Vue component, call `useAdminSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminSearchQuery({
 *   query: // value for 'query'
 *   groups: // value for 'groups'
 * });
 */
export function useAdminSearchQuery(variables: AdminSearchQueryVariables | VueCompositionApi.Ref<AdminSearchQueryVariables> | ReactiveFunction<AdminSearchQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminSearchQuery, AdminSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminSearchQuery, AdminSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminSearchQuery, AdminSearchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminSearchQuery, AdminSearchQueryVariables>(AdminSearchDocument, variables, options);
}
export function useAdminSearchLazyQuery(variables?: AdminSearchQueryVariables | VueCompositionApi.Ref<AdminSearchQueryVariables> | ReactiveFunction<AdminSearchQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminSearchQuery, AdminSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminSearchQuery, AdminSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminSearchQuery, AdminSearchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminSearchQuery, AdminSearchQueryVariables>(AdminSearchDocument, variables, options);
}
export type AdminSearchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminSearchQuery, AdminSearchQueryVariables>;
export const GetArticleStatisticsDocument = gql`
    query GetArticleStatistics($filter: ArticleStatisticsFilter!) {
  articleStatistics(filter: $filter) {
    timeSeries {
      bucketStart
      total
      byKind {
        kind
        count
      }
    }
    byKind {
      kind
      count
    }
    byEditor {
      id
      label
      count
    }
    topGames {
      id
      label
      count
    }
    topTags {
      id
      label
      count
    }
    topGenres {
      id
      label
      count
    }
    pipeline {
      draftCount
      inReviewCount
    }
    avgLeadTimeHours
    comparison {
      total
      byKind {
        kind
        count
      }
    }
  }
}
    `;

/**
 * __useGetArticleStatisticsQuery__
 *
 * To run a query within a Vue component, call `useGetArticleStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetArticleStatisticsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useGetArticleStatisticsQuery(variables: GetArticleStatisticsQueryVariables | VueCompositionApi.Ref<GetArticleStatisticsQueryVariables> | ReactiveFunction<GetArticleStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleStatisticsQuery, GetArticleStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleStatisticsQuery, GetArticleStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleStatisticsQuery, GetArticleStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetArticleStatisticsQuery, GetArticleStatisticsQueryVariables>(GetArticleStatisticsDocument, variables, options);
}
export function useGetArticleStatisticsLazyQuery(variables?: GetArticleStatisticsQueryVariables | VueCompositionApi.Ref<GetArticleStatisticsQueryVariables> | ReactiveFunction<GetArticleStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetArticleStatisticsQuery, GetArticleStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetArticleStatisticsQuery, GetArticleStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetArticleStatisticsQuery, GetArticleStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetArticleStatisticsQuery, GetArticleStatisticsQueryVariables>(GetArticleStatisticsDocument, variables, options);
}
export type GetArticleStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetArticleStatisticsQuery, GetArticleStatisticsQueryVariables>;
export const TriggerScheduleArticleIndexerUpdatesDocument = gql`
    mutation TriggerScheduleArticleIndexerUpdates {
  scheduleArticleIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleArticleIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleArticleIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleArticleIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleArticleIndexerUpdatesMutation();
 */
export function useTriggerScheduleArticleIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleArticleIndexerUpdatesMutation, TriggerScheduleArticleIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleArticleIndexerUpdatesMutation, TriggerScheduleArticleIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleArticleIndexerUpdatesMutation, TriggerScheduleArticleIndexerUpdatesMutationVariables>(TriggerScheduleArticleIndexerUpdatesDocument, options);
}
export type TriggerScheduleArticleIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleArticleIndexerUpdatesMutation, TriggerScheduleArticleIndexerUpdatesMutationVariables>;
export const TriggerScheduleArticleReindexingDocument = gql`
    mutation TriggerScheduleArticleReindexing {
  scheduleArticleReindexing
}
    `;

/**
 * __useTriggerScheduleArticleReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleArticleReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleArticleReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleArticleReindexingMutation();
 */
export function useTriggerScheduleArticleReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleArticleReindexingMutation, TriggerScheduleArticleReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleArticleReindexingMutation, TriggerScheduleArticleReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleArticleReindexingMutation, TriggerScheduleArticleReindexingMutationVariables>(TriggerScheduleArticleReindexingDocument, options);
}
export type TriggerScheduleArticleReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleArticleReindexingMutation, TriggerScheduleArticleReindexingMutationVariables>;
export const TriggerScheduleArticleSeriesIndexerUpdatesDocument = gql`
    mutation TriggerScheduleArticleSeriesIndexerUpdates {
  scheduleArticleSeriesIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleArticleSeriesIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleArticleSeriesIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleArticleSeriesIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleArticleSeriesIndexerUpdatesMutation();
 */
export function useTriggerScheduleArticleSeriesIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleArticleSeriesIndexerUpdatesMutation, TriggerScheduleArticleSeriesIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleArticleSeriesIndexerUpdatesMutation, TriggerScheduleArticleSeriesIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleArticleSeriesIndexerUpdatesMutation, TriggerScheduleArticleSeriesIndexerUpdatesMutationVariables>(TriggerScheduleArticleSeriesIndexerUpdatesDocument, options);
}
export type TriggerScheduleArticleSeriesIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleArticleSeriesIndexerUpdatesMutation, TriggerScheduleArticleSeriesIndexerUpdatesMutationVariables>;
export const TriggerScheduleArticleSeriesReindexingDocument = gql`
    mutation TriggerScheduleArticleSeriesReindexing {
  scheduleArticleSeriesReindexing
}
    `;

/**
 * __useTriggerScheduleArticleSeriesReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleArticleSeriesReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleArticleSeriesReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleArticleSeriesReindexingMutation();
 */
export function useTriggerScheduleArticleSeriesReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleArticleSeriesReindexingMutation, TriggerScheduleArticleSeriesReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleArticleSeriesReindexingMutation, TriggerScheduleArticleSeriesReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleArticleSeriesReindexingMutation, TriggerScheduleArticleSeriesReindexingMutationVariables>(TriggerScheduleArticleSeriesReindexingDocument, options);
}
export type TriggerScheduleArticleSeriesReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleArticleSeriesReindexingMutation, TriggerScheduleArticleSeriesReindexingMutationVariables>;
export const TriggerScheduleEventIndexerUpdatesDocument = gql`
    mutation TriggerScheduleEventIndexerUpdates {
  scheduleEventIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleEventIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleEventIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleEventIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleEventIndexerUpdatesMutation();
 */
export function useTriggerScheduleEventIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleEventIndexerUpdatesMutation, TriggerScheduleEventIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleEventIndexerUpdatesMutation, TriggerScheduleEventIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleEventIndexerUpdatesMutation, TriggerScheduleEventIndexerUpdatesMutationVariables>(TriggerScheduleEventIndexerUpdatesDocument, options);
}
export type TriggerScheduleEventIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleEventIndexerUpdatesMutation, TriggerScheduleEventIndexerUpdatesMutationVariables>;
export const TriggerScheduleEventReindexingDocument = gql`
    mutation TriggerScheduleEventReindexing {
  scheduleEventReindexing
}
    `;

/**
 * __useTriggerScheduleEventReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleEventReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleEventReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleEventReindexingMutation();
 */
export function useTriggerScheduleEventReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleEventReindexingMutation, TriggerScheduleEventReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleEventReindexingMutation, TriggerScheduleEventReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleEventReindexingMutation, TriggerScheduleEventReindexingMutationVariables>(TriggerScheduleEventReindexingDocument, options);
}
export type TriggerScheduleEventReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleEventReindexingMutation, TriggerScheduleEventReindexingMutationVariables>;
export const TriggerScheduleCompanyIndexerUpdatesDocument = gql`
    mutation TriggerScheduleCompanyIndexerUpdates {
  scheduleCompanyIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleCompanyIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleCompanyIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleCompanyIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleCompanyIndexerUpdatesMutation();
 */
export function useTriggerScheduleCompanyIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleCompanyIndexerUpdatesMutation, TriggerScheduleCompanyIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleCompanyIndexerUpdatesMutation, TriggerScheduleCompanyIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleCompanyIndexerUpdatesMutation, TriggerScheduleCompanyIndexerUpdatesMutationVariables>(TriggerScheduleCompanyIndexerUpdatesDocument, options);
}
export type TriggerScheduleCompanyIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleCompanyIndexerUpdatesMutation, TriggerScheduleCompanyIndexerUpdatesMutationVariables>;
export const TriggerScheduleCompanyReindexingDocument = gql`
    mutation TriggerScheduleCompanyReindexing {
  scheduleCompanyReindexing
}
    `;

/**
 * __useTriggerScheduleCompanyReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleCompanyReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleCompanyReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleCompanyReindexingMutation();
 */
export function useTriggerScheduleCompanyReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleCompanyReindexingMutation, TriggerScheduleCompanyReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleCompanyReindexingMutation, TriggerScheduleCompanyReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleCompanyReindexingMutation, TriggerScheduleCompanyReindexingMutationVariables>(TriggerScheduleCompanyReindexingDocument, options);
}
export type TriggerScheduleCompanyReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleCompanyReindexingMutation, TriggerScheduleCompanyReindexingMutationVariables>;
export const TriggerScheduleGameConsoleIndexerUpdatesDocument = gql`
    mutation TriggerScheduleGameConsoleIndexerUpdates {
  scheduleGameConsoleIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleGameConsoleIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleGameConsoleIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleGameConsoleIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleGameConsoleIndexerUpdatesMutation();
 */
export function useTriggerScheduleGameConsoleIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleGameConsoleIndexerUpdatesMutation, TriggerScheduleGameConsoleIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleGameConsoleIndexerUpdatesMutation, TriggerScheduleGameConsoleIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleGameConsoleIndexerUpdatesMutation, TriggerScheduleGameConsoleIndexerUpdatesMutationVariables>(TriggerScheduleGameConsoleIndexerUpdatesDocument, options);
}
export type TriggerScheduleGameConsoleIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleGameConsoleIndexerUpdatesMutation, TriggerScheduleGameConsoleIndexerUpdatesMutationVariables>;
export const TriggerScheduleGameConsoleReindexingDocument = gql`
    mutation TriggerScheduleGameConsoleReindexing {
  scheduleGameConsoleReindexing
}
    `;

/**
 * __useTriggerScheduleGameConsoleReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleGameConsoleReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleGameConsoleReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleGameConsoleReindexingMutation();
 */
export function useTriggerScheduleGameConsoleReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleGameConsoleReindexingMutation, TriggerScheduleGameConsoleReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleGameConsoleReindexingMutation, TriggerScheduleGameConsoleReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleGameConsoleReindexingMutation, TriggerScheduleGameConsoleReindexingMutationVariables>(TriggerScheduleGameConsoleReindexingDocument, options);
}
export type TriggerScheduleGameConsoleReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleGameConsoleReindexingMutation, TriggerScheduleGameConsoleReindexingMutationVariables>;
export const TriggerScheduleGameIndexerUpdatesDocument = gql`
    mutation TriggerScheduleGameIndexerUpdates {
  scheduleGameIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleGameIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleGameIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleGameIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleGameIndexerUpdatesMutation();
 */
export function useTriggerScheduleGameIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleGameIndexerUpdatesMutation, TriggerScheduleGameIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleGameIndexerUpdatesMutation, TriggerScheduleGameIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleGameIndexerUpdatesMutation, TriggerScheduleGameIndexerUpdatesMutationVariables>(TriggerScheduleGameIndexerUpdatesDocument, options);
}
export type TriggerScheduleGameIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleGameIndexerUpdatesMutation, TriggerScheduleGameIndexerUpdatesMutationVariables>;
export const TriggerScheduleGameReindexingDocument = gql`
    mutation TriggerScheduleGameReindexing {
  scheduleGameReindexing
}
    `;

/**
 * __useTriggerScheduleGameReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleGameReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleGameReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleGameReindexingMutation();
 */
export function useTriggerScheduleGameReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleGameReindexingMutation, TriggerScheduleGameReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleGameReindexingMutation, TriggerScheduleGameReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleGameReindexingMutation, TriggerScheduleGameReindexingMutationVariables>(TriggerScheduleGameReindexingDocument, options);
}
export type TriggerScheduleGameReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleGameReindexingMutation, TriggerScheduleGameReindexingMutationVariables>;
export const TriggerScheduleGameSeriesIndexerUpdatesDocument = gql`
    mutation TriggerScheduleGameSeriesIndexerUpdates {
  scheduleGameSeriesIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleGameSeriesIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleGameSeriesIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleGameSeriesIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleGameSeriesIndexerUpdatesMutation();
 */
export function useTriggerScheduleGameSeriesIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleGameSeriesIndexerUpdatesMutation, TriggerScheduleGameSeriesIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleGameSeriesIndexerUpdatesMutation, TriggerScheduleGameSeriesIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleGameSeriesIndexerUpdatesMutation, TriggerScheduleGameSeriesIndexerUpdatesMutationVariables>(TriggerScheduleGameSeriesIndexerUpdatesDocument, options);
}
export type TriggerScheduleGameSeriesIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleGameSeriesIndexerUpdatesMutation, TriggerScheduleGameSeriesIndexerUpdatesMutationVariables>;
export const TriggerScheduleGameSeriesReindexingDocument = gql`
    mutation TriggerScheduleGameSeriesReindexing {
  scheduleGameSeriesReindexing
}
    `;

/**
 * __useTriggerScheduleGameSeriesReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleGameSeriesReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleGameSeriesReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleGameSeriesReindexingMutation();
 */
export function useTriggerScheduleGameSeriesReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleGameSeriesReindexingMutation, TriggerScheduleGameSeriesReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleGameSeriesReindexingMutation, TriggerScheduleGameSeriesReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleGameSeriesReindexingMutation, TriggerScheduleGameSeriesReindexingMutationVariables>(TriggerScheduleGameSeriesReindexingDocument, options);
}
export type TriggerScheduleGameSeriesReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleGameSeriesReindexingMutation, TriggerScheduleGameSeriesReindexingMutationVariables>;
export const TriggerScheduleGenreIndexerUpdatesDocument = gql`
    mutation TriggerScheduleGenreIndexerUpdates {
  scheduleGenreIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleGenreIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleGenreIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleGenreIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleGenreIndexerUpdatesMutation();
 */
export function useTriggerScheduleGenreIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleGenreIndexerUpdatesMutation, TriggerScheduleGenreIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleGenreIndexerUpdatesMutation, TriggerScheduleGenreIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleGenreIndexerUpdatesMutation, TriggerScheduleGenreIndexerUpdatesMutationVariables>(TriggerScheduleGenreIndexerUpdatesDocument, options);
}
export type TriggerScheduleGenreIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleGenreIndexerUpdatesMutation, TriggerScheduleGenreIndexerUpdatesMutationVariables>;
export const TriggerScheduleGenreReindexingDocument = gql`
    mutation TriggerScheduleGenreReindexing {
  scheduleGenreReindexing
}
    `;

/**
 * __useTriggerScheduleGenreReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleGenreReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleGenreReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleGenreReindexingMutation();
 */
export function useTriggerScheduleGenreReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleGenreReindexingMutation, TriggerScheduleGenreReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleGenreReindexingMutation, TriggerScheduleGenreReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleGenreReindexingMutation, TriggerScheduleGenreReindexingMutationVariables>(TriggerScheduleGenreReindexingDocument, options);
}
export type TriggerScheduleGenreReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleGenreReindexingMutation, TriggerScheduleGenreReindexingMutationVariables>;
export const TriggerScheduleMediaIndexerUpdatesDocument = gql`
    mutation TriggerScheduleMediaIndexerUpdates {
  scheduleMediaIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleMediaIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleMediaIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleMediaIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleMediaIndexerUpdatesMutation();
 */
export function useTriggerScheduleMediaIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleMediaIndexerUpdatesMutation, TriggerScheduleMediaIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleMediaIndexerUpdatesMutation, TriggerScheduleMediaIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleMediaIndexerUpdatesMutation, TriggerScheduleMediaIndexerUpdatesMutationVariables>(TriggerScheduleMediaIndexerUpdatesDocument, options);
}
export type TriggerScheduleMediaIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleMediaIndexerUpdatesMutation, TriggerScheduleMediaIndexerUpdatesMutationVariables>;
export const TriggerScheduleMediaReindexingDocument = gql`
    mutation TriggerScheduleMediaReindexing {
  scheduleMediaReindexing
}
    `;

/**
 * __useTriggerScheduleMediaReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleMediaReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleMediaReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleMediaReindexingMutation();
 */
export function useTriggerScheduleMediaReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleMediaReindexingMutation, TriggerScheduleMediaReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleMediaReindexingMutation, TriggerScheduleMediaReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleMediaReindexingMutation, TriggerScheduleMediaReindexingMutationVariables>(TriggerScheduleMediaReindexingDocument, options);
}
export type TriggerScheduleMediaReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleMediaReindexingMutation, TriggerScheduleMediaReindexingMutationVariables>;
export const TriggerScheduleRatingCategoryIndexerUpdatesDocument = gql`
    mutation TriggerScheduleRatingCategoryIndexerUpdates {
  scheduleRatingCategoryIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleRatingCategoryIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleRatingCategoryIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleRatingCategoryIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleRatingCategoryIndexerUpdatesMutation();
 */
export function useTriggerScheduleRatingCategoryIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleRatingCategoryIndexerUpdatesMutation, TriggerScheduleRatingCategoryIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleRatingCategoryIndexerUpdatesMutation, TriggerScheduleRatingCategoryIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleRatingCategoryIndexerUpdatesMutation, TriggerScheduleRatingCategoryIndexerUpdatesMutationVariables>(TriggerScheduleRatingCategoryIndexerUpdatesDocument, options);
}
export type TriggerScheduleRatingCategoryIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleRatingCategoryIndexerUpdatesMutation, TriggerScheduleRatingCategoryIndexerUpdatesMutationVariables>;
export const TriggerScheduleRatingCategoryReindexingDocument = gql`
    mutation TriggerScheduleRatingCategoryReindexing {
  scheduleRatingCategoryReindexing
}
    `;

/**
 * __useTriggerScheduleRatingCategoryReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleRatingCategoryReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleRatingCategoryReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleRatingCategoryReindexingMutation();
 */
export function useTriggerScheduleRatingCategoryReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleRatingCategoryReindexingMutation, TriggerScheduleRatingCategoryReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleRatingCategoryReindexingMutation, TriggerScheduleRatingCategoryReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleRatingCategoryReindexingMutation, TriggerScheduleRatingCategoryReindexingMutationVariables>(TriggerScheduleRatingCategoryReindexingDocument, options);
}
export type TriggerScheduleRatingCategoryReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleRatingCategoryReindexingMutation, TriggerScheduleRatingCategoryReindexingMutationVariables>;
export const TriggerScheduleTagIndexerUpdatesDocument = gql`
    mutation TriggerScheduleTagIndexerUpdates {
  scheduleTagIndexing {
    ...ScheduleResult
  }
}
    ${ScheduleResultFragmentDoc}`;

/**
 * __useTriggerScheduleTagIndexerUpdatesMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleTagIndexerUpdatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleTagIndexerUpdatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleTagIndexerUpdatesMutation();
 */
export function useTriggerScheduleTagIndexerUpdatesMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleTagIndexerUpdatesMutation, TriggerScheduleTagIndexerUpdatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleTagIndexerUpdatesMutation, TriggerScheduleTagIndexerUpdatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleTagIndexerUpdatesMutation, TriggerScheduleTagIndexerUpdatesMutationVariables>(TriggerScheduleTagIndexerUpdatesDocument, options);
}
export type TriggerScheduleTagIndexerUpdatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleTagIndexerUpdatesMutation, TriggerScheduleTagIndexerUpdatesMutationVariables>;
export const TriggerScheduleTagReindexingDocument = gql`
    mutation TriggerScheduleTagReindexing {
  scheduleTagReindexing
}
    `;

/**
 * __useTriggerScheduleTagReindexingMutation__
 *
 * To run a mutation, you first call `useTriggerScheduleTagReindexingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerScheduleTagReindexingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerScheduleTagReindexingMutation();
 */
export function useTriggerScheduleTagReindexingMutation(options: VueApolloComposable.UseMutationOptions<TriggerScheduleTagReindexingMutation, TriggerScheduleTagReindexingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TriggerScheduleTagReindexingMutation, TriggerScheduleTagReindexingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TriggerScheduleTagReindexingMutation, TriggerScheduleTagReindexingMutationVariables>(TriggerScheduleTagReindexingDocument, options);
}
export type TriggerScheduleTagReindexingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TriggerScheduleTagReindexingMutation, TriggerScheduleTagReindexingMutationVariables>;
export const SubscribeToArticleIndexerStatusDocument = gql`
    subscription SubscribeToArticleIndexerStatus {
  articleIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToArticleIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToArticleIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToArticleIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToArticleIndexerStatusSubscription();
 */
export function useSubscribeToArticleIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToArticleIndexerStatusSubscription, SubscribeToArticleIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToArticleIndexerStatusSubscription, SubscribeToArticleIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToArticleIndexerStatusSubscription, SubscribeToArticleIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToArticleIndexerStatusSubscription, SubscribeToArticleIndexerStatusSubscriptionVariables>(SubscribeToArticleIndexerStatusDocument, {}, options);
}
export type SubscribeToArticleIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToArticleIndexerStatusSubscription, SubscribeToArticleIndexerStatusSubscriptionVariables>;
export const SubscribeToArticleSeriesIndexerStatusDocument = gql`
    subscription SubscribeToArticleSeriesIndexerStatus {
  articleSeriesIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToArticleSeriesIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToArticleSeriesIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToArticleSeriesIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToArticleSeriesIndexerStatusSubscription();
 */
export function useSubscribeToArticleSeriesIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToArticleSeriesIndexerStatusSubscription, SubscribeToArticleSeriesIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToArticleSeriesIndexerStatusSubscription, SubscribeToArticleSeriesIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToArticleSeriesIndexerStatusSubscription, SubscribeToArticleSeriesIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToArticleSeriesIndexerStatusSubscription, SubscribeToArticleSeriesIndexerStatusSubscriptionVariables>(SubscribeToArticleSeriesIndexerStatusDocument, {}, options);
}
export type SubscribeToArticleSeriesIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToArticleSeriesIndexerStatusSubscription, SubscribeToArticleSeriesIndexerStatusSubscriptionVariables>;
export const SubscribeToEventIndexerStatusDocument = gql`
    subscription SubscribeToEventIndexerStatus {
  eventIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToEventIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToEventIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToEventIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToEventIndexerStatusSubscription();
 */
export function useSubscribeToEventIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToEventIndexerStatusSubscription, SubscribeToEventIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToEventIndexerStatusSubscription, SubscribeToEventIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToEventIndexerStatusSubscription, SubscribeToEventIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToEventIndexerStatusSubscription, SubscribeToEventIndexerStatusSubscriptionVariables>(SubscribeToEventIndexerStatusDocument, {}, options);
}
export type SubscribeToEventIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToEventIndexerStatusSubscription, SubscribeToEventIndexerStatusSubscriptionVariables>;
export const SubscribeToCompanyIndexerStatusDocument = gql`
    subscription SubscribeToCompanyIndexerStatus {
  companyIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToCompanyIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToCompanyIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToCompanyIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToCompanyIndexerStatusSubscription();
 */
export function useSubscribeToCompanyIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToCompanyIndexerStatusSubscription, SubscribeToCompanyIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToCompanyIndexerStatusSubscription, SubscribeToCompanyIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToCompanyIndexerStatusSubscription, SubscribeToCompanyIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToCompanyIndexerStatusSubscription, SubscribeToCompanyIndexerStatusSubscriptionVariables>(SubscribeToCompanyIndexerStatusDocument, {}, options);
}
export type SubscribeToCompanyIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToCompanyIndexerStatusSubscription, SubscribeToCompanyIndexerStatusSubscriptionVariables>;
export const SubscribeToGameConsoleIndexerStatusDocument = gql`
    subscription SubscribeToGameConsoleIndexerStatus {
  gameConsoleIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToGameConsoleIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToGameConsoleIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToGameConsoleIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToGameConsoleIndexerStatusSubscription();
 */
export function useSubscribeToGameConsoleIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToGameConsoleIndexerStatusSubscription, SubscribeToGameConsoleIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToGameConsoleIndexerStatusSubscription, SubscribeToGameConsoleIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToGameConsoleIndexerStatusSubscription, SubscribeToGameConsoleIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToGameConsoleIndexerStatusSubscription, SubscribeToGameConsoleIndexerStatusSubscriptionVariables>(SubscribeToGameConsoleIndexerStatusDocument, {}, options);
}
export type SubscribeToGameConsoleIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToGameConsoleIndexerStatusSubscription, SubscribeToGameConsoleIndexerStatusSubscriptionVariables>;
export const SubscribeToGameIndexerStatusDocument = gql`
    subscription SubscribeToGameIndexerStatus {
  gameIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToGameIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToGameIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToGameIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToGameIndexerStatusSubscription();
 */
export function useSubscribeToGameIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToGameIndexerStatusSubscription, SubscribeToGameIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToGameIndexerStatusSubscription, SubscribeToGameIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToGameIndexerStatusSubscription, SubscribeToGameIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToGameIndexerStatusSubscription, SubscribeToGameIndexerStatusSubscriptionVariables>(SubscribeToGameIndexerStatusDocument, {}, options);
}
export type SubscribeToGameIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToGameIndexerStatusSubscription, SubscribeToGameIndexerStatusSubscriptionVariables>;
export const SubscribeToGameSeriesIndexerStatusDocument = gql`
    subscription SubscribeToGameSeriesIndexerStatus {
  gameSeriesIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToGameSeriesIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToGameSeriesIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToGameSeriesIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToGameSeriesIndexerStatusSubscription();
 */
export function useSubscribeToGameSeriesIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToGameSeriesIndexerStatusSubscription, SubscribeToGameSeriesIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToGameSeriesIndexerStatusSubscription, SubscribeToGameSeriesIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToGameSeriesIndexerStatusSubscription, SubscribeToGameSeriesIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToGameSeriesIndexerStatusSubscription, SubscribeToGameSeriesIndexerStatusSubscriptionVariables>(SubscribeToGameSeriesIndexerStatusDocument, {}, options);
}
export type SubscribeToGameSeriesIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToGameSeriesIndexerStatusSubscription, SubscribeToGameSeriesIndexerStatusSubscriptionVariables>;
export const SubscribeToGenreIndexerStatusDocument = gql`
    subscription SubscribeToGenreIndexerStatus {
  genreIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToGenreIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToGenreIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToGenreIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToGenreIndexerStatusSubscription();
 */
export function useSubscribeToGenreIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToGenreIndexerStatusSubscription, SubscribeToGenreIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToGenreIndexerStatusSubscription, SubscribeToGenreIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToGenreIndexerStatusSubscription, SubscribeToGenreIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToGenreIndexerStatusSubscription, SubscribeToGenreIndexerStatusSubscriptionVariables>(SubscribeToGenreIndexerStatusDocument, {}, options);
}
export type SubscribeToGenreIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToGenreIndexerStatusSubscription, SubscribeToGenreIndexerStatusSubscriptionVariables>;
export const SubscribeToMediaIndexerStatusDocument = gql`
    subscription SubscribeToMediaIndexerStatus {
  mediaIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToMediaIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToMediaIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToMediaIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToMediaIndexerStatusSubscription();
 */
export function useSubscribeToMediaIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToMediaIndexerStatusSubscription, SubscribeToMediaIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToMediaIndexerStatusSubscription, SubscribeToMediaIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToMediaIndexerStatusSubscription, SubscribeToMediaIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToMediaIndexerStatusSubscription, SubscribeToMediaIndexerStatusSubscriptionVariables>(SubscribeToMediaIndexerStatusDocument, {}, options);
}
export type SubscribeToMediaIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToMediaIndexerStatusSubscription, SubscribeToMediaIndexerStatusSubscriptionVariables>;
export const SubscribeToRatingCategoryIndexerStatusDocument = gql`
    subscription SubscribeToRatingCategoryIndexerStatus {
  ratingCategoryIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToRatingCategoryIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToRatingCategoryIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToRatingCategoryIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToRatingCategoryIndexerStatusSubscription();
 */
export function useSubscribeToRatingCategoryIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToRatingCategoryIndexerStatusSubscription, SubscribeToRatingCategoryIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToRatingCategoryIndexerStatusSubscription, SubscribeToRatingCategoryIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToRatingCategoryIndexerStatusSubscription, SubscribeToRatingCategoryIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToRatingCategoryIndexerStatusSubscription, SubscribeToRatingCategoryIndexerStatusSubscriptionVariables>(SubscribeToRatingCategoryIndexerStatusDocument, {}, options);
}
export type SubscribeToRatingCategoryIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToRatingCategoryIndexerStatusSubscription, SubscribeToRatingCategoryIndexerStatusSubscriptionVariables>;
export const SubscribeToTagIndexerStatusDocument = gql`
    subscription SubscribeToTagIndexerStatus {
  tagIndexerStatus {
    ...IndexerStatus
  }
}
    ${IndexerStatusFragmentDoc}`;

/**
 * __useSubscribeToTagIndexerStatusSubscription__
 *
 * To run a query within a Vue component, call `useSubscribeToTagIndexerStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTagIndexerStatusSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useSubscribeToTagIndexerStatusSubscription();
 */
export function useSubscribeToTagIndexerStatusSubscription(options: VueApolloComposable.UseSubscriptionOptions<SubscribeToTagIndexerStatusSubscription, SubscribeToTagIndexerStatusSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<SubscribeToTagIndexerStatusSubscription, SubscribeToTagIndexerStatusSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<SubscribeToTagIndexerStatusSubscription, SubscribeToTagIndexerStatusSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<SubscribeToTagIndexerStatusSubscription, SubscribeToTagIndexerStatusSubscriptionVariables>(SubscribeToTagIndexerStatusDocument, {}, options);
}
export type SubscribeToTagIndexerStatusSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<SubscribeToTagIndexerStatusSubscription, SubscribeToTagIndexerStatusSubscriptionVariables>;
export const GetTagDocument = gql`
    query GetTag($id: UUID!) {
  tag(id: $id) {
    ...TagDetails
  }
}
    ${TagDetailsFragmentDoc}`;

/**
 * __useGetTagQuery__
 *
 * To run a query within a Vue component, call `useGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTagQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetTagQuery(variables: GetTagQueryVariables | VueCompositionApi.Ref<GetTagQueryVariables> | ReactiveFunction<GetTagQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTagQuery, GetTagQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTagQuery, GetTagQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTagQuery, GetTagQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, variables, options);
}
export function useGetTagLazyQuery(variables?: GetTagQueryVariables | VueCompositionApi.Ref<GetTagQueryVariables> | ReactiveFunction<GetTagQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTagQuery, GetTagQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTagQuery, GetTagQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTagQuery, GetTagQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, variables, options);
}
export type GetTagQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTagQuery, GetTagQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags($page: Int!, $limit: Int!) {
  allTags(page: $page, limit: $limit) {
    ...TagPageResults
  }
}
    ${TagPageResultsFragmentDoc}`;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a Vue component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTagsQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useGetTagsQuery(variables: GetTagsQueryVariables | VueCompositionApi.Ref<GetTagsQueryVariables> | ReactiveFunction<GetTagsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTagsQuery, GetTagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTagsQuery, GetTagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTagsQuery, GetTagsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, variables, options);
}
export function useGetTagsLazyQuery(variables?: GetTagsQueryVariables | VueCompositionApi.Ref<GetTagsQueryVariables> | ReactiveFunction<GetTagsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTagsQuery, GetTagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTagsQuery, GetTagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTagsQuery, GetTagsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, variables, options);
}
export type GetTagsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTagsQuery, GetTagsQueryVariables>;
export const FindTagsDocument = gql`
    query FindTags($query: String, $ids: [UUID!], $examples: [TagExampleInput!], $page: Int!, $limit: Int!) {
  findTags(
    query: $query
    ids: $ids
    examples: $examples
    page: $page
    limit: $limit
  ) {
    ...TagPageResults
  }
}
    ${TagPageResultsFragmentDoc}`;

/**
 * __useFindTagsQuery__
 *
 * To run a query within a Vue component, call `useFindTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindTagsQuery({
 *   query: // value for 'query'
 *   ids: // value for 'ids'
 *   examples: // value for 'examples'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindTagsQuery(variables: FindTagsQueryVariables | VueCompositionApi.Ref<FindTagsQueryVariables> | ReactiveFunction<FindTagsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindTagsQuery, FindTagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindTagsQuery, FindTagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindTagsQuery, FindTagsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindTagsQuery, FindTagsQueryVariables>(FindTagsDocument, variables, options);
}
export function useFindTagsLazyQuery(variables?: FindTagsQueryVariables | VueCompositionApi.Ref<FindTagsQueryVariables> | ReactiveFunction<FindTagsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindTagsQuery, FindTagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindTagsQuery, FindTagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindTagsQuery, FindTagsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindTagsQuery, FindTagsQueryVariables>(FindTagsDocument, variables, options);
}
export type FindTagsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindTagsQuery, FindTagsQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($create: TagCreateInput!) {
  createTag(create: $create) {
    ...TagDetails
  }
}
    ${TagDetailsFragmentDoc}`;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTagMutation({
 *   variables: {
 *     create: // value for 'create'
 *   },
 * });
 */
export function useCreateTagMutation(options: VueApolloComposable.UseMutationOptions<CreateTagMutation, CreateTagMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateTagMutation, CreateTagMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
}
export type CreateTagMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($id: UUID!, $update: TagUpdateInput!, $expectedVersion: Int) {
  updateTag(id: $id, update: $update, expectedVersion: $expectedVersion) {
    ...TagDetails
  }
}
    ${TagDetailsFragmentDoc}`;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTagMutation({
 *   variables: {
 *     id: // value for 'id'
 *     update: // value for 'update'
 *     expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useUpdateTagMutation(options: VueApolloComposable.UseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
}
export type UpdateTagMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: UUID!) {
  deleteTag(id: $id) {
    ...TagListItem
  }
}
    ${TagListItemFragmentDoc}`;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTagMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(options: VueApolloComposable.UseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
}
export type DeleteTagMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteTagMutation, DeleteTagMutationVariables>;
export const PrepareUploadDocument = gql`
    mutation PrepareUpload($input: PrepareUploadInput!) {
  prepareUpload(upload: $input) {
    ...UploadUuidAndPartNumberWithUploadUrl
  }
}
    ${UploadUuidAndPartNumberWithUploadUrlFragmentDoc}`;

/**
 * __usePrepareUploadMutation__
 *
 * To run a mutation, you first call `usePrepareUploadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePrepareUploadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePrepareUploadMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePrepareUploadMutation(options: VueApolloComposable.UseMutationOptions<PrepareUploadMutation, PrepareUploadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PrepareUploadMutation, PrepareUploadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PrepareUploadMutation, PrepareUploadMutationVariables>(PrepareUploadDocument, options);
}
export type PrepareUploadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PrepareUploadMutation, PrepareUploadMutationVariables>;
export const ImportMediaDocument = gql`
    mutation ImportMedia($url: String!, $games: [UUID!], $gameSeries: [UUID!], $gameConsoles: [UUID!], $companies: [UUID!], $tags: [UUID!]) {
  importMedia(
    uri: $url
    games: $games
    gameSeries: $gameSeries
    gameConsoles: $gameConsoles
    companies: $companies
    tags: $tags
  ) {
    ...MediaListItem
  }
}
    ${MediaListItemFragmentDoc}`;

/**
 * __useImportMediaMutation__
 *
 * To run a mutation, you first call `useImportMediaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportMediaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportMediaMutation({
 *   variables: {
 *     url: // value for 'url'
 *     games: // value for 'games'
 *     gameSeries: // value for 'gameSeries'
 *     gameConsoles: // value for 'gameConsoles'
 *     companies: // value for 'companies'
 *     tags: // value for 'tags'
 *   },
 * });
 */
export function useImportMediaMutation(options: VueApolloComposable.UseMutationOptions<ImportMediaMutation, ImportMediaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ImportMediaMutation, ImportMediaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ImportMediaMutation, ImportMediaMutationVariables>(ImportMediaDocument, options);
}
export type ImportMediaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ImportMediaMutation, ImportMediaMutationVariables>;
export const FindUsersDocument = gql`
    query findUsers($page: Int!, $limit: Int!, $order: [String!], $query: String, $examples: [UserExampleInput!]) {
  findUsers(
    page: $page
    limit: $limit
    order: $order
    query: $query
    examples: $examples
  ) {
    page
    limit
    total
    totalPages
    results {
      ...UserListItem
    }
  }
}
    ${UserListItemFragmentDoc}`;

/**
 * __useFindUsersQuery__
 *
 * To run a query within a Vue component, call `useFindUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindUsersQuery({
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 *   order: // value for 'order'
 *   query: // value for 'query'
 *   examples: // value for 'examples'
 * });
 */
export function useFindUsersQuery(variables: FindUsersQueryVariables | VueCompositionApi.Ref<FindUsersQueryVariables> | ReactiveFunction<FindUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindUsersQuery, FindUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindUsersQuery, FindUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindUsersQuery, FindUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, variables, options);
}
export function useFindUsersLazyQuery(variables?: FindUsersQueryVariables | VueCompositionApi.Ref<FindUsersQueryVariables> | ReactiveFunction<FindUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindUsersQuery, FindUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindUsersQuery, FindUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindUsersQuery, FindUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, variables, options);
}
export type FindUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindUsersQuery, FindUsersQueryVariables>;
export const UserDocument = gql`
    query user($sub: ID!) {
  user(sub: $sub) {
    ...UserDetail
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a Vue component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserQuery({
 *   sub: // value for 'sub'
 * });
 */
export function useUserQuery(variables: UserQueryVariables | VueCompositionApi.Ref<UserQueryVariables> | ReactiveFunction<UserQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserQuery, UserQueryVariables>(UserDocument, variables, options);
}
export function useUserLazyQuery(variables?: UserQueryVariables | VueCompositionApi.Ref<UserQueryVariables> | ReactiveFunction<UserQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, variables, options);
}
export type UserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserQuery, UserQueryVariables>;
export const SetUserRolesDocument = gql`
    mutation setUserRoles($sub: ID!, $roles: [Role!]!) {
  setUserRoles(sub: $sub, roles: $roles) {
    ...UserDetail
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useSetUserRolesMutation__
 *
 * To run a mutation, you first call `useSetUserRolesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetUserRolesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetUserRolesMutation({
 *   variables: {
 *     sub: // value for 'sub'
 *     roles: // value for 'roles'
 *   },
 * });
 */
export function useSetUserRolesMutation(options: VueApolloComposable.UseMutationOptions<SetUserRolesMutation, SetUserRolesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetUserRolesMutation, SetUserRolesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetUserRolesMutation, SetUserRolesMutationVariables>(SetUserRolesDocument, options);
}
export type SetUserRolesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetUserRolesMutation, SetUserRolesMutationVariables>;
export const FindYouTubeVideosDocument = gql`
    query FindYouTubeVideos($query: String, $available: Boolean, $order: [String!], $page: Int!, $limit: Int!) {
  findYouTubeVideos(
    query: $query
    available: $available
    order: $order
    page: $page
    limit: $limit
  ) {
    content {
      ...YouTubeVideoListItem
    }
    totalElements
    totalPages
    hasPrevious
    hasNext
  }
}
    ${YouTubeVideoListItemFragmentDoc}`;

/**
 * __useFindYouTubeVideosQuery__
 *
 * To run a query within a Vue component, call `useFindYouTubeVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindYouTubeVideosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindYouTubeVideosQuery({
 *   query: // value for 'query'
 *   available: // value for 'available'
 *   order: // value for 'order'
 *   page: // value for 'page'
 *   limit: // value for 'limit'
 * });
 */
export function useFindYouTubeVideosQuery(variables: FindYouTubeVideosQueryVariables | VueCompositionApi.Ref<FindYouTubeVideosQueryVariables> | ReactiveFunction<FindYouTubeVideosQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindYouTubeVideosQuery, FindYouTubeVideosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindYouTubeVideosQuery, FindYouTubeVideosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindYouTubeVideosQuery, FindYouTubeVideosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindYouTubeVideosQuery, FindYouTubeVideosQueryVariables>(FindYouTubeVideosDocument, variables, options);
}
export function useFindYouTubeVideosLazyQuery(variables?: FindYouTubeVideosQueryVariables | VueCompositionApi.Ref<FindYouTubeVideosQueryVariables> | ReactiveFunction<FindYouTubeVideosQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindYouTubeVideosQuery, FindYouTubeVideosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindYouTubeVideosQuery, FindYouTubeVideosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindYouTubeVideosQuery, FindYouTubeVideosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindYouTubeVideosQuery, FindYouTubeVideosQueryVariables>(FindYouTubeVideosDocument, variables, options);
}
export type FindYouTubeVideosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindYouTubeVideosQuery, FindYouTubeVideosQueryVariables>;